export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  DateTime: { input: any; output: any; }
  GeneratingPriority: { input: any; output: any; }
  JsSafeInt: { input: any; output: any; }
  Json: { input: any; output: any; }
  Long: { input: any; output: any; }
};

export type AddUploadedAudioToSourceRes = {
  __typename?: 'AddUploadedAudioToSourceRes';
  sourceVideo: SourceVideo;
  uploads: Array<AudioUploadTarget>;
};

export type Alias = {
  __typename?: 'Alias';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  speaker?: Maybe<Speaker>;
  updatedAt: Scalars['DateTime']['output'];
};

export type ApprovedInvoiceDate = {
  __typename?: 'ApprovedInvoiceDate';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  isApproved: Scalars['Boolean']['output'];
  sessions?: Maybe<Array<Session>>;
  totalTimeSec: Scalars['Int']['output'];
  updatedAt: Scalars['DateTime']['output'];
  user: User;
};


export type ApprovedInvoiceDateSessionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<SessionOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<SessionWhereInput>;
};

export enum ApprovedInvoiceDateOrderByInput {
  CreatedAtAsc = 'createdAt_ASC',
  CreatedAtDesc = 'createdAt_DESC',
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  IsApprovedAsc = 'isApproved_ASC',
  IsApprovedDesc = 'isApproved_DESC',
  TotalTimeSecAsc = 'totalTimeSec_ASC',
  TotalTimeSecDesc = 'totalTimeSec_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC'
}

export type ApprovedInvoiceDateWhereInput = {
  AND?: InputMaybe<Array<ApprovedInvoiceDateWhereInput>>;
  NOT?: InputMaybe<Array<ApprovedInvoiceDateWhereInput>>;
  OR?: InputMaybe<Array<ApprovedInvoiceDateWhereInput>>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_not_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  id_gt?: InputMaybe<Scalars['ID']['input']>;
  id_gte?: InputMaybe<Scalars['ID']['input']>;
  id_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_lt?: InputMaybe<Scalars['ID']['input']>;
  id_lte?: InputMaybe<Scalars['ID']['input']>;
  id_not?: InputMaybe<Scalars['ID']['input']>;
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  id_not_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  isApproved?: InputMaybe<Scalars['Boolean']['input']>;
  isApproved_not?: InputMaybe<Scalars['Boolean']['input']>;
  totalTimeSec?: InputMaybe<Scalars['Int']['input']>;
  totalTimeSec_gt?: InputMaybe<Scalars['Int']['input']>;
  totalTimeSec_gte?: InputMaybe<Scalars['Int']['input']>;
  totalTimeSec_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  totalTimeSec_lt?: InputMaybe<Scalars['Int']['input']>;
  totalTimeSec_lte?: InputMaybe<Scalars['Int']['input']>;
  totalTimeSec_not?: InputMaybe<Scalars['Int']['input']>;
  totalTimeSec_not_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_not_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  user?: InputMaybe<UserWhereInput>;
};

export type ApprovedInvoiceDateWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export enum AssignableRoleForTranslatedVideoEnumType {
  Editor = 'Editor',
  EditorQc = 'EditorQC',
  QAer = 'QAer',
  Qc = 'QC',
  SpeechEditingQAer = 'SpeechEditingQAer',
  TranscriptionQAer = 'TranscriptionQAer',
  TranslationQAer = 'TranslationQAer',
  VoiceActor = 'VoiceActor',
  VoiceActorQc = 'VoiceActorQC'
}

export enum AudioEffect {
  Stretch = 'Stretch'
}

export enum AudioFileSource {
  EffectUnit = 'EffectUnit',
  ManualCompose = 'ManualCompose',
  ThirdPartyTts = 'ThirdPartyTts',
  VocoderOutput = 'VocoderOutput'
}

export type AudioPartInput = {
  /** Original file name, as passed to addUploadedAudioToSource */
  fileName: Scalars['String']['input'];
  /** Zero-based position of this file in the concatenation */
  partIndex: Scalars['Int']['input'];
};

export enum AudioRefinementProvider {
  Auphonic = 'Auphonic',
  NoProvider = 'NoProvider'
}

export type AudioUploadTarget = {
  __typename?: 'AudioUploadTarget';
  fileName: Scalars['String']['output'];
  partIndex: Scalars['Int']['output'];
  presignedS3Policy: Scalars['Json']['output'];
};

export type BatchPayload = {
  __typename?: 'BatchPayload';
  count: Scalars['Long']['output'];
};

export type BulkModelOption = {
  __typename?: 'BulkModelOption';
  /** Segments bulkUpdateSegmentModel would change: their voice supports the model and they use another one. */
  eligibleCount: Scalars['Int']['output'];
  model: Scalars['String']['output'];
};

export type BulkModelOptions = {
  __typename?: 'BulkModelOptions';
  /** Non-archived segments that support at least one model. */
  applicableCount: Scalars['Int']['output'];
  /** Models at least one segment supports. Empty hides the tab. */
  models: Array<BulkModelOption>;
};

export type BulkReplaceInSegmentsResult = {
  __typename?: 'BulkReplaceInSegmentsResult';
  skippedCount: Scalars['Int']['output'];
  updated: Array<ReplacedSegment>;
};

export type CatalogCharacteristic = {
  __typename?: 'CatalogCharacteristic';
  key: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

/** The extensions.code of a Voices catalog error. */
export enum CatalogErrorCode {
  CatalogInvalidControls = 'CATALOG_INVALID_CONTROLS',
  CatalogMimicNotAvailable = 'CATALOG_MIMIC_NOT_AVAILABLE',
  CatalogModelNotAvailable = 'CATALOG_MODEL_NOT_AVAILABLE',
  CatalogModelNotFound = 'CATALOG_MODEL_NOT_FOUND',
  CatalogNoVoice = 'CATALOG_NO_VOICE',
  CatalogUnavailable = 'CATALOG_UNAVAILABLE',
  CatalogVoiceMisconfigured = 'CATALOG_VOICE_MISCONFIGURED',
  CatalogVoiceNotFound = 'CATALOG_VOICE_NOT_FOUND',
  CatalogVoiceNotSelectable = 'CATALOG_VOICE_NOT_SELECTABLE',
  CatalogVoiceRetired = 'CATALOG_VOICE_RETIRED',
  VoiceCatalogOff = 'VOICE_CATALOG_OFF',
  VoiceCatalogOn = 'VOICE_CATALOG_ON'
}

export type CatalogGenerationResult = {
  __typename?: 'CatalogGenerationResult';
  /** How many segments were sent to generation, across the whole video. */
  generatedCount: Scalars['Int']['output'];
  skipped: Array<CatalogSkippedSegment>;
  video: TranslatedVideo;
};

export type CatalogModel = {
  __typename?: 'CatalogModel';
  /** Control definitions keyed by control name. */
  controls?: Maybe<Scalars['Json']['output']>;
  isDefault: Scalars['Boolean']['output'];
  modelKey: Scalars['String']['output'];
  provider: Scalars['String']['output'];
  /** The provider's id for the model, e.g. eleven_v3. */
  providerModelId: Scalars['String']['output'];
  status: CatalogModelStatus;
};

export type CatalogModelOption = {
  __typename?: 'CatalogModelOption';
  /** Segments setSegmentsCatalogModel would change: their voice offers the model and they use another one. */
  eligibleCount: Scalars['Int']['output'];
  model: CatalogModel;
};

export type CatalogModelOptions = {
  __typename?: 'CatalogModelOptions';
  /** Live segments whose catalog voice offers at least one model. */
  applicableCount: Scalars['Int']['output'];
  /** Models at least one segment's voice offers. */
  models: Array<CatalogModelOption>;
};

export enum CatalogModelStatus {
  Active = 'active',
  Deprecated = 'deprecated',
  Retired = 'retired'
}

/** A segment bulk generation skipped: the voice catalog refused it. */
export type CatalogSkippedSegment = {
  __typename?: 'CatalogSkippedSegment';
  code: CatalogErrorCode;
  message: Scalars['String']['output'];
  /** The segment's row number in Studio. */
  number: Scalars['Int']['output'];
  segmentId: Scalars['ID']['output'];
};

export type CatalogVoice = {
  __typename?: 'CatalogVoice';
  canGenerate: Scalars['Boolean']['output'];
  canMimic: Scalars['Boolean']['output'];
  characteristics: Array<CatalogCharacteristic>;
  conversionKind?: Maybe<Scalars['String']['output']>;
  /** The model a new segment starts with in a language. */
  defaultModel?: Maybe<CatalogModel>;
  deprecatedAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  languages: Array<Scalars['String']['output']>;
  /** The models a user may pick for this voice in a language. */
  models?: Maybe<Array<CatalogModel>>;
  name: Scalars['String']['output'];
  provider: Scalars['String']['output'];
  /** The model keys Voices restricts this voice to in a language; empty means every model of the provider. */
  restrictedModels: Array<Scalars['String']['output']>;
  retireAt?: Maybe<Scalars['DateTime']['output']>;
  status: CatalogVoiceStatus;
  variants: Array<Scalars['String']['output']>;
};


export type CatalogVoiceDefaultModelArgs = {
  language: Scalars['String']['input'];
};


export type CatalogVoiceModelsArgs = {
  language: Scalars['String']['input'];
};


export type CatalogVoiceRestrictedModelsArgs = {
  language: Scalars['String']['input'];
};

export enum CatalogVoiceStatus {
  Active = 'active',
  Deprecated = 'deprecated',
  Experimental = 'experimental',
  Retired = 'retired'
}

export type ChannelAudioUploadTargets = {
  __typename?: 'ChannelAudioUploadTargets';
  channelId: Scalars['String']['output'];
  uploads: Array<AudioUploadTarget>;
};

export enum ChannelType {
  Default = 'Default'
}

export type ConfirmUploadedAudioRes = {
  __typename?: 'ConfirmUploadedAudioRes';
  pendingFileNames: Array<Scalars['String']['output']>;
  sourceVideo?: Maybe<SourceVideo>;
};

export type Context = {
  __typename?: 'Context';
  contentType?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  fullSummaryText?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  keyTopics?: Maybe<Scalars['String']['output']>;
  styleToneGenre?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

export type Correction = {
  __typename?: 'Correction';
  applicationLevel?: Maybe<CorrectionApplicationLevel>;
  appliedCorrection?: Maybe<CorrectionAttempt>;
  channel?: Maybe<TranslatedChannel>;
  correctionDrafts?: Maybe<Array<CorrectionDraft>>;
  createdAt: Scalars['DateTime']['output'];
  createdBy?: Maybe<User>;
  doesFinalDraftHaveLanguageFlag?: Maybe<Scalars['Boolean']['output']>;
  finalDraft?: Maybe<CorrectionDraft>;
  id: Scalars['ID']['output'];
  isArchived: Scalars['Boolean']['output'];
  isDatamodelV3: Scalars['Boolean']['output'];
  language: Scalars['String']['output'];
  originalSample?: Maybe<Sample>;
  originalSpeechOutput?: Maybe<SpeechOutput>;
  originalText?: Maybe<Scalars['String']['output']>;
  originalWord: Scalars['String']['output'];
  pronunciationLanguage?: Maybe<Scalars['String']['output']>;
  published?: Maybe<Scalars['Boolean']['output']>;
  segment?: Maybe<Segment>;
  speaker?: Maybe<Scalars['String']['output']>;
  speakers?: Maybe<Array<Speaker>>;
  ttsSourceEnum: TtsSource;
  updatedAt: Scalars['DateTime']['output'];
  video?: Maybe<TranslatedVideo>;
};

export enum CorrectionApplicationLevel {
  AssignedVideos = 'AssignedVideos',
  Channel = 'Channel',
  Character = 'Character',
  Segment = 'Segment',
  Video = 'Video'
}

export type CorrectionAttempt = {
  __typename?: 'CorrectionAttempt';
  charPhones: Array<Scalars['String']['output']>;
  correctedWord: Scalars['String']['output'];
  correction: Correction;
  createdAt: Scalars['DateTime']['output'];
  endTime?: Maybe<Scalars['Float']['output']>;
  id: Scalars['ID']['output'];
  sample?: Maybe<Sample>;
  startTime?: Maybe<Scalars['Float']['output']>;
  state: Scalars['Json']['output'];
  stateValue: CorrectionAttemptState;
  text: Scalars['String']['output'];
};

export enum CorrectionAttemptState {
  Complete = 'Complete',
  GeneratingPhones = 'GeneratingPhones',
  Initial = 'Initial'
}

export type CorrectionConflict = {
  __typename?: 'CorrectionConflict';
  applicationLevel: CorrectionApplicationLevel;
  correctionId: Scalars['ID']['output'];
  willBeArchivedOnOverride: Scalars['Boolean']['output'];
};

export type CorrectionConflicts = {
  __typename?: 'CorrectionConflicts';
  affectedSegmentCount: Scalars['Int']['output'];
  conflicts: Array<CorrectionConflict>;
};

export type CorrectionDraft = {
  __typename?: 'CorrectionDraft';
  correctedWord: Scalars['String']['output'];
  correctedWordEndTime?: Maybe<Scalars['Float']['output']>;
  correctedWordLanguageCode?: Maybe<Scalars['String']['output']>;
  correctedWordStartTime?: Maybe<Scalars['Float']['output']>;
  correction?: Maybe<Correction>;
  createdAt: Scalars['DateTime']['output'];
  hasLanguageFlag: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  isMigratedFromCorrectionAttempt: Scalars['Boolean']['output'];
  /** Has the audio been generated for the correction draft? */
  isReady: Scalars['Boolean']['output'];
  /** Was this draft rendered from the corrected word alone rather than the whole segment? Null for drafts created before the distinction existed. */
  isWordOnly?: Maybe<Scalars['Boolean']['output']>;
  segment?: Maybe<Segment>;
  speechOutput?: Maybe<SpeechOutput>;
  text: Scalars['String']['output'];
  type: CorrectionType;
  updatedAt: Scalars['DateTime']['output'];
};

export type CorrectionDraftWhereInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  id_in?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type CorrectionDraftWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type CorrectionRule = {
  __typename?: 'CorrectionRule';
  applicationLevel?: Maybe<CorrectionApplicationLevel>;
  createdAt: Scalars['DateTime']['output'];
  createdBy?: Maybe<User>;
  hasLanguageFlag: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  overriddenBy?: Maybe<CorrectionApplicationLevel>;
  pronunciation: Scalars['String']['output'];
  pronunciationLanguage?: Maybe<Scalars['String']['output']>;
  segment?: Maybe<Segment>;
  speaker?: Maybe<Speaker>;
  ttsSourceEnum: TtsSource;
  updatedAt: Scalars['DateTime']['output'];
  video?: Maybe<TranslatedVideo>;
  word: Scalars['String']['output'];
};

export type CorrectionRuleList = {
  __typename?: 'CorrectionRuleList';
  rules: Array<CorrectionRule>;
  totalCount: Scalars['Int']['output'];
};

export enum CorrectionType {
  Intonation = 'Intonation',
  Pronunciation = 'Pronunciation',
  Unknown = 'Unknown'
}

export type CorrectionWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type CreatedTranslatedVideo = {
  __typename?: 'CreatedTranslatedVideo';
  channelId: Scalars['ID']['output'];
  tvId: Scalars['ID']['output'];
};

export type Creator = {
  __typename?: 'Creator';
  authId: Scalars['String']['output'];
  authProvider: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type CreatorUpdateOneInput = {
  connect?: InputMaybe<CreatorWhereUniqueInput>;
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CreatorWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type CsvPresignedPolicy = {
  __typename?: 'CsvPresignedPolicy';
  presignedPolicy: Scalars['Json']['output'];
  translatedVideoId: Scalars['ID']['output'];
};

export type Customer = {
  __typename?: 'Customer';
  createdAt: Scalars['DateTime']['output'];
  frameioActionId?: Maybe<Scalars['String']['output']>;
  frameioWorkspaceId?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  sourceChannels: Array<SourceChannel>;
  updatedAt: Scalars['DateTime']['output'];
};

export enum DaysOfWeek {
  Friday = 'Friday',
  Monday = 'Monday',
  Saturday = 'Saturday',
  Sunday = 'Sunday',
  Thursday = 'Thursday',
  Tuesday = 'Tuesday',
  Wednesday = 'Wednesday'
}

export enum DueDateFieldOnTranslatedVideoEnumType {
  DueDate = 'dueDate',
  EditorDueDate = 'editorDueDate',
  EditorQcDueDate = 'editorQCDueDate',
  QcDueDate = 'qcDueDate',
  SpeechEditingQAerDueDate = 'speechEditingQAerDueDate',
  TranscriptionQAerDueDate = 'transcriptionQAerDueDate',
  TranslationQAerDueDate = 'translationQAerDueDate',
  VoiceActorDueDate = 'voiceActorDueDate'
}

export type Edit = {
  __typename?: 'Edit';
  createdAt: Scalars['DateTime']['output'];
  endTime: Scalars['Float']['output'];
  id: Scalars['ID']['output'];
  reason?: Maybe<Scalars['String']['output']>;
  sourceVideo: SourceVideo;
  startTime: Scalars['Float']['output'];
  type: EditType;
  updatedAt: Scalars['DateTime']['output'];
};

export enum EditType {
  ClipOut = 'ClipOut',
  KeepAudio = 'KeepAudio'
}

export type EditWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type EditedAudioGroup = {
  __typename?: 'EditedAudioGroup';
  createdAt: Scalars['DateTime']['output'];
  done?: Maybe<Scalars['Boolean']['output']>;
  editsHash: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  lowVolumeAudioFile?: Maybe<File>;
  mutedAudioFile?: Maybe<File>;
  s3root: Scalars['String']['output'];
  sourceVideo: SourceVideo;
  updatedAt: Scalars['DateTime']['output'];
};

export enum EditedAudioGroupOrderByInput {
  CreatedAtAsc = 'createdAt_ASC',
  CreatedAtDesc = 'createdAt_DESC',
  DoneAsc = 'done_ASC',
  DoneDesc = 'done_DESC',
  EditsHashAsc = 'editsHash_ASC',
  EditsHashDesc = 'editsHash_DESC',
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  S3rootAsc = 's3root_ASC',
  S3rootDesc = 's3root_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC'
}

export type EditedAudioGroupWhereInput = {
  AND?: InputMaybe<Array<EditedAudioGroupWhereInput>>;
  NOT?: InputMaybe<Array<EditedAudioGroupWhereInput>>;
  OR?: InputMaybe<Array<EditedAudioGroupWhereInput>>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_not_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  done?: InputMaybe<Scalars['Boolean']['input']>;
  done_not?: InputMaybe<Scalars['Boolean']['input']>;
  editsHash?: InputMaybe<Scalars['String']['input']>;
  editsHash_contains?: InputMaybe<Scalars['String']['input']>;
  editsHash_ends_with?: InputMaybe<Scalars['String']['input']>;
  editsHash_gt?: InputMaybe<Scalars['String']['input']>;
  editsHash_gte?: InputMaybe<Scalars['String']['input']>;
  editsHash_in?: InputMaybe<Array<Scalars['String']['input']>>;
  editsHash_lt?: InputMaybe<Scalars['String']['input']>;
  editsHash_lte?: InputMaybe<Scalars['String']['input']>;
  editsHash_not?: InputMaybe<Scalars['String']['input']>;
  editsHash_not_contains?: InputMaybe<Scalars['String']['input']>;
  editsHash_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  editsHash_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  editsHash_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  editsHash_starts_with?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  id_gt?: InputMaybe<Scalars['ID']['input']>;
  id_gte?: InputMaybe<Scalars['ID']['input']>;
  id_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_lt?: InputMaybe<Scalars['ID']['input']>;
  id_lte?: InputMaybe<Scalars['ID']['input']>;
  id_not?: InputMaybe<Scalars['ID']['input']>;
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  id_not_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  lowVolumeAudioFile?: InputMaybe<EditedAudioGroupWhereInput_Relation>;
  mutedAudioFile?: InputMaybe<EditedAudioGroupWhereInput_Relation>;
  s3root?: InputMaybe<Scalars['String']['input']>;
  s3root_contains?: InputMaybe<Scalars['String']['input']>;
  s3root_ends_with?: InputMaybe<Scalars['String']['input']>;
  s3root_gt?: InputMaybe<Scalars['String']['input']>;
  s3root_gte?: InputMaybe<Scalars['String']['input']>;
  s3root_in?: InputMaybe<Array<Scalars['String']['input']>>;
  s3root_lt?: InputMaybe<Scalars['String']['input']>;
  s3root_lte?: InputMaybe<Scalars['String']['input']>;
  s3root_not?: InputMaybe<Scalars['String']['input']>;
  s3root_not_contains?: InputMaybe<Scalars['String']['input']>;
  s3root_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  s3root_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  s3root_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  s3root_starts_with?: InputMaybe<Scalars['String']['input']>;
  sourceVideo?: InputMaybe<EditedAudioGroupWhereInput_Relation>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_not_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
};

export type EditedAudioGroupWhereInput_Relation = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type EditedAudioGroupWhereUniqueInput = {
  editsHash?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type EffectUnit = {
  __typename?: 'EffectUnit';
  audioEffectEnum: AudioEffect;
  audioFile?: Maybe<File>;
  createdAt: Scalars['DateTime']['output'];
  failureMessage?: Maybe<Scalars['String']['output']>;
  generatingPriority: Scalars['Float']['output'];
  id: Scalars['ID']['output'];
  inputsHash: Scalars['String']['output'];
  processingDurationMs?: Maybe<Scalars['Float']['output']>;
  processingEndTime?: Maybe<Scalars['DateTime']['output']>;
  processingStartTime?: Maybe<Scalars['DateTime']['output']>;
  speechOutputs?: Maybe<Array<SpeechOutput>>;
  stateEnum: GeneratingState;
  stretchRate: Scalars['Float']['output'];
  updatedAt: Scalars['DateTime']['output'];
  vocoderOutput?: Maybe<VocoderOutput>;
};

export type FeaturesData = {
  __typename?: 'FeaturesData';
  createdAt: Scalars['DateTime']['output'];
  failureMessage?: Maybe<Scalars['String']['output']>;
  featuresDuration?: Maybe<Scalars['Float']['output']>;
  featuresFile?: Maybe<File>;
  featuresModelName?: Maybe<Scalars['String']['output']>;
  featuresVersion: Scalars['String']['output'];
  generatingPriority: Scalars['Float']['output'];
  id: Scalars['ID']['output'];
  inputsHash: Scalars['String']['output'];
  languageCode: Scalars['String']['output'];
  mimicAudioFile?: Maybe<File>;
  phones: PhonesData;
  processingDurationMs?: Maybe<Scalars['Float']['output']>;
  processingEndTime?: Maybe<Scalars['DateTime']['output']>;
  processingStartTime?: Maybe<Scalars['DateTime']['output']>;
  s3root: Scalars['String']['output'];
  speakerCode: Scalars['String']['output'];
  stateEnum: GeneratingState;
  stretchRate: Scalars['Float']['output'];
  styleCode: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  vocoderOutputs?: Maybe<Array<VocoderOutput>>;
  wordTimings?: Maybe<Scalars['Json']['output']>;
};

export enum FeaturesDataOrderByInput {
  CreatedAtAsc = 'createdAt_ASC',
  CreatedAtDesc = 'createdAt_DESC',
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  InputsHashAsc = 'inputsHash_ASC',
  InputsHashDesc = 'inputsHash_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC'
}

export type FeaturesDataWhereInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  inputsHash?: InputMaybe<Scalars['String']['input']>;
};

export type File = {
  __typename?: 'File';
  /** URL for the File */
  URL: Scalars['String']['output'];
  bucket?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  duration?: Maybe<Scalars['Float']['output']>;
  /** The extension of the file */
  extension: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  key: Scalars['String']['output'];
  properties?: Maybe<Scalars['Json']['output']>;
  provider: ProviderType;
  region?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  videoProperties?: Maybe<VideoProperties>;
};

export type FileWhereInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  id_in?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type FindInSegmentsPage = {
  __typename?: 'FindInSegmentsPage';
  replaceableCount: Scalars['Int']['output'];
  results: Array<SegmentFindResult>;
  totalCount: Scalars['Int']['output'];
};

export enum FindMode {
  Source = 'source',
  Translated = 'translated'
}

export enum FrameProjectType {
  Customer = 'Customer',
  Editor = 'Editor'
}

export type FrameioPushResult = {
  __typename?: 'FrameioPushResult';
  status: FrameioPushStatus;
};

export enum FrameioPushStatus {
  AlreadyRunning = 'ALREADY_RUNNING',
  NotComplete = 'NOT_COMPLETE',
  NotFrameioLinked = 'NOT_FRAMEIO_LINKED',
  NoOutputGroup = 'NO_OUTPUT_GROUP',
  Started = 'STARTED'
}

export type FrameioWorkspace = {
  __typename?: 'FrameioWorkspace';
  customer?: Maybe<Customer>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export enum Frequency {
  Biweekly = 'Biweekly',
  Daily = 'Daily',
  Monthly = 'Monthly',
  Weekly = 'Weekly'
}

export enum GeneratingState {
  Done = 'Done',
  Failed = 'Failed',
  Generating = 'Generating',
  Initial = 'Initial'
}

export type InvoiceItem = {
  __typename?: 'InvoiceItem';
  amount: Scalars['Int']['output'];
  channel?: Maybe<TranslatedChannel>;
  createdAt: Scalars['DateTime']['output'];
  currency: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  stripeInvoiceItemId: Scalars['String']['output'];
  translatedVideo?: Maybe<TranslatedVideo>;
  updatedAt: Scalars['DateTime']['output'];
};

export type MlOutput = {
  __typename?: 'MLOutput';
  id: Scalars['ID']['output'];
};

export type ManualTaskTime = {
  __typename?: 'ManualTaskTime';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  manualTimeSec: Scalars['Int']['output'];
  reason?: Maybe<Scalars['String']['output']>;
  translatedVideo?: Maybe<TranslatedVideo>;
  updatedAt: Scalars['DateTime']['output'];
};

export type MatchRange = {
  __typename?: 'MatchRange';
  end: Scalars['Int']['output'];
  start: Scalars['Int']['output'];
};

export enum MediaType {
  AudioPerFile = 'AudioPerFile',
  AudioSegmented = 'AudioSegmented',
  Video = 'Video'
}

export enum MimicAudioConfirmStatus {
  Confirmed = 'CONFIRMED',
  NotFound = 'NOT_FOUND',
  Pending = 'PENDING',
  ScanRejected = 'SCAN_REJECTED'
}

export type MimicAudioConfirmation = {
  __typename?: 'MimicAudioConfirmation';
  segmentId: Scalars['ID']['output'];
  status: MimicAudioConfirmStatus;
  uploadId: Scalars['ID']['output'];
};

export type MimicAudioMetadata = {
  __typename?: 'MimicAudioMetadata';
  createdAt: Scalars['DateTime']['output'];
  generatedBy: User;
  id: Scalars['ID']['output'];
  mimicAudioFile: File;
  segment: Segment;
  updatedAt: Scalars['DateTime']['output'];
};

export type MimicAudioUpload = {
  __typename?: 'MimicAudioUpload';
  presignedS3Policy: Scalars['Json']['output'];
  segmentId: Scalars['ID']['output'];
  segmentNumber: Scalars['Int']['output'];
  uploadId: Scalars['ID']['output'];
};

export type MimicAudioUploadInput = {
  segmentId: Scalars['ID']['input'];
  /** uploadId returned by bulkPrepareMimicAudioFiles */
  uploadId: Scalars['ID']['input'];
};

export type MimicRequiredReason = {
  __typename?: 'MimicRequiredReason';
  createdAt: Scalars['DateTime']['output'];
  createdBy: User;
  id: Scalars['ID']['output'];
  reason: MimicRequiredReasonEnum;
  segment: Segment;
  translatedVideo: TranslatedVideo;
  updatedAt: Scalars['DateTime']['output'];
};

export type MimicRequiredReasonCreateInput = {
  createdBy: UserCreateOneInput;
  id?: InputMaybe<Scalars['ID']['input']>;
  reason: MimicRequiredReasonEnum;
  segment: SegmentCreateOneInput;
  translatedVideo: TranslatedVideoCreateOneInput;
};

export enum MimicRequiredReasonEnum {
  InconsistentSpeakerIdentity = 'InconsistentSpeakerIdentity',
  InsufficientExpressivity = 'InsufficientExpressivity',
  PacingAndCadenceOrUnableToLipSync = 'PacingAndCadenceOrUnableToLipSync',
  Pronunciation = 'Pronunciation',
  SpeechCutOffOrArtefacts = 'SpeechCutOffOrArtefacts'
}

export enum MimicRequiredReasonOrderByInput {
  CreatedAtAsc = 'createdAt_ASC',
  CreatedAtDesc = 'createdAt_DESC',
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  ReasonAsc = 'reason_ASC',
  ReasonDesc = 'reason_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC'
}

export type MimicRequiredReasonWhereInput = {
  AND?: InputMaybe<Array<MimicRequiredReasonWhereInput>>;
  NOT?: InputMaybe<Array<MimicRequiredReasonWhereInput>>;
  OR?: InputMaybe<Array<MimicRequiredReasonWhereInput>>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_not_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  id_gt?: InputMaybe<Scalars['ID']['input']>;
  id_gte?: InputMaybe<Scalars['ID']['input']>;
  id_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_lt?: InputMaybe<Scalars['ID']['input']>;
  id_lte?: InputMaybe<Scalars['ID']['input']>;
  id_not?: InputMaybe<Scalars['ID']['input']>;
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  id_not_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  reason?: InputMaybe<MimicRequiredReasonEnum>;
  reason_in?: InputMaybe<Array<MimicRequiredReasonEnum>>;
  reason_not?: InputMaybe<MimicRequiredReasonEnum>;
  reason_not_in?: InputMaybe<Array<MimicRequiredReasonEnum>>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_not_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
};

export type MimicRequiredReasonWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export enum ModelType {
  OutputGroup = 'OutputGroup',
  OutputGroupIssue = 'OutputGroupIssue',
  SourceVideo = 'SourceVideo',
  TvStudioStage = 'TVStudioStage',
  TranslatedVideo = 'TranslatedVideo'
}

export type MultipleTranslationRes = {
  __typename?: 'MultipleTranslationRes';
  provider?: Maybe<Scalars['String']['output']>;
  text?: Maybe<Scalars['String']['output']>;
};

export type Mutation = {
  __typename?: 'Mutation';
  /** Internal Mutation-root liveness probe. Returns 'hello' to admin callers; admin-only via graphql-shield. */
  _pothosMutationHello?: Maybe<Scalars['String']['output']>;
  addAllPapercupVoiceSpeakers: Scalars['String']['output'];
  addChannelSpeaker: Speaker;
  /** Per-part counterpart of addCsvToTranslatedVideo, for a multi-file audio SourceVideo. One presigned target per fileNames entry, matched to its audio part by exact basename. */
  addCsvPartsToTranslatedVideo: Array<AudioUploadTarget>;
  /** Generates presignedS3Policy for CSV file upload */
  addCsvToTranslatedVideo: Scalars['Json']['output'];
  addDefaultChannel: SourceChannel;
  addDefaultChannelWithManyTranslatedChannels: SourceChannel;
  addEdit: Edit;
  addGoogleVoicesByLanguage: Scalars['String']['output'];
  /** Generates presignedS3Policy for JSON transcript file */
  addJsonTranscriptToSourceVideo: Scalars['Json']['output'];
  addMicrosoftVoicesByLanguage: Scalars['String']['output'];
  addNewSegment: Segment;
  addOpenAIVoicesByLanguage: Scalars['String']['output'];
  addOpenAIWithRVCVoice: Scalars['String']['output'];
  /** Generates presignedS3Policy to upload tracks */
  addPresignedToTrack: Scalars['Json']['output'];
  addStyleToVoices: Array<Voice>;
  /** Marks one or more SpeechOutputs (takes in segmentId's history) as favorites in a single batch update. Global flag, visible to every user. Does not change which take is currently selected on the segment. speechOutputIds that don't belong to segmentId are silently ignored (no-op) — compare the returned list against the requested ids if you need to detect that. */
  addTakeFavorites: Array<SpeechOutput>;
  /** Generates presignedS3Policy for SRT file */
  addTargetSrtTranscript: Scalars['Json']['output'];
  /** Adds track to source video */
  addTrackToSourceVideo: Scalars['Json']['output'];
  /** Per-part counterpart of addTranscriptionSrtToTranslatedVideo, for a multi-file audio SourceVideo. One presigned target per fileNames entry, matched to its audio part by exact basename. */
  addTranscriptionSrtPartsToTranslatedVideo: Array<AudioUploadTarget>;
  /** Generates a presigned S3 POST policy for the source-video-level transcription SRT upload. The transcription SRT is shared across all languages in the ManualTranscriptionTranslationUpload flow. */
  addTranscriptionSrtToSourceVideo: Scalars['Json']['output'];
  /** Generates a presigned S3 POST policy for transcription SRT upload */
  addTranscriptionSrtToTranslatedVideo: Scalars['Json']['output'];
  addTranslatedChannelsToSourceChannel: Scalars['String']['output'];
  /** Creates a TranslatedVideo on the existing SourceVideo for each channel in the "translations" input array. */
  addTranslatedVideosToSource: SourceVideo;
  /** Per-part counterpart of addTranslationSrtToTranslatedVideo, for a multi-file audio SourceVideo. One presigned target per fileNames entry, matched to its audio part by exact basename. */
  addTranslationSrtPartsToTranslatedVideo: Array<AudioUploadTarget>;
  /** Generates a presigned S3 POST policy for translation SRT upload */
  addTranslationSrtToTranslatedVideo: Scalars['Json']['output'];
  addTranslationToOnScreenText?: Maybe<OnScreenTextSource>;
  /** Create an audio-only Source Video with one presigned upload target per file. Both AudioSegmented and AudioPerFile support any number of files. */
  addUploadedAudioToSource: AddUploadedAudioToSourceRes;
  /** Create a Source Video object with a presignedS3Policy to use to manually upload the video. Does not create a Translated Video. */
  addUploadedVideoToSource: SourceVideo;
  addXttsSourceVoiceByLanguage: Scalars['String']['output'];
  addZeroShotVoice: Scalars['String']['output'];
  applySegmentCorrection?: Maybe<Segment>;
  archiveCorrection: Scalars['String']['output'];
  /** Used to assign one Speech Output of many, generated from features such as Prosody Buffet or Multiple Renditions */
  assignSpeechOutputToSegment?: Maybe<Segment>;
  /** Assigns a userId to many translated videos */
  assignUserToManyTranslatedVideos: BatchPayload;
  /** Trigger batch prosody enhancement for all segments of a translated video via Scribe service */
  batchProsodyEnhancement?: Maybe<TranslatedVideo>;
  /** Verifies each mimic audio upload from bulkPrepareMimicAudioFiles landed in S3 and passed the antivirus scan, then attaches the clean ones to their segments. Returns a status per file, in input order; re-send the PENDING ones. */
  bulkConfirmMimicAudioFilesUploaded: Array<MimicAudioConfirmation>;
  /** Presigned S3 policies for mimic audio uploads, one per 1-based Studio segment number. Numbers that match no segment are left out. Creates no DB rows; call bulkConfirmMimicAudioFilesUploaded after the uploads. */
  bulkPrepareMimicAudioFiles: Array<MimicAudioUpload>;
  /** Replaces every literal match in the non-archived segments of a video. Translated replacements that would produce invalid markup are skipped and counted. */
  bulkReplaceInSegments: BulkReplaceInSegmentsResult;
  /** Sets the provider model on every non-archived segment whose voice supports it. Returns the segments that changed. */
  bulkUpdateSegmentModel: Array<SegmentModelUpdate>;
  /** Sets the translation of every non-archived segment of a video, one line per segment in Studio order. Returns the segments that changed. */
  bulkUpdateSegmentTranslations: Array<SegmentTranslationUpdate>;
  cancelChatterboxWorkflow: SpeechOutput;
  captureOnScreenText: OnScreenTextSource;
  /** collect Mimic Data for the most recent Output Group of the Translated Video */
  collectMimicData?: Maybe<Scalars['Json']['output']>;
  confirmCsvUploaded?: Maybe<TranslatedVideo>;
  /** Verifies the composed WAV was uploaded to S3, then creates the manual SpeechOutput take (File + SpeechInputData snapshot + SpeechOutput) and sets it as the segment's latest speech output. */
  confirmManualSpeechOutputUploaded: SpeechOutput;
  confirmManualTranscriptUploaded?: Maybe<SourceVideo>;
  /** Verifies the mimic audio file was uploaded to S3, then creates the MimicAudioMetadata + File rows and attaches them to the segment's SID. */
  confirmMimicAudioFileUploaded: Scalars['Json']['output'];
  /** Assets tab / Add Video Language flow only. Converts an already-uploaded transcription SRT and/or translation SRT — both at TV level — into the script-CSV format and stores it at {tv.s3root}/{tvId}-script.csv. Every uploaded file must have passed the antivirus scan before its content is read. When both SRTs are present, segment count and every segment's start/end timecode must match exactly. When only a translation SRT is uploaded (re-translation of an already-segmented TV), its segment count must match the TV's existing Segment rows instead. For scriptCsvUploadType='Asset' fires PreparingSegments directly (TV in QA state). For scriptCsvUploadType='TargetLanguage' fires PreparingSegments immediately. For the Add Video case use confirmSrtsPairUploadedForVideo instead. */
  confirmSrtPairUploaded?: Maybe<TranslatedVideo>;
  /** Add Video flow only (ManualTranscriptionUpload — the SRT-pair flow; ManualTranscriptionTranslationUpload is the CSV flow). Reads the shared transcription SRT at {sv.s3root}/{svId}-transcriptionSrt.srt and each language's optional translation SRT at {sv.s3root}/{channelId}-translationSrt.srt. Every uploaded file must have passed the antivirus scan before its content is read. Validates timecode format for both and, for each pair, that segment counts match, converts them to script-CSVs, and stores each CSV at {tv.s3root}/{tvId}-script.csv. PreparingSegments is NOT fired — onSourceVideoComplete handles it. */
  confirmSrtsPairUploadedForVideo?: Maybe<SourceVideo>;
  /** Checks every uploaded audio part has landed in S3 for an audio-only Source Video, creates TranslatedVideos for each translation and transitions the Source Video. Returns a non-empty pendingFileNames with a null sourceVideo when parts are still being scanned; nothing is written in that case, so the caller should retry. */
  confirmUploadedAudioAndTranslations: ConfirmUploadedAudioRes;
  /** Checks a file has been uploaded to the presignedS3Policy of a Source Video. Creates TranslatedVideos for each object in the translations arg array. Transitions the Source Video. */
  confirmUploadedVideoAndTranslations?: Maybe<SourceVideo>;
  createCorrection: Correction;
  createCorrectionDraftForSegment: CorrectionDraft;
  createCustomer?: Maybe<Customer>;
  createMimicRequiredReason: MimicRequiredReason;
  createMultipleRenditionsForSegment?: Maybe<Segment>;
  createProsodyBuffetForSegment?: Maybe<Segment>;
  createSegment: Segment;
  createSegmentAnnotation: SegmentAnnotation;
  createSpeechOutputFeedback: SpeechOutputFeedback;
  /** create source video and translated video from backup */
  createSvWithTvFromBackup: Scalars['String']['output'];
  /** Use to create a test TV Overlap Record */
  createTestTranslatedVideoSnapshot: TranslatedVideoSnapshot;
  /** create serialise a translated video and store on s3 */
  createTranslatedVideoBackup: Scalars['String']['output'];
  createUser: User;
  createVoice: Voice;
  deleteCustomer?: Maybe<Customer>;
  deleteEdit?: Maybe<Edit>;
  deleteOnScreenTextSource?: Maybe<OnScreenTextSource>;
  deleteOnScreenTextTranslation?: Maybe<OnScreenTextTranslation>;
  deleteSegment?: Maybe<Segment>;
  deleteSegmentAnnotation?: Maybe<SegmentAnnotation>;
  /** Cascades a full, async, hard delete of a SourceVideo: every related row in binder and stapler-v2, and every related cloud file. Irreversible. */
  deleteSourceVideo?: Maybe<SourceVideo>;
  /** Deletes all cloud files relating to a source video from cloud storage. This also includes all Outputs. */
  deleteSourceVideoAndOutputGroupFiles?: Maybe<SourceVideo>;
  deleteTrack?: Maybe<Track>;
  enableTranslatedVideoStudioStages?: Maybe<TranslatedVideo>;
  /** Trigger prosody enhancement for a single segment via Scribe service */
  enhanceProsodyForSegment?: Maybe<Segment>;
  /** Generates every segment of the video that is not up to date and skips the ones the voice catalog refuses. Errors with VOICE_CATALOG_OFF while the voice catalog is off. */
  generateCatalogSpeechOutputForSegments: CatalogGenerationResult;
  /** Generates a cost report for all videos in the given source channels. Returns { downloadUrl } for the UI to download the file. */
  generateChannelCostReport: Scalars['Json']['output'];
  /** Generate new SpeechOutput for the segment */
  generateSpeechOutputForSegment?: Maybe<Segment>;
  /** Generate new SpeechOutput for all segments of a translated video */
  generateSpeechOutputForSegments: Array<Segment>;
  generateSplitAudio?: Maybe<SourceVideo>;
  /** Generates presignedS3Policy to upload glossary */
  getPresignedUrlForGlossary: Scalars['Json']['output'];
  /**
   * Reset a translated video to the state when first added.
   * WARNING: This will delete all existing segments and samples for that video.
   */
  hardResetTranslatedVideo?: Maybe<TranslatedVideo>;
  linkChannelToCustomer?: Maybe<Customer>;
  /** Create a new segment that is the result of merging the 2 input segments. The input segments will be marked as archived. */
  mergeSegments: Segment;
  migrateCorrection?: Maybe<Correction>;
  /** Returns a presigned S3 POST policy for uploading a manually-composed WAV take. No DB writes — confirmManualSpeechOutputUploaded persists the take after the upload is verified. */
  prepareManualSpeechOutput: Scalars['Json']['output'];
  /** Generates a presignedS3Policy for a mimic audio upload. Creates no DB rows; call confirmMimicAudioFileUploaded after the upload succeeds. */
  prepareMimicAudioFile: Scalars['Json']['output'];
  /** Start uploading the chosen output types of the latest output group to Frame.io in the background. Complete videos only. */
  pushTranslatedVideoOutputsToFrameio: FrameioPushResult;
  /** Generate new SpeechOutputs for all Segments on provided Translated Videos. */
  regenerateOutOfDateSegmentsForTVsById: Scalars['String']['output'];
  /** Generate SpeechOutput for all Segments on TVs that meet the input criteria. */
  regenerateOutOfDateSegmentsForTVsByState: Scalars['String']['output'];
  /** Remove mimic audio file from speechInputData (soft delete) */
  removeMimicAudioFile?: Maybe<Segment>;
  /** Removes the favorite flag from one or more SpeechOutputs (takes in segmentId's history) in a single batch update. Global flag, visible to every user. Does not change which take is currently selected on the segment. speechOutputIds that don't belong to segmentId are silently ignored (no-op) — compare the returned list against the requested ids if you need to detect that. */
  removeTakeFavorites: Array<SpeechOutput>;
  /** Restores a segment's speech output to a prior entry from its history (Segment.speechOutputs) without regenerating speech. Re-points the segment's latest speech output and resyncs the segment's SpeechInputData content (text/voice/style/stretchRate/etc.) to match the historical entry's own SpeechInputData snapshot — it never triggers synthesis. */
  restoreSegmentFromHistory?: Maybe<Segment>;
  /** create serialise a translated video and store on s3 */
  restoreTranslatedVideoFromBackup: Scalars['String']['output'];
  /** Retranslate the source text for a segment. If the channel has chunking translation enabled, uses chunking translation and only updates the requested segment. */
  retranslateSegment?: Maybe<Segment>;
  /** Retranslate an entire video by regenerating all segments and speech outputs. Returns immediately after transitioning to Retranslating state. The actual processing happens asynchronously in the background. */
  retranslateVideo?: Maybe<TranslatedVideo>;
  retrySourceVideoState?: Maybe<SourceVideo>;
  retryTranslatedVideoState?: Maybe<TranslatedVideo>;
  /** Send a 'Ready for User email' */
  sendReadyForUserEmail: Scalars['String']['output'];
  /** Sets the controls of a segment's Voices catalog model; parameters left out take the model's defaults. Errors with VOICE_CATALOG_OFF while the voice catalog is off. */
  setSegmentCatalogControls: Segment;
  /** Sets a Voices catalog model, at its default controls, on the segments whose voice offers it: the given ones, or every live segment of the video. Returns the segments that changed. Errors with VOICE_CATALOG_OFF while the voice catalog is off. */
  setSegmentsCatalogModel: Array<Segment>;
  /** Moves segments to a speaker and its Voices catalog voice. Errors with VOICE_CATALOG_OFF while the voice catalog is off. */
  setSegmentsCatalogSpeaker: Array<Segment>;
  /** Gives a speaker a Voices catalog voice and variant. Errors with VOICE_CATALOG_OFF while the voice catalog is off. */
  setSpeakerCatalogVoice: Speaker;
  setSpeakerLocked: Speaker;
  /** Set the video complexity 1 (low) - 3 (high) of a translated video (predicted by QA). */
  setVideoComplexityQA?: Maybe<TranslatedVideo>;
  /** Set the video complexity 1 (low) - 3 (high) of a translated video (predicted by Quality Controller). */
  setVideoComplexityQC?: Maybe<TranslatedVideo>;
  /** Set the video complexity rating of a translated video. */
  setVideoComplexityRating?: Maybe<TranslatedVideo>;
  /** Update the voiceConversion type for the Segment */
  setVoiceConversionType?: Maybe<Segment>;
  /**
   * "Split a segment into 2 new segments based on the Segment "source" time and a character position in its text".
   *
   * If "splitTime" input is not provided, is within 5% of the "source" start or end time,
   * less than the start time, or greater than the end time, then the mid time-point
   * of the "source" will be used as the splitTime.
   *
   * The "source lang" text is split literally at "characterNumber": the first new
   * segment gets the text up to (but not including) "characterNumber", the second
   * gets the rest. "characterNumber" must be a positive integer strictly less than
   * the length of the source text, otherwise the mutation throws.
   *
   * The "target lang" text (translation) is split at the proportionally equivalent
   * position, since source and target text are usually different lengths: the
   * "characterNumber" / source-length ratio is applied to the target text's length
   * to compute its own split index, which is then snapped to the nearest word
   * boundary so the target text is never split mid-word.
   *
   * The input segment will be marked as archived.
   *
   */
  splitSegment: Array<Segment>;
  transitionAllSegmentStudioStageCompleteStates: BatchPayload;
  transitionSegmentStudioStageCompleteState?: Maybe<Segment>;
  transitionTranslatedVideo?: Maybe<TranslatedVideo>;
  transitionTranslatedVideoStudioStage?: Maybe<TranslatedVideo>;
  translateWithMultipleProviders: Array<MultipleTranslationRes>;
  /** Updates the overlaps allowed value for many videos */
  updateAudibleOverlapsForManyTranslatedVideos: BatchPayload;
  updateChannelSpeaker?: Maybe<Speaker>;
  updateCustomer?: Maybe<Customer>;
  /** Updates any of the due date fields for many videos */
  updateDueDateForManyTranslatedVideos: BatchPayload;
  updateEdit?: Maybe<Edit>;
  updateNote?: Maybe<Note>;
  updateOnScreenTextSource: OnScreenTextSource;
  updateOnScreenTextTranslation?: Maybe<OnScreenTextTranslation>;
  updateSegment?: Maybe<Segment>;
  updateSourceChannel: SourceChannel;
  updateSourceVideo?: Maybe<SourceVideo>;
  updateSpeaker?: Maybe<Speaker>;
  /** Update SpeechInputs on many Segments */
  updateSpeechInputDataForManySegments: BatchPayload;
  /** Updates the stateValue of many translated videos. */
  updateStateValueForManyTranslatedVideos: BatchPayload;
  updateTrack?: Maybe<Track>;
  updateTranslatedChannel?: Maybe<TranslatedChannel>;
  updateTranslatedChannelMetadata?: Maybe<TranslatedChannel>;
  updateTranslatedVideo?: Maybe<TranslatedVideo>;
  updateTranslatedVideoChannelMetadata?: Maybe<TranslatedVideo>;
  updateTranslatedVideoMetadata?: Maybe<TranslatedVideo>;
  updateUser?: Maybe<User>;
  updateVoice?: Maybe<Voice>;
};


export type MutationAddAllPapercupVoiceSpeakersArgs = {
  translatedChannelId: Scalars['String']['input'];
};


export type MutationAddChannelSpeakerArgs = {
  speakerName?: InputMaybe<Scalars['String']['input']>;
  translatedChannelId: Scalars['ID']['input'];
};


export type MutationAddCsvPartsToTranslatedVideoArgs = {
  fileNames: Array<Scalars['String']['input']>;
  translatedVideoId: Scalars['ID']['input'];
};


export type MutationAddCsvToTranslatedVideoArgs = {
  translatedVideoId: Scalars['ID']['input'];
};


export type MutationAddDefaultChannelArgs = {
  sourceLanguage: Scalars['String']['input'];
  targetLanguage: Scalars['String']['input'];
  title: Scalars['String']['input'];
};


export type MutationAddDefaultChannelWithManyTranslatedChannelsArgs = {
  sourceLanguage: Scalars['String']['input'];
  targetLanguages: Array<Scalars['String']['input']>;
  title: Scalars['String']['input'];
};


export type MutationAddEditArgs = {
  endTime: Scalars['Float']['input'];
  reason?: InputMaybe<Scalars['String']['input']>;
  sourceVideoId: Scalars['ID']['input'];
  startTime: Scalars['Float']['input'];
  type: EditType;
};


export type MutationAddGoogleVoicesByLanguageArgs = {
  language: Scalars['String']['input'];
};


export type MutationAddJsonTranscriptToSourceVideoArgs = {
  sourceVideoId: Scalars['ID']['input'];
};


export type MutationAddMicrosoftVoicesByLanguageArgs = {
  language: Scalars['String']['input'];
};


export type MutationAddNewSegmentArgs = {
  endTimeMs?: InputMaybe<Scalars['Int']['input']>;
  sourceText?: InputMaybe<Scalars['String']['input']>;
  startTimeMs: Scalars['Int']['input'];
  translatedText?: InputMaybe<Scalars['String']['input']>;
  tvId: Scalars['ID']['input'];
};


export type MutationAddOpenAiVoicesByLanguageArgs = {
  language: Scalars['String']['input'];
};


export type MutationAddOpenAiWithRvcVoiceArgs = {
  gender: Scalars['String']['input'];
  language: Scalars['String']['input'];
  papercupSpeakerId: Scalars['String']['input'];
};


export type MutationAddPresignedToTrackArgs = {
  fileExtension: Scalars['String']['input'];
  sourceVideoId: Scalars['ID']['input'];
};


export type MutationAddStyleToVoicesArgs = {
  speakerCodes: Array<Scalars['String']['input']>;
  style: Scalars['String']['input'];
};


export type MutationAddTakeFavoritesArgs = {
  segmentId: Scalars['ID']['input'];
  speechOutputIds: Array<Scalars['ID']['input']>;
};


export type MutationAddTargetSrtTranscriptArgs = {
  sourceVideoId: Scalars['ID']['input'];
  translatedChannelId: Scalars['ID']['input'];
};


export type MutationAddTrackToSourceVideoArgs = {
  bucket: Scalars['String']['input'];
  fileStorageKey: Scalars['String']['input'];
  name: Scalars['String']['input'];
  sourceVideoId: Scalars['ID']['input'];
  volumeAdj: Scalars['Float']['input'];
};


export type MutationAddTranscriptionSrtPartsToTranslatedVideoArgs = {
  fileNames: Array<Scalars['String']['input']>;
  translatedVideoId: Scalars['ID']['input'];
};


export type MutationAddTranscriptionSrtToSourceVideoArgs = {
  sourceVideoId: Scalars['ID']['input'];
};


export type MutationAddTranscriptionSrtToTranslatedVideoArgs = {
  translatedVideoId: Scalars['ID']['input'];
};


export type MutationAddTranslatedChannelsToSourceChannelArgs = {
  sourceChannelId: Scalars['ID']['input'];
  targetLanguages: Array<Scalars['String']['input']>;
};


export type MutationAddTranslatedVideosToSourceArgs = {
  copyFromTvId?: InputMaybe<Scalars['ID']['input']>;
  sourceVideoId: Scalars['ID']['input'];
  title?: InputMaybe<Scalars['String']['input']>;
  translations: Array<Translation>;
};


export type MutationAddTranslationSrtPartsToTranslatedVideoArgs = {
  fileNames: Array<Scalars['String']['input']>;
  translatedVideoId: Scalars['ID']['input'];
};


export type MutationAddTranslationSrtToTranslatedVideoArgs = {
  translatedVideoId: Scalars['ID']['input'];
};


export type MutationAddTranslationToOnScreenTextArgs = {
  onScreenTextId: Scalars['ID']['input'];
  translatedText?: InputMaybe<Scalars['String']['input']>;
  translatedVideoId: Scalars['ID']['input'];
};


export type MutationAddUploadedAudioToSourceArgs = {
  fileNames: Array<Scalars['String']['input']>;
  mediaType: MediaType;
  sourceChannelId: Scalars['ID']['input'];
};


export type MutationAddUploadedVideoToSourceArgs = {
  sourceChannelId: Scalars['ID']['input'];
};


export type MutationAddXttsSourceVoiceByLanguageArgs = {
  language: Scalars['String']['input'];
};


export type MutationAddZeroShotVoiceArgs = {
  language: Scalars['String']['input'];
  speakerCode: Scalars['String']['input'];
  ttsSourceEnum: TtsSource;
};


export type MutationApplySegmentCorrectionArgs = {
  applicationLevel: CorrectionApplicationLevel;
  correctionDraftId: Scalars['ID']['input'];
  correctionId: Scalars['ID']['input'];
  overrideConflicts?: InputMaybe<Scalars['Boolean']['input']>;
  segmentId: Scalars['ID']['input'];
};


export type MutationArchiveCorrectionArgs = {
  correctionId: Scalars['ID']['input'];
};


export type MutationAssignSpeechOutputToSegmentArgs = {
  segmentId: Scalars['ID']['input'];
  speechOutputId: Scalars['ID']['input'];
};


export type MutationAssignUserToManyTranslatedVideosArgs = {
  role: AssignableRoleForTranslatedVideoEnumType;
  translatedVideoIds: Array<Scalars['ID']['input']>;
  userId: Scalars['ID']['input'];
};


export type MutationBatchProsodyEnhancementArgs = {
  translatedVideoId: Scalars['ID']['input'];
};


export type MutationBulkConfirmMimicAudioFilesUploadedArgs = {
  items: Array<MimicAudioUploadInput>;
  tvId: Scalars['ID']['input'];
  voiceConversionType: VoiceConversionTypeEnum;
};


export type MutationBulkPrepareMimicAudioFilesArgs = {
  segmentNumbers: Array<Scalars['Int']['input']>;
  tvId: Scalars['ID']['input'];
};


export type MutationBulkReplaceInSegmentsArgs = {
  matchCase?: InputMaybe<Scalars['Boolean']['input']>;
  mode?: InputMaybe<FindMode>;
  replacement: Scalars['String']['input'];
  searchTerm: Scalars['String']['input'];
  tvId: Scalars['ID']['input'];
  wholeWord?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationBulkUpdateSegmentModelArgs = {
  model: Scalars['String']['input'];
  tvId: Scalars['ID']['input'];
};


export type MutationBulkUpdateSegmentTranslationsArgs = {
  lines: Array<Scalars['String']['input']>;
  tvId: Scalars['ID']['input'];
};


export type MutationCancelChatterboxWorkflowArgs = {
  speechOutputId: Scalars['ID']['input'];
};


export type MutationCaptureOnScreenTextArgs = {
  endTimeSec: Scalars['Float']['input'];
  onScreenTextType?: InputMaybe<OnScreenTextType>;
  sourceText: Scalars['String']['input'];
  sourceVideoId: Scalars['ID']['input'];
  startTimeSec: Scalars['Float']['input'];
  translatedText?: InputMaybe<Scalars['String']['input']>;
  translatedVideoId?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationCollectMimicDataArgs = {
  outputGroupId: Scalars['String']['input'];
  translatedVideoId: Scalars['ID']['input'];
};


export type MutationConfirmCsvUploadedArgs = {
  importTargetText?: InputMaybe<Scalars['Boolean']['input']>;
  scriptCsvUploadType?: InputMaybe<Scalars['String']['input']>;
  translatedVideoId: Scalars['ID']['input'];
};


export type MutationConfirmManualSpeechOutputUploadedArgs = {
  durationSec: Scalars['Float']['input'];
  segmentId: Scalars['ID']['input'];
  uploadId: Scalars['ID']['input'];
};


export type MutationConfirmManualTranscriptUploadedArgs = {
  sourceVideoId: Scalars['ID']['input'];
};


export type MutationConfirmMimicAudioFileUploadedArgs = {
  segmentId: Scalars['ID']['input'];
  uploadId: Scalars['ID']['input'];
  voiceConversionType: VoiceConversionTypeEnum;
};


export type MutationConfirmSrtPairUploadedArgs = {
  scriptCsvUploadType?: InputMaybe<Scalars['String']['input']>;
  translatedVideoId: Scalars['ID']['input'];
};


export type MutationConfirmSrtsPairUploadedForVideoArgs = {
  sourceVideoId: Scalars['ID']['input'];
};


export type MutationConfirmUploadedAudioAndTranslationsArgs = {
  isDatamodelV3?: InputMaybe<Scalars['Boolean']['input']>;
  parts: Array<AudioPartInput>;
  sourceVideoId: Scalars['ID']['input'];
  title: Scalars['String']['input'];
  transcriptionType?: InputMaybe<TranscriptionProvider>;
  translations?: InputMaybe<Array<Translation>>;
};


export type MutationConfirmUploadedVideoAndTranslationsArgs = {
  isDatamodelV3?: InputMaybe<Scalars['Boolean']['input']>;
  sourceVideoId: Scalars['ID']['input'];
  title: Scalars['String']['input'];
  transcriptionType?: InputMaybe<TranscriptionProvider>;
  translations?: InputMaybe<Array<Translation>>;
};


export type MutationCreateCorrectionArgs = {
  applicationLevel?: InputMaybe<CorrectionApplicationLevel>;
  channelId?: InputMaybe<Scalars['ID']['input']>;
  isDatamodelV3?: InputMaybe<Scalars['Boolean']['input']>;
  language?: InputMaybe<Scalars['String']['input']>;
  originalText: Scalars['String']['input'];
  originalWord: Scalars['String']['input'];
  pronunciationLanguage?: InputMaybe<Scalars['String']['input']>;
  published?: InputMaybe<Scalars['Boolean']['input']>;
  segmentId?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationCreateCorrectionDraftForSegmentArgs = {
  correctedWord: Scalars['String']['input'];
  correctedWordLanguageCode?: InputMaybe<Scalars['String']['input']>;
  correctionId: Scalars['ID']['input'];
  correctionType?: InputMaybe<CorrectionType>;
  isWordOnly?: InputMaybe<Scalars['Boolean']['input']>;
  markedupText: Scalars['String']['input'];
  segmentId: Scalars['ID']['input'];
};


export type MutationCreateCustomerArgs = {
  frameioWorkspaceId?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
};


export type MutationCreateMimicRequiredReasonArgs = {
  data: MimicRequiredReasonCreateInput;
};


export type MutationCreateMultipleRenditionsForSegmentArgs = {
  segmentId: Scalars['ID']['input'];
  targetLanguageCode: Scalars['String']['input'];
  translatedChannelId: Scalars['ID']['input'];
  translatedVideoId: Scalars['ID']['input'];
};


export type MutationCreateProsodyBuffetForSegmentArgs = {
  prosodyTemplateIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  segmentId: Scalars['ID']['input'];
  targetLanguageCode: Scalars['String']['input'];
  translatedChannelId: Scalars['ID']['input'];
  translatedVideoId: Scalars['ID']['input'];
};


export type MutationCreateSegmentArgs = {
  data: SegmentCreateInput;
};


export type MutationCreateSegmentAnnotationArgs = {
  details?: InputMaybe<Scalars['String']['input']>;
  segmentId: Scalars['ID']['input'];
  type: SegmentAnnotationType;
};


export type MutationCreateSpeechOutputFeedbackArgs = {
  data: SpeechOutputFeedbackCreateInput;
};


export type MutationCreateSvWithTvFromBackupArgs = {
  backupS3Bucket?: InputMaybe<Scalars['String']['input']>;
  backupS3Key: Scalars['String']['input'];
  copyMimicFiles?: InputMaybe<Scalars['Boolean']['input']>;
  targetTvState?: InputMaybe<TranslatedVideoState>;
  translatedChannelId: Scalars['String']['input'];
};


export type MutationCreateTestTranslatedVideoSnapshotArgs = {
  tvId: Scalars['ID']['input'];
};


export type MutationCreateTranslatedVideoBackupArgs = {
  translatedVideoId: Scalars['ID']['input'];
};


export type MutationCreateUserArgs = {
  data: UserCreateInput;
};


export type MutationCreateVoiceArgs = {
  data: VoiceCreateInput;
};


export type MutationDeleteCustomerArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteEditArgs = {
  where: EditWhereUniqueInput;
};


export type MutationDeleteOnScreenTextSourceArgs = {
  where: OnScreenTextSourceWhereUniqueInput;
};


export type MutationDeleteOnScreenTextTranslationArgs = {
  where: OnScreenTextTranslationWhereUniqueInput;
};


export type MutationDeleteSegmentArgs = {
  where: SegmentWhereUniqueInput;
};


export type MutationDeleteSegmentAnnotationArgs = {
  where: SegmentAnnotationWhereUniqueInput;
};


export type MutationDeleteSourceVideoArgs = {
  sourceVideoId: Scalars['ID']['input'];
};


export type MutationDeleteSourceVideoAndOutputGroupFilesArgs = {
  sourceVideoId: Scalars['ID']['input'];
};


export type MutationDeleteTrackArgs = {
  where: TrackWhereUniqueInput;
};


export type MutationEnableTranslatedVideoStudioStagesArgs = {
  id: Scalars['ID']['input'];
};


export type MutationEnhanceProsodyForSegmentArgs = {
  segmentId: Scalars['ID']['input'];
};


export type MutationGenerateCatalogSpeechOutputForSegmentsArgs = {
  tvId: Scalars['ID']['input'];
};


export type MutationGenerateChannelCostReportArgs = {
  channelIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  granularEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  since?: InputMaybe<Scalars['DateTime']['input']>;
  translatedChannelIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  translatedVideoIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  until?: InputMaybe<Scalars['DateTime']['input']>;
};


export type MutationGenerateSpeechOutputForSegmentArgs = {
  forceFeaturesRegen?: InputMaybe<Scalars['Boolean']['input']>;
  mockSleepDuration?: InputMaybe<Scalars['Float']['input']>;
  segmentId: Scalars['ID']['input'];
};


export type MutationGenerateSpeechOutputForSegmentsArgs = {
  mockSleepDuration?: InputMaybe<Scalars['Float']['input']>;
  tvId: Scalars['ID']['input'];
};


export type MutationGenerateSplitAudioArgs = {
  id: Scalars['ID']['input'];
};


export type MutationGetPresignedUrlForGlossaryArgs = {
  translatedChannelId: Scalars['ID']['input'];
};


export type MutationHardResetTranslatedVideoArgs = {
  copyFromTvId?: InputMaybe<Scalars['ID']['input']>;
  translatedVideoId: Scalars['ID']['input'];
};


export type MutationLinkChannelToCustomerArgs = {
  customerId: Scalars['ID']['input'];
  sourceChannelId: Scalars['ID']['input'];
};


export type MutationMergeSegmentsArgs = {
  segment1Id: Scalars['ID']['input'];
  segment2Id: Scalars['ID']['input'];
  translatedVideoId: Scalars['ID']['input'];
};


export type MutationMigrateCorrectionArgs = {
  correctionId: Scalars['ID']['input'];
  generateAudioForFinalDraft?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationPrepareManualSpeechOutputArgs = {
  segmentId: Scalars['ID']['input'];
};


export type MutationPrepareMimicAudioFileArgs = {
  segmentId: Scalars['ID']['input'];
};


export type MutationPushTranslatedVideoOutputsToFrameioArgs = {
  outputTypes: Array<OutputType>;
  translatedVideoId: Scalars['ID']['input'];
};


export type MutationRegenerateOutOfDateSegmentsForTVsByIdArgs = {
  ids: Array<Scalars['ID']['input']>;
};


export type MutationRegenerateOutOfDateSegmentsForTVsByStateArgs = {
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  notificationEmail?: InputMaybe<Scalars['String']['input']>;
  onlyRegenerateOutOfDateSegments: Scalars['Boolean']['input'];
  stateValue_in: Array<TranslatedVideoState>;
};


export type MutationRemoveMimicAudioFileArgs = {
  segmentId: Scalars['ID']['input'];
};


export type MutationRemoveTakeFavoritesArgs = {
  segmentId: Scalars['ID']['input'];
  speechOutputIds: Array<Scalars['ID']['input']>;
};


export type MutationRestoreSegmentFromHistoryArgs = {
  segmentId: Scalars['ID']['input'];
  speechOutputId: Scalars['ID']['input'];
};


export type MutationRestoreTranslatedVideoFromBackupArgs = {
  backupS3Bucket?: InputMaybe<Scalars['String']['input']>;
  backupS3Key: Scalars['String']['input'];
  targetTvState?: InputMaybe<TranslatedVideoState>;
  translatedVideoId: Scalars['ID']['input'];
};


export type MutationRetranslateSegmentArgs = {
  segmentId: Scalars['ID']['input'];
};


export type MutationRetranslateVideoArgs = {
  translatedVideoId: Scalars['ID']['input'];
};


export type MutationRetrySourceVideoStateArgs = {
  id: Scalars['ID']['input'];
};


export type MutationRetryTranslatedVideoStateArgs = {
  copyFromTvId?: InputMaybe<Scalars['ID']['input']>;
  translatedVideoId: Scalars['ID']['input'];
};


export type MutationSendReadyForUserEmailArgs = {
  role: UserRole;
  tvId: Scalars['ID']['input'];
  userId?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationSetSegmentCatalogControlsArgs = {
  controls: Scalars['Json']['input'];
  segmentId: Scalars['ID']['input'];
};


export type MutationSetSegmentsCatalogModelArgs = {
  modelKey: Scalars['String']['input'];
  segmentIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  tvId: Scalars['ID']['input'];
};


export type MutationSetSegmentsCatalogSpeakerArgs = {
  segmentIds: Array<Scalars['ID']['input']>;
  speakerId: Scalars['ID']['input'];
  tvId: Scalars['ID']['input'];
  variant?: InputMaybe<Scalars['String']['input']>;
};


export type MutationSetSpeakerCatalogVoiceArgs = {
  speakerId: Scalars['ID']['input'];
  variant?: InputMaybe<Scalars['String']['input']>;
  voiceId: Scalars['ID']['input'];
};


export type MutationSetSpeakerLockedArgs = {
  isLocked: Scalars['Boolean']['input'];
  speakerId: Scalars['ID']['input'];
};


export type MutationSetVideoComplexityQaArgs = {
  translatedVideoId: Scalars['ID']['input'];
  videoComplexity: Scalars['Int']['input'];
};


export type MutationSetVideoComplexityQcArgs = {
  translatedVideoId: Scalars['ID']['input'];
  videoComplexity: Scalars['Int']['input'];
};


export type MutationSetVideoComplexityRatingArgs = {
  maxRating: Scalars['Int']['input'];
  minRating: Scalars['Int']['input'];
  reviewerRole: ReviewerRole;
  translatedVideoId: Scalars['ID']['input'];
  videoComplexityRating?: InputMaybe<Array<VideoComplexityRatingInput>>;
};


export type MutationSetVoiceConversionTypeArgs = {
  segmentId: Scalars['ID']['input'];
  voiceConversionType?: InputMaybe<VoiceConversionTypeEnum>;
};


export type MutationSplitSegmentArgs = {
  characterNumber: Scalars['Int']['input'];
  segmentId: Scalars['ID']['input'];
  splitTime?: InputMaybe<Scalars['Float']['input']>;
};


export type MutationTransitionAllSegmentStudioStageCompleteStatesArgs = {
  tvId: Scalars['ID']['input'];
};


export type MutationTransitionSegmentStudioStageCompleteStateArgs = {
  id: Scalars['ID']['input'];
  isCurrStudioStageDone: Scalars['Boolean']['input'];
};


export type MutationTransitionTranslatedVideoArgs = {
  eventType: TranslatedVideoEventEnumType;
  id: Scalars['ID']['input'];
};


export type MutationTransitionTranslatedVideoStudioStageArgs = {
  id: Scalars['ID']['input'];
};


export type MutationTranslateWithMultipleProvidersArgs = {
  segmentId: Scalars['ID']['input'];
};


export type MutationUpdateAudibleOverlapsForManyTranslatedVideosArgs = {
  areAudibleOverlapsAllowed: Scalars['Boolean']['input'];
  translatedVideoIds: Array<Scalars['ID']['input']>;
};


export type MutationUpdateChannelSpeakerArgs = {
  speakerId: Scalars['ID']['input'];
  voiceId?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationUpdateCustomerArgs = {
  frameioWorkspaceId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUpdateDueDateForManyTranslatedVideosArgs = {
  dueDate: Scalars['String']['input'];
  dueDateFieldToUpdate: DueDateFieldOnTranslatedVideoEnumType;
  translatedVideoIds: Array<Scalars['ID']['input']>;
};


export type MutationUpdateEditArgs = {
  endTime?: InputMaybe<Scalars['Float']['input']>;
  id: Scalars['ID']['input'];
  reason?: InputMaybe<Scalars['String']['input']>;
  startTime?: InputMaybe<Scalars['Float']['input']>;
  type?: InputMaybe<EditType>;
};


export type MutationUpdateNoteArgs = {
  data: NoteUpdateInput;
  where: NoteWhereUniqueInput;
};


export type MutationUpdateOnScreenTextSourceArgs = {
  endTimeSec?: InputMaybe<Scalars['Float']['input']>;
  id: Scalars['ID']['input'];
  reviewStatus?: InputMaybe<OnScreenTextReviewStatus>;
  sourceText?: InputMaybe<Scalars['String']['input']>;
  startTimeSec?: InputMaybe<Scalars['Float']['input']>;
};


export type MutationUpdateOnScreenTextTranslationArgs = {
  onScreenTextTranslationId: Scalars['ID']['input'];
  translatedText?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUpdateSegmentArgs = {
  controls?: InputMaybe<Scalars['Json']['input']>;
  data: SegmentUpdateInput;
  where: SegmentWhereUniqueInput;
};


export type MutationUpdateSourceChannelArgs = {
  data: SourceChannelUpdateInput;
  where: SourceChannelWhereUniqueInput;
};


export type MutationUpdateSourceVideoArgs = {
  data: SourceVideoUpdateInput;
  where: SourceVideoWhereUniqueInput;
};


export type MutationUpdateSpeakerArgs = {
  data: SpeakerUpdateInput;
  where: SpeakerWhereUniqueInput;
};


export type MutationUpdateSpeechInputDataForManySegmentsArgs = {
  segmentIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  speakerCode?: InputMaybe<Scalars['String']['input']>;
  stretchRate?: InputMaybe<Scalars['Float']['input']>;
  styleCode?: InputMaybe<Scalars['String']['input']>;
  tvId: Scalars['ID']['input'];
};


export type MutationUpdateStateValueForManyTranslatedVideosArgs = {
  stateValue: TranslatedVideoState;
  translatedVideoIds: Array<Scalars['ID']['input']>;
};


export type MutationUpdateTrackArgs = {
  data: TrackUpdateInput;
  where: TrackWhereUniqueInput;
};


export type MutationUpdateTranslatedChannelArgs = {
  data: TranslatedChannelUpdateInput;
  where: TranslatedChannelWhereUniqueInput;
};


export type MutationUpdateTranslatedChannelMetadataArgs = {
  data: Scalars['String']['input'];
  translatedChannelId: Scalars['ID']['input'];
};


export type MutationUpdateTranslatedVideoArgs = {
  data: TranslatedVideoUpdateInput;
  where: TranslatedVideoWhereUniqueInput;
};


export type MutationUpdateTranslatedVideoChannelMetadataArgs = {
  data: Scalars['String']['input'];
  translatedVideoId: Scalars['ID']['input'];
};


export type MutationUpdateTranslatedVideoMetadataArgs = {
  data: Scalars['String']['input'];
  translatedVideoId: Scalars['ID']['input'];
};


export type MutationUpdateUserArgs = {
  data: UserUpdateInput;
  where: UserWhereUniqueInput;
};


export type MutationUpdateVoiceArgs = {
  age?: InputMaybe<Scalars['Int']['input']>;
  gender?: InputMaybe<Scalars['String']['input']>;
  speakerCode: Scalars['String']['input'];
  styles?: InputMaybe<Array<Scalars['String']['input']>>;
  text?: InputMaybe<Scalars['String']['input']>;
};

export type Note = {
  __typename?: 'Note';
  createdAt: Scalars['DateTime']['output'];
  createdBy: User;
  details: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  sourceVideo?: Maybe<SourceVideo>;
  translatedVideo?: Maybe<TranslatedVideo>;
  type: NoteType;
  updatedAt: Scalars['DateTime']['output'];
};

export type NoteCreateManyWithoutTranslatedVideoInput = {
  create?: InputMaybe<Array<NoteCreateWithoutTranslatedVideoInput>>;
};

export type NoteCreateWithoutTranslatedVideoInput = {
  createdBy?: InputMaybe<NoteCreateWithoutTranslatedVideoInputcreatedByInput>;
  details: Scalars['String']['input'];
  type: NoteType;
};

export type NoteCreateWithoutTranslatedVideoInputcreatedByInput = {
  connect?: InputMaybe<UserWhereUniqueInput>;
};

export enum NoteOrderByInput {
  CreatedAtAsc = 'createdAt_ASC',
  CreatedAtDesc = 'createdAt_DESC',
  DetailsAsc = 'details_ASC',
  DetailsDesc = 'details_DESC',
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  TypeAsc = 'type_ASC',
  TypeDesc = 'type_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC'
}

export type NoteSourceVideoFilter = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type NoteTranslatedVideoFilter = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export enum NoteType {
  ForEditor = 'ForEditor',
  ForQc = 'ForQC',
  Other = 'Other'
}

export type NoteUpdateInput = {
  details?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<NoteType>;
};

export type NoteWhereInput = {
  AND?: InputMaybe<Array<NoteWhereInput>>;
  NOT?: InputMaybe<Array<NoteWhereInput>>;
  OR?: InputMaybe<Array<NoteWhereInput>>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_not_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  createdBy?: InputMaybe<UserWhereInput>;
  details?: InputMaybe<Scalars['String']['input']>;
  details_contains?: InputMaybe<Scalars['String']['input']>;
  details_ends_with?: InputMaybe<Scalars['String']['input']>;
  details_gt?: InputMaybe<Scalars['String']['input']>;
  details_gte?: InputMaybe<Scalars['String']['input']>;
  details_in?: InputMaybe<Array<Scalars['String']['input']>>;
  details_lt?: InputMaybe<Scalars['String']['input']>;
  details_lte?: InputMaybe<Scalars['String']['input']>;
  details_not?: InputMaybe<Scalars['String']['input']>;
  details_not_contains?: InputMaybe<Scalars['String']['input']>;
  details_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  details_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  details_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  details_starts_with?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  id_gt?: InputMaybe<Scalars['ID']['input']>;
  id_gte?: InputMaybe<Scalars['ID']['input']>;
  id_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_lt?: InputMaybe<Scalars['ID']['input']>;
  id_lte?: InputMaybe<Scalars['ID']['input']>;
  id_not?: InputMaybe<Scalars['ID']['input']>;
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  id_not_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  sourceVideo?: InputMaybe<NoteSourceVideoFilter>;
  translatedVideo?: InputMaybe<NoteTranslatedVideoFilter>;
  type?: InputMaybe<NoteType>;
  type_in?: InputMaybe<Array<NoteType>>;
  type_not?: InputMaybe<NoteType>;
  type_not_in?: InputMaybe<Array<NoteType>>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_not_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
};

export type NoteWhereUniqueInput = {
  id: Scalars['ID']['input'];
};

export enum OnScreenTextCaptureSource {
  Manual = 'Manual',
  VisualAnalysis = 'VisualAnalysis'
}

export enum OnScreenTextOrigin {
  Edited = 'edited',
  Filmed = 'filmed',
  Screen = 'screen'
}

export enum OnScreenTextPlacement {
  Bottom = 'bottom',
  FullFrame = 'full_frame',
  Middle = 'middle',
  Top = 'top'
}

export enum OnScreenTextReviewStatus {
  Accepted = 'Accepted',
  Pending = 'Pending',
  Rejected = 'Rejected'
}

export type OnScreenTextSource = {
  __typename?: 'OnScreenTextSource';
  captureSource: OnScreenTextCaptureSource;
  endTimeSec: Scalars['Float']['output'];
  id: Scalars['ID']['output'];
  inFocus?: Maybe<Scalars['Boolean']['output']>;
  onScreenTextType: OnScreenTextType;
  origin?: Maybe<OnScreenTextOrigin>;
  placement?: Maybe<OnScreenTextPlacement>;
  reviewStatus: OnScreenTextReviewStatus;
  sourceText: Scalars['String']['output'];
  sourceVideo: SourceVideo;
  startTimeSec: Scalars['Float']['output'];
  translations?: Maybe<Array<OnScreenTextTranslation>>;
  uncertain: Scalars['Boolean']['output'];
};


export type OnScreenTextSourceTranslationsArgs = {
  where?: InputMaybe<OnScreenTextTranslationWhereInput>;
};

export type OnScreenTextSourceWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type OnScreenTextTranslation = {
  __typename?: 'OnScreenTextTranslation';
  id: Scalars['ID']['output'];
  translatedText: Scalars['String']['output'];
  translatedVideo: TranslatedVideo;
};

export type OnScreenTextTranslationWhereInput = {
  translatedVideo?: InputMaybe<OnScreenTextTranslationWhereInput_TranslatedVideo>;
};

export type OnScreenTextTranslationWhereInput_TranslatedVideo = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type OnScreenTextTranslationWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export enum OnScreenTextType {
  Bugs = 'Bugs',
  LowThirds = 'LowThirds',
  Titles = 'Titles',
  Branding = 'branding',
  CallToAction = 'call_to_action',
  Caption = 'caption',
  Credits = 'credits',
  Disclaimer = 'disclaimer',
  Information = 'information',
  Interface = 'interface',
  Message = 'message',
  NameCard = 'name_card',
  Other = 'other',
  PlaceDate = 'place_date',
  Readout = 'readout',
  Sign = 'sign',
  Title = 'title',
  TranslationSubtitle = 'translation_subtitle'
}

export type Output = {
  __typename?: 'Output';
  createdAt: Scalars['DateTime']['output'];
  file: File;
  frameReviewLink?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  initialFrameProjectType?: Maybe<FrameProjectType>;
  outputGroup: OutputGroup;
  type: OutputType;
  updatedAt: Scalars['DateTime']['output'];
};

export type OutputGroup = {
  __typename?: 'OutputGroup';
  appropriateQualityScore?: Maybe<Scalars['Float']['output']>;
  appropriateQualityScoreNotes?: Maybe<Scalars['String']['output']>;
  appropriateQualityScoreQa?: Maybe<User>;
  audibleOverlaps: Scalars['Boolean']['output'];
  clipOutEditsSnapshot?: Maybe<Scalars['Json']['output']>;
  createdAt: Scalars['DateTime']['output'];
  currentFailure?: Maybe<OutputGroupFailure>;
  currentFailureState?: Maybe<OutputGroupState>;
  editedAudioGroup?: Maybe<EditedAudioGroup>;
  failures?: Maybe<Array<OutputGroupFailure>>;
  generatedBy?: Maybe<User>;
  id: Scalars['ID']['output'];
  issues: Array<OutputGroupIssue>;
  keepAudioEditsSnapshot?: Maybe<Scalars['Json']['output']>;
  mimicDataCollectionComplete?: Maybe<Scalars['Boolean']['output']>;
  muxPlaybackId?: Maybe<Scalars['String']['output']>;
  outputs?: Maybe<Array<Output>>;
  processingDurationMs?: Maybe<Scalars['Float']['output']>;
  processingEndTime?: Maybe<Scalars['DateTime']['output']>;
  processingStartTime?: Maybe<Scalars['DateTime']['output']>;
  qualityScore?: Maybe<Scalars['Float']['output']>;
  qualityScoreQa?: Maybe<User>;
  s3root: Scalars['String']['output'];
  samples?: Maybe<Array<Sample>>;
  speechOutputIdToInfo?: Maybe<Scalars['Json']['output']>;
  speechOutputs?: Maybe<Array<SpeechOutput>>;
  speechOutputsV2?: Maybe<Array<SpeechOutput>>;
  stateValue: OutputGroupState;
  translatedVideo: TranslatedVideo;
  updatedAt: Scalars['DateTime']['output'];
};

export type OutputGroupFailure = {
  __typename?: 'OutputGroupFailure';
  createdAt: Scalars['DateTime']['output'];
  currentFailureOutputGroup?: Maybe<OutputGroup>;
  failureError?: Maybe<Scalars['String']['output']>;
  failureMessage?: Maybe<Scalars['String']['output']>;
  failureState?: Maybe<OutputGroupState>;
  failureStatusCode?: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  outputGroup: OutputGroup;
  updatedAt: Scalars['DateTime']['output'];
};

export type OutputGroupIssue = {
  __typename?: 'OutputGroupIssue';
  category?: Maybe<Scalars['String']['output']>;
  collectionId?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  isMajor: Scalars['Boolean']['output'];
  isRecurring: Scalars['Boolean']['output'];
  isSuggestion: Scalars['Boolean']['output'];
  issueLocation?: Maybe<Scalars['Json']['output']>;
  notes?: Maybe<Scalars['String']['output']>;
  outputGroup: OutputGroup;
  reason?: Maybe<Scalars['String']['output']>;
  rejectionReason?: Maybe<Scalars['String']['output']>;
  resolvedBy?: Maybe<User>;
  segment?: Maybe<Segment>;
  severity?: Maybe<Scalars['String']['output']>;
  sourceStartTime?: Maybe<Scalars['Float']['output']>;
  speechOutput?: Maybe<SpeechOutput>;
  startTime: Scalars['Float']['output'];
  status: OutputGroupIssueStatus;
  text?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  userId: User;
  version: Scalars['Int']['output'];
};

export enum OutputGroupIssueStatus {
  Pending = 'Pending',
  Rejected = 'Rejected',
  Resolved = 'Resolved'
}

export enum OutputGroupOrderByInput {
  CreatedAtAsc = 'createdAt_ASC',
  CreatedAtDesc = 'createdAt_DESC',
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC'
}

export enum OutputGroupState {
  Complete = 'Complete',
  Failed = 'Failed',
  GeneratingAudioOnlyWithTracks = 'GeneratingAudioOnlyWithTracks',
  GeneratingAudioRefinedDub = 'GeneratingAudioRefinedDub',
  GeneratingAudioRefinedVoiceOver = 'GeneratingAudioRefinedVoiceOver',
  GeneratingSourceAudioForMix = 'GeneratingSourceAudioForMix',
  GeneratingSourceAudioForReplace = 'GeneratingSourceAudioForReplace',
  GeneratingSubtitles = 'GeneratingSubtitles',
  GeneratingVideoAudioMix = 'GeneratingVideoAudioMix',
  GeneratingVideoAudioReplace = 'GeneratingVideoAudioReplace',
  Initial = 'Initial',
  MaybeSettingEditedAudioGroup = 'MaybeSettingEditedAudioGroup',
  UpdateAudioFrom16To24Bits = 'UpdateAudioFrom16To24Bits',
  UploadToMux = 'UploadToMux'
}

export type OutputGroupWhereInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  id_in?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export enum OutputType {
  AudioMixOnly = 'AudioMixOnly',
  AudioOnly = 'AudioOnly',
  AudioOnlyOneSpeakerPerChannel = 'AudioOnlyOneSpeakerPerChannel',
  AudioOnlyOneSpeakerPerChannelRefined = 'AudioOnlyOneSpeakerPerChannelRefined',
  AudioOnlyWithTracks = 'AudioOnlyWithTracks',
  AudioPostProduction = 'AudioPostProduction',
  AudioRefinedDub = 'AudioRefinedDub',
  AudioRefinedVoiceOver = 'AudioRefinedVoiceOver',
  AudioReplaceWithEdits = 'AudioReplaceWithEdits',
  MimicOutputsData = 'MimicOutputsData',
  SourcePartsZip = 'SourcePartsZip',
  SourceSubtitles = 'SourceSubtitles',
  SrtPostProduction = 'SrtPostProduction',
  Subtitles = 'Subtitles',
  TranslatedPartsZip = 'TranslatedPartsZip',
  VideoAudioMix = 'VideoAudioMix',
  VideoAudioReplace = 'VideoAudioReplace',
  VideoDubWithTracks = 'VideoDubWithTracks',
  VideoPostProduction = 'VideoPostProduction'
}

export type PartPresignedPolicy = {
  __typename?: 'PartPresignedPolicy';
  partIndex: Scalars['Int']['output'];
  presignedPolicy: Scalars['Json']['output'];
};

export type PhonesData = {
  __typename?: 'PhonesData';
  createdAt: Scalars['DateTime']['output'];
  features?: Maybe<Array<FeaturesData>>;
  id: Scalars['ID']['output'];
  inkwellResp: Scalars['Json']['output'];
  inkwellRespHashV3: Scalars['String']['output'];
  inkwellVersion: Scalars['String']['output'];
  languageCode: Scalars['String']['output'];
  parsedText: Scalars['String']['output'];
  processingDurationMs?: Maybe<Scalars['Float']['output']>;
  processingEndTime: Scalars['DateTime']['output'];
  processingStartTime: Scalars['DateTime']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export enum PrepareSegmentsMethod {
  Tessellation = 'Tessellation',
  TessellationLlm = 'TessellationLLM'
}

export enum ProviderType {
  Gcp = 'GCP',
  S3 = 'S3'
}

export type Query = {
  __typename?: 'Query';
  /** Internal liveness probe. Returns 'hello' to admin callers; admin-only via graphql-shield. */
  _pothosHello?: Maybe<Scalars['String']['output']>;
  ablyToken?: Maybe<Scalars['String']['output']>;
  approvedInvoiceDate?: Maybe<ApprovedInvoiceDate>;
  approvedInvoiceDates: Array<ApprovedInvoiceDate>;
  bulkModelOptions: BulkModelOptions;
  /** What a bulk catalog model change offers for a video. Errors with VOICE_CATALOG_OFF while the voice catalog is off. */
  catalogModelOptions: CatalogModelOptions;
  channelCorrectionRules: CorrectionRuleList;
  correction?: Maybe<Correction>;
  correctionConflicts: CorrectionConflicts;
  correctionDraft?: Maybe<CorrectionDraft>;
  costsBySourceVideo?: Maybe<Scalars['Json']['output']>;
  costsByTranslatedVideo?: Maybe<Scalars['Json']['output']>;
  customer?: Maybe<Customer>;
  customers: Array<Customer>;
  editedAudioGroup?: Maybe<EditedAudioGroup>;
  editedAudioGroups: Array<EditedAudioGroup>;
  /** Literal search across every non-archived segment of a video, in Studio order. Paginated over matching segments. */
  findInSegments: FindInSegmentsPage;
  frameioWorkspaces: Array<FrameioWorkspace>;
  getBinderS3Bucket: Scalars['String']['output'];
  getBinderSQSQueue: Scalars['String']['output'];
  getRefinedAudioPresets: Scalars['Json']['output'];
  hasDefaultSpeakerSegments: Scalars['Boolean']['output'];
  mimicRequiredReason?: Maybe<MimicRequiredReason>;
  mimicRequiredReasons: Array<MimicRequiredReason>;
  myProfile: User;
  note?: Maybe<Note>;
  notes: Array<Note>;
  regeneratedFeaturesData?: Maybe<RegeneratedFeaturesData>;
  regeneratedFeaturesDatas: Array<RegeneratedFeaturesData>;
  scanStatus: Scalars['String']['output'];
  segment?: Maybe<Segment>;
  /** Position of the segment in the Studio list (non-archived, by startTime then id). Null when it is not a non-archived segment of the video. */
  segmentIndex?: Maybe<Scalars['Int']['output']>;
  segmentSnapshot?: Maybe<SegmentSnapshot>;
  segmentSnapshots: Array<SegmentSnapshot>;
  segments: Array<Segment>;
  sourceChannel?: Maybe<SourceChannel>;
  sourceChannelGroups: SourceChannelGroupList;
  sourceChannels: Array<SourceChannel>;
  sourceVideo?: Maybe<SourceVideo>;
  sourceVideos: Array<SourceVideo>;
  speaker?: Maybe<Speaker>;
  speakerUsage: SpeakerUsage;
  speakers: Array<Speaker>;
  speechOutput?: Maybe<SpeechOutput>;
  speechOutputCollection?: Maybe<SpeechOutputCollection>;
  speechOutputCollections: Array<SpeechOutputCollection>;
  speechOutputs: Array<SpeechOutput>;
  stateTransitionEvent?: Maybe<StateTransitionEvent>;
  stateTransitionEvents: Array<StateTransitionEvent>;
  track?: Maybe<Track>;
  tracks: Array<Track>;
  translatedChannel?: Maybe<TranslatedChannel>;
  translatedChannels: Array<TranslatedChannel>;
  translatedVideo?: Maybe<TranslatedVideo>;
  translatedVideoSnapshot?: Maybe<TranslatedVideoSnapshot>;
  translatedVideoSnapshots: Array<TranslatedVideoSnapshot>;
  translatedVideos: Array<TranslatedVideo>;
  translatedVideosForSpeaker: Array<TranslatedVideo>;
  translationMemory: Scalars['Json']['output'];
  user?: Maybe<User>;
  users: Array<User>;
  videoCorrectionRules: CorrectionRuleList;
  voice?: Maybe<Voice>;
  voices: Array<Voice>;
};


export type QueryAblyTokenArgs = {
  translatedVideoId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryApprovedInvoiceDateArgs = {
  where: ApprovedInvoiceDateWhereUniqueInput;
};


export type QueryApprovedInvoiceDatesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<ApprovedInvoiceDateOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ApprovedInvoiceDateWhereInput>;
};


export type QueryBulkModelOptionsArgs = {
  tvId: Scalars['ID']['input'];
};


export type QueryCatalogModelOptionsArgs = {
  tvId: Scalars['ID']['input'];
};


export type QueryChannelCorrectionRulesArgs = {
  channelId: Scalars['ID']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryCorrectionArgs = {
  where: CorrectionWhereUniqueInput;
};


export type QueryCorrectionConflictsArgs = {
  applicationLevel: CorrectionApplicationLevel;
  correctionId: Scalars['ID']['input'];
  segmentId: Scalars['ID']['input'];
};


export type QueryCorrectionDraftArgs = {
  where: CorrectionDraftWhereUniqueInput;
};


export type QueryCostsBySourceVideoArgs = {
  sourceVideoId: Scalars['String']['input'];
};


export type QueryCostsByTranslatedVideoArgs = {
  translatedVideoId: Scalars['String']['input'];
};


export type QueryCustomerArgs = {
  id: Scalars['ID']['input'];
};


export type QueryEditedAudioGroupArgs = {
  where: EditedAudioGroupWhereUniqueInput;
};


export type QueryEditedAudioGroupsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<EditedAudioGroupOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<EditedAudioGroupWhereInput>;
};


export type QueryFindInSegmentsArgs = {
  first?: InputMaybe<Scalars['Int']['input']>;
  matchCase?: InputMaybe<Scalars['Boolean']['input']>;
  mode?: InputMaybe<FindMode>;
  searchTerm: Scalars['String']['input'];
  skip?: InputMaybe<Scalars['Int']['input']>;
  translatedVideoId: Scalars['ID']['input'];
  wholeWord?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryHasDefaultSpeakerSegmentsArgs = {
  translatedVideoId: Scalars['ID']['input'];
};


export type QueryMimicRequiredReasonArgs = {
  where: MimicRequiredReasonWhereUniqueInput;
};


export type QueryMimicRequiredReasonsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<MimicRequiredReasonOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<MimicRequiredReasonWhereInput>;
};


export type QueryNoteArgs = {
  where: NoteWhereUniqueInput;
};


export type QueryNotesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<NoteOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<NoteWhereInput>;
};


export type QueryRegeneratedFeaturesDataArgs = {
  where: RegeneratedFeaturesDataWhereUniqueInput;
};


export type QueryRegeneratedFeaturesDatasArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<RegeneratedFeaturesDataOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<RegeneratedFeaturesDataWhereInput>;
};


export type QueryScanStatusArgs = {
  key: Scalars['String']['input'];
};


export type QuerySegmentArgs = {
  where: SegmentWhereUniqueInput;
};


export type QuerySegmentIndexArgs = {
  segmentId: Scalars['ID']['input'];
  tvId: Scalars['ID']['input'];
};


export type QuerySegmentSnapshotArgs = {
  where: SegmentSnapshotWhereUniqueInput;
};


export type QuerySegmentSnapshotsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<SegmentSnapshotOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<SegmentSnapshotWhereInput>;
};


export type QuerySegmentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<SegmentOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<SegmentWhereInput>;
};


export type QuerySourceChannelArgs = {
  where: SourceChannelWhereUniqueInput;
};


export type QuerySourceChannelGroupsArgs = {
  channelsPerGroup?: InputMaybe<Scalars['Int']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<SourceChannelOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<SourceChannelWhereInput>;
};


export type QuerySourceChannelsArgs = {
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<SourceChannelOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<SourceChannelWhereInput>;
};


export type QuerySourceVideoArgs = {
  where: SourceVideoWhereUniqueInput;
};


export type QuerySourceVideosArgs = {
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<SourceVideoOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<SourceVideoWhereInput>;
};


export type QuerySpeakerArgs = {
  where: SpeakerWhereUniqueInput;
};


export type QuerySpeakerUsageArgs = {
  speakerId: Scalars['ID']['input'];
};


export type QuerySpeakersArgs = {
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<SpeakerOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<SpeakerWhereInput>;
};


export type QuerySpeechOutputArgs = {
  where: SpeechOutputWhereUniqueInput;
};


export type QuerySpeechOutputCollectionArgs = {
  where: SpeechOutputCollectionWhereUniqueInput;
};


export type QuerySpeechOutputCollectionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<SpeechOutputCollectionOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<SpeechOutputCollectionWhereInput>;
};


export type QuerySpeechOutputsArgs = {
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<SpeechOutputOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<SpeechOutputWhereInput>;
};


export type QueryStateTransitionEventArgs = {
  where: StateTransitionEventWhereUniqueInput;
};


export type QueryStateTransitionEventsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<StateTransitionEventOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<StateTransitionEventWhereInput>;
};


export type QueryTrackArgs = {
  where: TrackWhereUniqueInput;
};


export type QueryTracksArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<TrackOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<TrackWhereInput>;
};


export type QueryTranslatedChannelArgs = {
  where: TranslatedChannelWhereUniqueInput;
};


export type QueryTranslatedChannelsArgs = {
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<TranslatedChannelOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<TranslatedChannelWhereInput>;
};


export type QueryTranslatedVideoArgs = {
  where: TranslatedVideoWhereUniqueInput;
};


export type QueryTranslatedVideoSnapshotArgs = {
  where: TranslatedVideoSnapshotWhereUniqueInput;
};


export type QueryTranslatedVideoSnapshotsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<TranslatedVideoSnapshotOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<TranslatedVideoSnapshotWhereInput>;
};


export type QueryTranslatedVideosArgs = {
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<TranslatedVideoOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<TranslatedVideoWhereInput>;
};


export type QueryTranslatedVideosForSpeakerArgs = {
  speakerId: Scalars['ID']['input'];
};


export type QueryTranslationMemoryArgs = {
  searchScope?: InputMaybe<Scalars['Int']['input']>;
  sourceLanguage?: InputMaybe<Scalars['String']['input']>;
  targetLanguage?: InputMaybe<Scalars['String']['input']>;
  term: Scalars['String']['input'];
  translatedChannelId: Scalars['ID']['input'];
};


export type QueryUserArgs = {
  where: UserWhereUniqueInput;
};


export type QueryUsersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<UserOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<UserWhereInput>;
};


export type QueryVideoCorrectionRulesArgs = {
  first?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  videoId: Scalars['ID']['input'];
};


export type QueryVoiceArgs = {
  where: VoiceWhereUniqueInput;
};


export type QueryVoicesArgs = {
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<VoiceOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<VoiceWhereInput>;
};

export type RegeneratedFeaturesData = {
  __typename?: 'RegeneratedFeaturesData';
  createdAt: Scalars['DateTime']['output'];
  featureDatas?: Maybe<Array<FeaturesData>>;
  id: Scalars['ID']['output'];
  inputsHash: Scalars['String']['output'];
  regenerationCount: Scalars['Int']['output'];
  updatedAt: Scalars['DateTime']['output'];
};


export type RegeneratedFeaturesDataFeatureDatasArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<FeaturesDataOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<FeaturesDataWhereInput>;
};

export enum RegeneratedFeaturesDataOrderByInput {
  CreatedAtAsc = 'createdAt_ASC',
  CreatedAtDesc = 'createdAt_DESC',
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  InputsHashAsc = 'inputsHash_ASC',
  InputsHashDesc = 'inputsHash_DESC',
  RegenerationCountAsc = 'regenerationCount_ASC',
  RegenerationCountDesc = 'regenerationCount_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC'
}

export type RegeneratedFeaturesDataWhereInput = {
  AND?: InputMaybe<Array<RegeneratedFeaturesDataWhereInput>>;
  NOT?: InputMaybe<Array<RegeneratedFeaturesDataWhereInput>>;
  OR?: InputMaybe<Array<RegeneratedFeaturesDataWhereInput>>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_not_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  featureDatas_every?: InputMaybe<RegeneratedFeaturesDataWhereInput_FeatureDatas>;
  featureDatas_none?: InputMaybe<RegeneratedFeaturesDataWhereInput_FeatureDatas>;
  featureDatas_some?: InputMaybe<RegeneratedFeaturesDataWhereInput_FeatureDatas>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  id_gt?: InputMaybe<Scalars['ID']['input']>;
  id_gte?: InputMaybe<Scalars['ID']['input']>;
  id_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_lt?: InputMaybe<Scalars['ID']['input']>;
  id_lte?: InputMaybe<Scalars['ID']['input']>;
  id_not?: InputMaybe<Scalars['ID']['input']>;
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  id_not_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  inputsHash?: InputMaybe<Scalars['String']['input']>;
  inputsHash_contains?: InputMaybe<Scalars['String']['input']>;
  inputsHash_ends_with?: InputMaybe<Scalars['String']['input']>;
  inputsHash_gt?: InputMaybe<Scalars['String']['input']>;
  inputsHash_gte?: InputMaybe<Scalars['String']['input']>;
  inputsHash_in?: InputMaybe<Array<Scalars['String']['input']>>;
  inputsHash_lt?: InputMaybe<Scalars['String']['input']>;
  inputsHash_lte?: InputMaybe<Scalars['String']['input']>;
  inputsHash_not?: InputMaybe<Scalars['String']['input']>;
  inputsHash_not_contains?: InputMaybe<Scalars['String']['input']>;
  inputsHash_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  inputsHash_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  inputsHash_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  inputsHash_starts_with?: InputMaybe<Scalars['String']['input']>;
  regenerationCount?: InputMaybe<Scalars['Int']['input']>;
  regenerationCount_gt?: InputMaybe<Scalars['Int']['input']>;
  regenerationCount_gte?: InputMaybe<Scalars['Int']['input']>;
  regenerationCount_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  regenerationCount_lt?: InputMaybe<Scalars['Int']['input']>;
  regenerationCount_lte?: InputMaybe<Scalars['Int']['input']>;
  regenerationCount_not?: InputMaybe<Scalars['Int']['input']>;
  regenerationCount_not_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_not_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
};

export type RegeneratedFeaturesDataWhereInput_FeatureDatas = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type RegeneratedFeaturesDataWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  inputsHash?: InputMaybe<Scalars['String']['input']>;
};

export type ReplacedSegment = {
  __typename?: 'ReplacedSegment';
  id: Scalars['ID']['output'];
  markedupText?: Maybe<Scalars['String']['output']>;
  text?: Maybe<Scalars['String']['output']>;
};

export enum ReviewerRole {
  Qa = 'QA',
  Qc = 'QC'
}

export type Role = {
  __typename?: 'Role';
  id: Scalars['ID']['output'];
  name?: Maybe<UserRole>;
};

export type RoleCreateInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  name?: InputMaybe<UserRole>;
};

export type RoleCreateManyInput = {
  connect?: InputMaybe<Array<RoleWhereUniqueInput>>;
  create?: InputMaybe<Array<RoleCreateInput>>;
};

export enum RoleOrderByInput {
  CreatedAtAsc = 'createdAt_ASC',
  CreatedAtDesc = 'createdAt_DESC',
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  NameAsc = 'name_ASC',
  NameDesc = 'name_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC'
}

export type RoleScalarWhereInput = {
  AND?: InputMaybe<Array<RoleScalarWhereInput>>;
  NOT?: InputMaybe<Array<RoleScalarWhereInput>>;
  OR?: InputMaybe<Array<RoleScalarWhereInput>>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  id_gt?: InputMaybe<Scalars['ID']['input']>;
  id_gte?: InputMaybe<Scalars['ID']['input']>;
  id_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_lt?: InputMaybe<Scalars['ID']['input']>;
  id_lte?: InputMaybe<Scalars['ID']['input']>;
  id_not?: InputMaybe<Scalars['ID']['input']>;
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  id_not_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  name?: InputMaybe<UserRole>;
  name_in?: InputMaybe<Array<UserRole>>;
  name_not?: InputMaybe<UserRole>;
  name_not_in?: InputMaybe<Array<UserRole>>;
};

export type RoleUpdateDataInput = {
  name?: InputMaybe<UserRole>;
};

export type RoleUpdateManyDataInput = {
  name?: InputMaybe<UserRole>;
};

export type RoleUpdateManyInput = {
  connect?: InputMaybe<Array<RoleWhereUniqueInput>>;
  create?: InputMaybe<Array<RoleCreateInput>>;
  delete?: InputMaybe<Array<RoleWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<RoleScalarWhereInput>>;
  disconnect?: InputMaybe<Array<RoleWhereUniqueInput>>;
  set?: InputMaybe<Array<RoleWhereUniqueInput>>;
  update?: InputMaybe<Array<RoleUpdateWithWhereUniqueNestedInput>>;
  updateMany?: InputMaybe<Array<RoleUpdateManyWithWhereNestedInput>>;
  upsert?: InputMaybe<Array<RoleUpsertWithWhereUniqueNestedInput>>;
};

export type RoleUpdateManyWithWhereNestedInput = {
  data: RoleUpdateManyDataInput;
  where: RoleScalarWhereInput;
};

export type RoleUpdateWithWhereUniqueNestedInput = {
  data: RoleUpdateDataInput;
  where: RoleWhereUniqueInput;
};

export type RoleUpsertWithWhereUniqueNestedInput = {
  create: RoleCreateInput;
  update: RoleUpdateDataInput;
  where: RoleWhereUniqueInput;
};

export type RoleWhereInput = {
  AND?: InputMaybe<Array<RoleWhereInput>>;
  NOT?: InputMaybe<Array<RoleWhereInput>>;
  OR?: InputMaybe<Array<RoleWhereInput>>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  id_gt?: InputMaybe<Scalars['ID']['input']>;
  id_gte?: InputMaybe<Scalars['ID']['input']>;
  id_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_lt?: InputMaybe<Scalars['ID']['input']>;
  id_lte?: InputMaybe<Scalars['ID']['input']>;
  id_not?: InputMaybe<Scalars['ID']['input']>;
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  id_not_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  name?: InputMaybe<UserRole>;
  name_in?: InputMaybe<Array<UserRole>>;
  name_not?: InputMaybe<UserRole>;
  name_not_in?: InputMaybe<Array<UserRole>>;
};

export type RoleWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  name?: InputMaybe<UserRole>;
};

export type Sample = {
  __typename?: 'Sample';
  audioDuration?: Maybe<Scalars['Float']['output']>;
  audioFile?: Maybe<File>;
  correctionApplied: Scalars['Boolean']['output'];
  createdAt: Scalars['DateTime']['output'];
  featuresS3?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  language: Scalars['String']['output'];
  modelName?: Maybe<Scalars['String']['output']>;
  modelVersion?: Maybe<Scalars['String']['output']>;
  outputGroup?: Maybe<OutputGroup>;
  papercupSpeakerId: Scalars['String']['output'];
  phonemizationVersion?: Maybe<Scalars['String']['output']>;
  phonemizedText: Array<Scalars['Int']['output']>;
  startTime?: Maybe<Scalars['Float']['output']>;
  state: Scalars['Json']['output'];
  stateValue: SampleState;
  stretchRate: Scalars['Float']['output'];
  style: Scalars['String']['output'];
  text: Scalars['String']['output'];
  trainingSetVersion?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  video?: Maybe<TranslatedVideo>;
  vocoderName?: Maybe<Scalars['String']['output']>;
  vocoderType: VocoderType;
  vocoderVersion?: Maybe<Scalars['String']['output']>;
};

export enum SampleState {
  Complete = 'Complete',
  Generating = 'Generating',
  Initial = 'Initial'
}

export type SampleWhereInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  id_in?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export enum ScriptCsvUploadType {
  Asset = 'Asset',
  TargetLanguage = 'TargetLanguage',
  Video = 'Video'
}

export type Segment = {
  __typename?: 'Segment';
  annotations?: Maybe<Array<SegmentAnnotation>>;
  autoTranslation?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  currentMLOutput?: Maybe<MlOutput>;
  done: Scalars['Boolean']['output'];
  endTime: Scalars['Float']['output'];
  featuresS3?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isArchived: Scalars['Boolean']['output'];
  isCurrStudioStageDone: Scalars['Boolean']['output'];
  /** Does the SpeechInputData for the Segment match current SpeechOutput */
  isSegmentUpToDate: Scalars['Boolean']['output'];
  isTranslationDone: Scalars['Boolean']['output'];
  latestMultipleRenditions?: Maybe<SpeechOutputCollection>;
  latestProsodyBuffet?: Maybe<SpeechOutputCollection>;
  latestSpeechOutput?: Maybe<SpeechOutput>;
  /** @deprecated Use latestMultipleRenditions. */
  latestTunedMultipleRenditions?: Maybe<SpeechOutputCollection>;
  /** @deprecated Use latestSpeechOutput. */
  latestTunedSpeechOutput?: Maybe<SpeechOutput>;
  mimicAudioMetadatas?: Maybe<Array<MimicAudioMetadata>>;
  modelName?: Maybe<Scalars['String']['output']>;
  modelVersion?: Maybe<Scalars['String']['output']>;
  origin: SegmentOrigin;
  phonemizationVersion?: Maybe<Scalars['String']['output']>;
  phonemizedText: Array<Scalars['Int']['output']>;
  /** @deprecated Legacy speech mode, no longer written. */
  previewSample?: Maybe<Sample>;
  requiresVoiceActor?: Maybe<Scalars['Boolean']['output']>;
  sourceLanguage: Scalars['String']['output'];
  sourceWords: Array<Scalars['Json']['output']>;
  speechInputData?: Maybe<SpeechInputData>;
  speechOutputCollections?: Maybe<Array<SpeechOutputCollection>>;
  speechOutputs?: Maybe<Array<SpeechOutput>>;
  startTime: Scalars['Float']['output'];
  state?: Maybe<Scalars['Json']['output']>;
  stateValue?: Maybe<SegmentState>;
  stretchRate?: Maybe<Scalars['Float']['output']>;
  studioStageCompleteState: SegmentStudioStageCompleteState;
  style?: Maybe<Scalars['String']['output']>;
  targetLanguage?: Maybe<Scalars['String']['output']>;
  terScore?: Maybe<Scalars['Float']['output']>;
  text: Scalars['String']['output'];
  translatedText?: Maybe<Scalars['String']['output']>;
  translatedTextParsed?: Maybe<Scalars['String']['output']>;
  translationStartTime: Scalars['Float']['output'];
  /** @deprecated Use done. */
  tunedAudioDone: Scalars['Boolean']['output'];
  /** @deprecated Legacy speech mode, no longer written. */
  tunedSample?: Maybe<Sample>;
  updatedAt: Scalars['DateTime']['output'];
  video: TranslatedVideo;
};


export type SegmentAnnotationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<SegmentAnnotationOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<SegmentAnnotationWhereInput>;
};


export type SegmentMimicAudioMetadatasArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type SegmentSpeechOutputCollectionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type SegmentSpeechOutputsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};

export type SegmentAnnotation = {
  __typename?: 'SegmentAnnotation';
  createdAt: Scalars['DateTime']['output'];
  createdBy: User;
  details?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  segment: Segment;
  type: SegmentAnnotationType;
  updatedAt: Scalars['DateTime']['output'];
};

export enum SegmentAnnotationOrderByInput {
  CreatedAtAsc = 'createdAt_ASC',
  CreatedAtDesc = 'createdAt_DESC',
  DetailsAsc = 'details_ASC',
  DetailsDesc = 'details_DESC',
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  TypeAsc = 'type_ASC',
  TypeDesc = 'type_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC'
}

export enum SegmentAnnotationType {
  InsufficientExpressivity = 'InsufficientExpressivity',
  NoteForVa = 'NoteForVA'
}

export type SegmentAnnotationWhereInput = {
  AND?: InputMaybe<Array<SegmentAnnotationWhereInput>>;
  NOT?: InputMaybe<Array<SegmentAnnotationWhereInput>>;
  OR?: InputMaybe<Array<SegmentAnnotationWhereInput>>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_not_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  createdBy?: InputMaybe<UserWhereInput>;
  details?: InputMaybe<Scalars['String']['input']>;
  details_contains?: InputMaybe<Scalars['String']['input']>;
  details_ends_with?: InputMaybe<Scalars['String']['input']>;
  details_gt?: InputMaybe<Scalars['String']['input']>;
  details_gte?: InputMaybe<Scalars['String']['input']>;
  details_in?: InputMaybe<Array<Scalars['String']['input']>>;
  details_lt?: InputMaybe<Scalars['String']['input']>;
  details_lte?: InputMaybe<Scalars['String']['input']>;
  details_not?: InputMaybe<Scalars['String']['input']>;
  details_not_contains?: InputMaybe<Scalars['String']['input']>;
  details_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  details_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  details_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  details_starts_with?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  id_gt?: InputMaybe<Scalars['ID']['input']>;
  id_gte?: InputMaybe<Scalars['ID']['input']>;
  id_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_lt?: InputMaybe<Scalars['ID']['input']>;
  id_lte?: InputMaybe<Scalars['ID']['input']>;
  id_not?: InputMaybe<Scalars['ID']['input']>;
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  id_not_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  segment?: InputMaybe<SegmentWhereInput>;
  type?: InputMaybe<SegmentAnnotationType>;
  type_in?: InputMaybe<Array<SegmentAnnotationType>>;
  type_not?: InputMaybe<SegmentAnnotationType>;
  type_not_in?: InputMaybe<Array<SegmentAnnotationType>>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_not_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
};

export type SegmentAnnotationWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type SegmentCreateInput = {
  autoTranslation?: InputMaybe<Scalars['String']['input']>;
  done?: InputMaybe<Scalars['Boolean']['input']>;
  endTime: Scalars['Float']['input'];
  featuresS3?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  isArchived?: InputMaybe<Scalars['Boolean']['input']>;
  isTranslationDone?: InputMaybe<Scalars['Boolean']['input']>;
  modelName?: InputMaybe<Scalars['String']['input']>;
  modelVersion?: InputMaybe<Scalars['String']['input']>;
  phonemizationVersion?: InputMaybe<Scalars['String']['input']>;
  requiresVoiceActor?: InputMaybe<Scalars['Boolean']['input']>;
  sourceLanguage: Scalars['String']['input'];
  speechInputData?: InputMaybe<SpeechInputDataCreateOneInput>;
  startTime: Scalars['Float']['input'];
  stretchRate?: InputMaybe<Scalars['Float']['input']>;
  style?: InputMaybe<Scalars['String']['input']>;
  targetLanguage?: InputMaybe<Scalars['String']['input']>;
  terScore?: InputMaybe<Scalars['Float']['input']>;
  text: Scalars['String']['input'];
  translationStartTime: Scalars['Float']['input'];
  video: TranslatedVideoCreateOneWithoutSegmentsInput;
};

export type SegmentCreateOneInput = {
  connect?: InputMaybe<SegmentWhereUniqueInput>;
};

export type SegmentFindResult = {
  __typename?: 'SegmentFindResult';
  id: Scalars['ID']['output'];
  index: Scalars['Int']['output'];
  replaceable: Scalars['Boolean']['output'];
  sourceRanges: Array<MatchRange>;
  sourceText: Scalars['String']['output'];
  startTime: Scalars['Float']['output'];
  translatedDisplay: Scalars['String']['output'];
  translatedDisplayRanges: Array<MatchRange>;
};

export type SegmentModelUpdate = {
  __typename?: 'SegmentModelUpdate';
  controls: Scalars['Json']['output'];
  id: Scalars['ID']['output'];
};

export enum SegmentOrderByInput {
  AutoTranslationAsc = 'autoTranslation_ASC',
  AutoTranslationDesc = 'autoTranslation_DESC',
  CreatedAtAsc = 'createdAt_ASC',
  CreatedAtDesc = 'createdAt_DESC',
  DoneAsc = 'done_ASC',
  DoneDesc = 'done_DESC',
  EndTimeAsc = 'endTime_ASC',
  EndTimeDesc = 'endTime_DESC',
  FeaturesS3Asc = 'featuresS3_ASC',
  FeaturesS3Desc = 'featuresS3_DESC',
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  IsArchivedAsc = 'isArchived_ASC',
  IsArchivedDesc = 'isArchived_DESC',
  IsTranslationDoneAsc = 'isTranslationDone_ASC',
  IsTranslationDoneDesc = 'isTranslationDone_DESC',
  ModelNameAsc = 'modelName_ASC',
  ModelNameDesc = 'modelName_DESC',
  ModelVersionAsc = 'modelVersion_ASC',
  ModelVersionDesc = 'modelVersion_DESC',
  OriginAsc = 'origin_ASC',
  OriginDesc = 'origin_DESC',
  PhonemizationVersionAsc = 'phonemizationVersion_ASC',
  PhonemizationVersionDesc = 'phonemizationVersion_DESC',
  RequiresVoiceActorAsc = 'requiresVoiceActor_ASC',
  RequiresVoiceActorDesc = 'requiresVoiceActor_DESC',
  SourceLanguageAsc = 'sourceLanguage_ASC',
  SourceLanguageDesc = 'sourceLanguage_DESC',
  StartTimeAsc = 'startTime_ASC',
  StartTimeDesc = 'startTime_DESC',
  StateValueAsc = 'stateValue_ASC',
  StateValueDesc = 'stateValue_DESC',
  StateAsc = 'state_ASC',
  StateDesc = 'state_DESC',
  StretchRateAsc = 'stretchRate_ASC',
  StretchRateDesc = 'stretchRate_DESC',
  StudioStageCompleteStateAsc = 'studioStageCompleteState_ASC',
  StudioStageCompleteStateDesc = 'studioStageCompleteState_DESC',
  StyleAsc = 'style_ASC',
  StyleDesc = 'style_DESC',
  TargetLanguageAsc = 'targetLanguage_ASC',
  TargetLanguageDesc = 'targetLanguage_DESC',
  TerScoreAsc = 'terScore_ASC',
  TerScoreDesc = 'terScore_DESC',
  TextAsc = 'text_ASC',
  TextDesc = 'text_DESC',
  TranslatedTextParsedAsc = 'translatedTextParsed_ASC',
  TranslatedTextParsedDesc = 'translatedTextParsed_DESC',
  TranslatedTextAsc = 'translatedText_ASC',
  TranslatedTextDesc = 'translatedText_DESC',
  TranslationStartTimeAsc = 'translationStartTime_ASC',
  TranslationStartTimeDesc = 'translationStartTime_DESC',
  TunedAudioDoneAsc = 'tunedAudioDone_ASC',
  TunedAudioDoneDesc = 'tunedAudioDone_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC'
}

export enum SegmentOrigin {
  MergeArchive = 'MergeArchive',
  MergeSink = 'MergeSink',
  Original = 'Original',
  SplitBranch = 'SplitBranch',
  SplitSource = 'SplitSource'
}

export type SegmentSnapshot = {
  __typename?: 'SegmentSnapshot';
  createdAt: Scalars['DateTime']['output'];
  durationSec: Scalars['Float']['output'];
  endTimeSec: Scalars['Float']['output'];
  id: Scalars['ID']['output'];
  isFirstSegment: Scalars['Boolean']['output'];
  isLastSegment: Scalars['Boolean']['output'];
  nextSegmentSnapshot?: Maybe<SegmentSnapshot>;
  segment: Segment;
  speechOutput: SpeechOutput;
  startTimeSec: Scalars['Float']['output'];
  stretchRate: Scalars['Float']['output'];
  timeToNextSec?: Maybe<Scalars['Float']['output']>;
  timelinePosition: Scalars['Int']['output'];
  updatedAt: Scalars['DateTime']['output'];
  videoSnapshot: TranslatedVideoSnapshot;
};

export enum SegmentSnapshotOrderByInput {
  CreatedAtAsc = 'createdAt_ASC',
  CreatedAtDesc = 'createdAt_DESC',
  DurationSecAsc = 'durationSec_ASC',
  DurationSecDesc = 'durationSec_DESC',
  EndTimeSecAsc = 'endTimeSec_ASC',
  EndTimeSecDesc = 'endTimeSec_DESC',
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  IsFirstSegmentAsc = 'isFirstSegment_ASC',
  IsFirstSegmentDesc = 'isFirstSegment_DESC',
  IsLastSegmentAsc = 'isLastSegment_ASC',
  IsLastSegmentDesc = 'isLastSegment_DESC',
  StartTimeSecAsc = 'startTimeSec_ASC',
  StartTimeSecDesc = 'startTimeSec_DESC',
  StretchRateAsc = 'stretchRate_ASC',
  StretchRateDesc = 'stretchRate_DESC',
  TimeToNextSecAsc = 'timeToNextSec_ASC',
  TimeToNextSecDesc = 'timeToNextSec_DESC',
  TimelinePositionAsc = 'timelinePosition_ASC',
  TimelinePositionDesc = 'timelinePosition_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC'
}

export type SegmentSnapshotWhereInput = {
  AND?: InputMaybe<Array<SegmentSnapshotWhereInput>>;
  NOT?: InputMaybe<Array<SegmentSnapshotWhereInput>>;
  OR?: InputMaybe<Array<SegmentSnapshotWhereInput>>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_not_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  durationSec?: InputMaybe<Scalars['Float']['input']>;
  durationSec_gt?: InputMaybe<Scalars['Float']['input']>;
  durationSec_gte?: InputMaybe<Scalars['Float']['input']>;
  durationSec_in?: InputMaybe<Array<Scalars['Float']['input']>>;
  durationSec_lt?: InputMaybe<Scalars['Float']['input']>;
  durationSec_lte?: InputMaybe<Scalars['Float']['input']>;
  durationSec_not?: InputMaybe<Scalars['Float']['input']>;
  durationSec_not_in?: InputMaybe<Array<Scalars['Float']['input']>>;
  endTimeSec?: InputMaybe<Scalars['Float']['input']>;
  endTimeSec_gt?: InputMaybe<Scalars['Float']['input']>;
  endTimeSec_gte?: InputMaybe<Scalars['Float']['input']>;
  endTimeSec_in?: InputMaybe<Array<Scalars['Float']['input']>>;
  endTimeSec_lt?: InputMaybe<Scalars['Float']['input']>;
  endTimeSec_lte?: InputMaybe<Scalars['Float']['input']>;
  endTimeSec_not?: InputMaybe<Scalars['Float']['input']>;
  endTimeSec_not_in?: InputMaybe<Array<Scalars['Float']['input']>>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  id_gt?: InputMaybe<Scalars['ID']['input']>;
  id_gte?: InputMaybe<Scalars['ID']['input']>;
  id_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_lt?: InputMaybe<Scalars['ID']['input']>;
  id_lte?: InputMaybe<Scalars['ID']['input']>;
  id_not?: InputMaybe<Scalars['ID']['input']>;
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  id_not_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  isFirstSegment?: InputMaybe<Scalars['Boolean']['input']>;
  isFirstSegment_not?: InputMaybe<Scalars['Boolean']['input']>;
  isLastSegment?: InputMaybe<Scalars['Boolean']['input']>;
  isLastSegment_not?: InputMaybe<Scalars['Boolean']['input']>;
  nextSegmentSnapshot?: InputMaybe<SegmentSnapshotWhereInput>;
  segment?: InputMaybe<SegmentSnapshotWhereInput_Relation>;
  speechOutput?: InputMaybe<SegmentSnapshotWhereInput_Relation>;
  startTimeSec?: InputMaybe<Scalars['Float']['input']>;
  startTimeSec_gt?: InputMaybe<Scalars['Float']['input']>;
  startTimeSec_gte?: InputMaybe<Scalars['Float']['input']>;
  startTimeSec_in?: InputMaybe<Array<Scalars['Float']['input']>>;
  startTimeSec_lt?: InputMaybe<Scalars['Float']['input']>;
  startTimeSec_lte?: InputMaybe<Scalars['Float']['input']>;
  startTimeSec_not?: InputMaybe<Scalars['Float']['input']>;
  startTimeSec_not_in?: InputMaybe<Array<Scalars['Float']['input']>>;
  stretchRate?: InputMaybe<Scalars['Float']['input']>;
  stretchRate_gt?: InputMaybe<Scalars['Float']['input']>;
  stretchRate_gte?: InputMaybe<Scalars['Float']['input']>;
  stretchRate_in?: InputMaybe<Array<Scalars['Float']['input']>>;
  stretchRate_lt?: InputMaybe<Scalars['Float']['input']>;
  stretchRate_lte?: InputMaybe<Scalars['Float']['input']>;
  stretchRate_not?: InputMaybe<Scalars['Float']['input']>;
  stretchRate_not_in?: InputMaybe<Array<Scalars['Float']['input']>>;
  timeToNextSec?: InputMaybe<Scalars['Float']['input']>;
  timeToNextSec_gt?: InputMaybe<Scalars['Float']['input']>;
  timeToNextSec_gte?: InputMaybe<Scalars['Float']['input']>;
  timeToNextSec_in?: InputMaybe<Array<Scalars['Float']['input']>>;
  timeToNextSec_lt?: InputMaybe<Scalars['Float']['input']>;
  timeToNextSec_lte?: InputMaybe<Scalars['Float']['input']>;
  timeToNextSec_not?: InputMaybe<Scalars['Float']['input']>;
  timeToNextSec_not_in?: InputMaybe<Array<Scalars['Float']['input']>>;
  timelinePosition?: InputMaybe<Scalars['Int']['input']>;
  timelinePosition_gt?: InputMaybe<Scalars['Int']['input']>;
  timelinePosition_gte?: InputMaybe<Scalars['Int']['input']>;
  timelinePosition_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  timelinePosition_lt?: InputMaybe<Scalars['Int']['input']>;
  timelinePosition_lte?: InputMaybe<Scalars['Int']['input']>;
  timelinePosition_not?: InputMaybe<Scalars['Int']['input']>;
  timelinePosition_not_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_not_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  videoSnapshot?: InputMaybe<SegmentSnapshotWhereInput_Relation>;
};

export type SegmentSnapshotWhereInput_Relation = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type SegmentSnapshotWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export enum SegmentState {
  Complete = 'Complete',
  GeneratingFeatures = 'GeneratingFeatures',
  GeneratingPhones = 'GeneratingPhones',
  Initial = 'Initial',
  Translating = 'Translating'
}

export enum SegmentStudioStageCompleteState {
  SpeechComplete = 'SpeechComplete',
  TranscriptionComplete = 'TranscriptionComplete',
  TranslationComplete = 'TranslationComplete',
  TunedSpeechComplete = 'TunedSpeechComplete',
  Unknown = 'Unknown'
}

export type SegmentTranslationUpdate = {
  __typename?: 'SegmentTranslationUpdate';
  id: Scalars['ID']['output'];
  markedupText: Scalars['String']['output'];
};

export type SegmentUpdateInput = {
  autoTranslation?: InputMaybe<Scalars['String']['input']>;
  done?: InputMaybe<Scalars['Boolean']['input']>;
  endTime?: InputMaybe<Scalars['Float']['input']>;
  featuresS3?: InputMaybe<Scalars['String']['input']>;
  isArchived?: InputMaybe<Scalars['Boolean']['input']>;
  isTranslationDone?: InputMaybe<Scalars['Boolean']['input']>;
  modelName?: InputMaybe<Scalars['String']['input']>;
  modelVersion?: InputMaybe<Scalars['String']['input']>;
  origin?: InputMaybe<SegmentOrigin>;
  papercupSpeakerId?: InputMaybe<Scalars['String']['input']>;
  phonemizationVersion?: InputMaybe<Scalars['String']['input']>;
  requiresVoiceActor?: InputMaybe<Scalars['Boolean']['input']>;
  sourceLanguage?: InputMaybe<Scalars['String']['input']>;
  speechInputData?: InputMaybe<Scalars['Json']['input']>;
  startTime?: InputMaybe<Scalars['Float']['input']>;
  state?: InputMaybe<Scalars['Json']['input']>;
  stateValue?: InputMaybe<SegmentState>;
  stretchRate?: InputMaybe<Scalars['Float']['input']>;
  studioStageCompleteState?: InputMaybe<SegmentStudioStageCompleteState>;
  style?: InputMaybe<Scalars['String']['input']>;
  targetLanguage?: InputMaybe<Scalars['String']['input']>;
  terScore?: InputMaybe<Scalars['Float']['input']>;
  text?: InputMaybe<Scalars['String']['input']>;
  translatedText?: InputMaybe<Scalars['String']['input']>;
  translatedTextParsed?: InputMaybe<Scalars['String']['input']>;
  translationStartTime?: InputMaybe<Scalars['Float']['input']>;
};

export type SegmentWhereInput = {
  AND?: InputMaybe<Array<SegmentWhereInput>>;
  NOT?: InputMaybe<Array<SegmentWhereInput>>;
  OR?: InputMaybe<Array<SegmentWhereInput>>;
  autoTranslation?: InputMaybe<Scalars['String']['input']>;
  autoTranslation_contains?: InputMaybe<Scalars['String']['input']>;
  autoTranslation_ends_with?: InputMaybe<Scalars['String']['input']>;
  autoTranslation_gt?: InputMaybe<Scalars['String']['input']>;
  autoTranslation_gte?: InputMaybe<Scalars['String']['input']>;
  autoTranslation_in?: InputMaybe<Array<Scalars['String']['input']>>;
  autoTranslation_lt?: InputMaybe<Scalars['String']['input']>;
  autoTranslation_lte?: InputMaybe<Scalars['String']['input']>;
  autoTranslation_not?: InputMaybe<Scalars['String']['input']>;
  autoTranslation_not_contains?: InputMaybe<Scalars['String']['input']>;
  autoTranslation_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  autoTranslation_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  autoTranslation_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  autoTranslation_starts_with?: InputMaybe<Scalars['String']['input']>;
  done?: InputMaybe<Scalars['Boolean']['input']>;
  done_not?: InputMaybe<Scalars['Boolean']['input']>;
  endTime?: InputMaybe<Scalars['Float']['input']>;
  endTime_gt?: InputMaybe<Scalars['Float']['input']>;
  endTime_gte?: InputMaybe<Scalars['Float']['input']>;
  endTime_in?: InputMaybe<Array<Scalars['Float']['input']>>;
  endTime_lt?: InputMaybe<Scalars['Float']['input']>;
  endTime_lte?: InputMaybe<Scalars['Float']['input']>;
  endTime_not?: InputMaybe<Scalars['Float']['input']>;
  endTime_not_in?: InputMaybe<Array<Scalars['Float']['input']>>;
  featuresS3?: InputMaybe<Scalars['String']['input']>;
  featuresS3_contains?: InputMaybe<Scalars['String']['input']>;
  featuresS3_ends_with?: InputMaybe<Scalars['String']['input']>;
  featuresS3_gt?: InputMaybe<Scalars['String']['input']>;
  featuresS3_gte?: InputMaybe<Scalars['String']['input']>;
  featuresS3_in?: InputMaybe<Array<Scalars['String']['input']>>;
  featuresS3_lt?: InputMaybe<Scalars['String']['input']>;
  featuresS3_lte?: InputMaybe<Scalars['String']['input']>;
  featuresS3_not?: InputMaybe<Scalars['String']['input']>;
  featuresS3_not_contains?: InputMaybe<Scalars['String']['input']>;
  featuresS3_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  featuresS3_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  featuresS3_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  featuresS3_starts_with?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  id_gt?: InputMaybe<Scalars['ID']['input']>;
  id_gte?: InputMaybe<Scalars['ID']['input']>;
  id_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_lt?: InputMaybe<Scalars['ID']['input']>;
  id_lte?: InputMaybe<Scalars['ID']['input']>;
  id_not?: InputMaybe<Scalars['ID']['input']>;
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  id_not_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  isArchived?: InputMaybe<Scalars['Boolean']['input']>;
  isArchived_not?: InputMaybe<Scalars['Boolean']['input']>;
  isTranslationDone?: InputMaybe<Scalars['Boolean']['input']>;
  isTranslationDone_not?: InputMaybe<Scalars['Boolean']['input']>;
  modelName?: InputMaybe<Scalars['String']['input']>;
  modelName_contains?: InputMaybe<Scalars['String']['input']>;
  modelName_ends_with?: InputMaybe<Scalars['String']['input']>;
  modelName_gt?: InputMaybe<Scalars['String']['input']>;
  modelName_gte?: InputMaybe<Scalars['String']['input']>;
  modelName_in?: InputMaybe<Array<Scalars['String']['input']>>;
  modelName_lt?: InputMaybe<Scalars['String']['input']>;
  modelName_lte?: InputMaybe<Scalars['String']['input']>;
  modelName_not?: InputMaybe<Scalars['String']['input']>;
  modelName_not_contains?: InputMaybe<Scalars['String']['input']>;
  modelName_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  modelName_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  modelName_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  modelName_starts_with?: InputMaybe<Scalars['String']['input']>;
  modelVersion?: InputMaybe<Scalars['String']['input']>;
  modelVersion_contains?: InputMaybe<Scalars['String']['input']>;
  modelVersion_ends_with?: InputMaybe<Scalars['String']['input']>;
  modelVersion_gt?: InputMaybe<Scalars['String']['input']>;
  modelVersion_gte?: InputMaybe<Scalars['String']['input']>;
  modelVersion_in?: InputMaybe<Array<Scalars['String']['input']>>;
  modelVersion_lt?: InputMaybe<Scalars['String']['input']>;
  modelVersion_lte?: InputMaybe<Scalars['String']['input']>;
  modelVersion_not?: InputMaybe<Scalars['String']['input']>;
  modelVersion_not_contains?: InputMaybe<Scalars['String']['input']>;
  modelVersion_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  modelVersion_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  modelVersion_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  modelVersion_starts_with?: InputMaybe<Scalars['String']['input']>;
  origin?: InputMaybe<SegmentOrigin>;
  origin_in?: InputMaybe<Array<SegmentOrigin>>;
  origin_not?: InputMaybe<SegmentOrigin>;
  origin_not_in?: InputMaybe<Array<SegmentOrigin>>;
  phonemizationVersion?: InputMaybe<Scalars['String']['input']>;
  phonemizationVersion_contains?: InputMaybe<Scalars['String']['input']>;
  phonemizationVersion_ends_with?: InputMaybe<Scalars['String']['input']>;
  phonemizationVersion_gt?: InputMaybe<Scalars['String']['input']>;
  phonemizationVersion_gte?: InputMaybe<Scalars['String']['input']>;
  phonemizationVersion_in?: InputMaybe<Array<Scalars['String']['input']>>;
  phonemizationVersion_lt?: InputMaybe<Scalars['String']['input']>;
  phonemizationVersion_lte?: InputMaybe<Scalars['String']['input']>;
  phonemizationVersion_not?: InputMaybe<Scalars['String']['input']>;
  phonemizationVersion_not_contains?: InputMaybe<Scalars['String']['input']>;
  phonemizationVersion_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  phonemizationVersion_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  phonemizationVersion_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  phonemizationVersion_starts_with?: InputMaybe<Scalars['String']['input']>;
  requiresVoiceActor?: InputMaybe<Scalars['Boolean']['input']>;
  requiresVoiceActor_not?: InputMaybe<Scalars['Boolean']['input']>;
  sourceLanguage?: InputMaybe<Scalars['String']['input']>;
  sourceLanguage_contains?: InputMaybe<Scalars['String']['input']>;
  sourceLanguage_ends_with?: InputMaybe<Scalars['String']['input']>;
  sourceLanguage_gt?: InputMaybe<Scalars['String']['input']>;
  sourceLanguage_gte?: InputMaybe<Scalars['String']['input']>;
  sourceLanguage_in?: InputMaybe<Array<Scalars['String']['input']>>;
  sourceLanguage_lt?: InputMaybe<Scalars['String']['input']>;
  sourceLanguage_lte?: InputMaybe<Scalars['String']['input']>;
  sourceLanguage_not?: InputMaybe<Scalars['String']['input']>;
  sourceLanguage_not_contains?: InputMaybe<Scalars['String']['input']>;
  sourceLanguage_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  sourceLanguage_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  sourceLanguage_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  sourceLanguage_starts_with?: InputMaybe<Scalars['String']['input']>;
  startTime?: InputMaybe<Scalars['Float']['input']>;
  startTime_gt?: InputMaybe<Scalars['Float']['input']>;
  startTime_gte?: InputMaybe<Scalars['Float']['input']>;
  startTime_in?: InputMaybe<Array<Scalars['Float']['input']>>;
  startTime_lt?: InputMaybe<Scalars['Float']['input']>;
  startTime_lte?: InputMaybe<Scalars['Float']['input']>;
  startTime_not?: InputMaybe<Scalars['Float']['input']>;
  startTime_not_in?: InputMaybe<Array<Scalars['Float']['input']>>;
  stateValue?: InputMaybe<SegmentState>;
  stateValue_in?: InputMaybe<Array<SegmentState>>;
  stateValue_not?: InputMaybe<SegmentState>;
  stateValue_not_in?: InputMaybe<Array<SegmentState>>;
  stretchRate?: InputMaybe<Scalars['Float']['input']>;
  stretchRate_gt?: InputMaybe<Scalars['Float']['input']>;
  stretchRate_gte?: InputMaybe<Scalars['Float']['input']>;
  stretchRate_in?: InputMaybe<Array<Scalars['Float']['input']>>;
  stretchRate_lt?: InputMaybe<Scalars['Float']['input']>;
  stretchRate_lte?: InputMaybe<Scalars['Float']['input']>;
  stretchRate_not?: InputMaybe<Scalars['Float']['input']>;
  stretchRate_not_in?: InputMaybe<Array<Scalars['Float']['input']>>;
  studioStageCompleteState?: InputMaybe<SegmentStudioStageCompleteState>;
  studioStageCompleteState_in?: InputMaybe<Array<SegmentStudioStageCompleteState>>;
  studioStageCompleteState_not?: InputMaybe<SegmentStudioStageCompleteState>;
  studioStageCompleteState_not_in?: InputMaybe<Array<SegmentStudioStageCompleteState>>;
  style?: InputMaybe<Scalars['String']['input']>;
  style_contains?: InputMaybe<Scalars['String']['input']>;
  style_ends_with?: InputMaybe<Scalars['String']['input']>;
  style_gt?: InputMaybe<Scalars['String']['input']>;
  style_gte?: InputMaybe<Scalars['String']['input']>;
  style_in?: InputMaybe<Array<Scalars['String']['input']>>;
  style_lt?: InputMaybe<Scalars['String']['input']>;
  style_lte?: InputMaybe<Scalars['String']['input']>;
  style_not?: InputMaybe<Scalars['String']['input']>;
  style_not_contains?: InputMaybe<Scalars['String']['input']>;
  style_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  style_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  style_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  style_starts_with?: InputMaybe<Scalars['String']['input']>;
  targetLanguage?: InputMaybe<Scalars['String']['input']>;
  targetLanguage_contains?: InputMaybe<Scalars['String']['input']>;
  targetLanguage_ends_with?: InputMaybe<Scalars['String']['input']>;
  targetLanguage_gt?: InputMaybe<Scalars['String']['input']>;
  targetLanguage_gte?: InputMaybe<Scalars['String']['input']>;
  targetLanguage_in?: InputMaybe<Array<Scalars['String']['input']>>;
  targetLanguage_lt?: InputMaybe<Scalars['String']['input']>;
  targetLanguage_lte?: InputMaybe<Scalars['String']['input']>;
  targetLanguage_not?: InputMaybe<Scalars['String']['input']>;
  targetLanguage_not_contains?: InputMaybe<Scalars['String']['input']>;
  targetLanguage_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  targetLanguage_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  targetLanguage_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  targetLanguage_starts_with?: InputMaybe<Scalars['String']['input']>;
  terScore?: InputMaybe<Scalars['Float']['input']>;
  terScore_gt?: InputMaybe<Scalars['Float']['input']>;
  terScore_gte?: InputMaybe<Scalars['Float']['input']>;
  terScore_in?: InputMaybe<Array<Scalars['Float']['input']>>;
  terScore_lt?: InputMaybe<Scalars['Float']['input']>;
  terScore_lte?: InputMaybe<Scalars['Float']['input']>;
  terScore_not?: InputMaybe<Scalars['Float']['input']>;
  terScore_not_in?: InputMaybe<Array<Scalars['Float']['input']>>;
  text?: InputMaybe<Scalars['String']['input']>;
  text_contains?: InputMaybe<Scalars['String']['input']>;
  text_ends_with?: InputMaybe<Scalars['String']['input']>;
  text_gt?: InputMaybe<Scalars['String']['input']>;
  text_gte?: InputMaybe<Scalars['String']['input']>;
  text_in?: InputMaybe<Array<Scalars['String']['input']>>;
  text_lt?: InputMaybe<Scalars['String']['input']>;
  text_lte?: InputMaybe<Scalars['String']['input']>;
  text_not?: InputMaybe<Scalars['String']['input']>;
  text_not_contains?: InputMaybe<Scalars['String']['input']>;
  text_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  text_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  text_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  text_starts_with?: InputMaybe<Scalars['String']['input']>;
  translatedText?: InputMaybe<Scalars['String']['input']>;
  translatedTextParsed?: InputMaybe<Scalars['String']['input']>;
  translatedTextParsed_contains?: InputMaybe<Scalars['String']['input']>;
  translatedTextParsed_ends_with?: InputMaybe<Scalars['String']['input']>;
  translatedTextParsed_gt?: InputMaybe<Scalars['String']['input']>;
  translatedTextParsed_gte?: InputMaybe<Scalars['String']['input']>;
  translatedTextParsed_in?: InputMaybe<Array<Scalars['String']['input']>>;
  translatedTextParsed_lt?: InputMaybe<Scalars['String']['input']>;
  translatedTextParsed_lte?: InputMaybe<Scalars['String']['input']>;
  translatedTextParsed_not?: InputMaybe<Scalars['String']['input']>;
  translatedTextParsed_not_contains?: InputMaybe<Scalars['String']['input']>;
  translatedTextParsed_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  translatedTextParsed_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  translatedTextParsed_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  translatedTextParsed_starts_with?: InputMaybe<Scalars['String']['input']>;
  translatedText_contains?: InputMaybe<Scalars['String']['input']>;
  translatedText_ends_with?: InputMaybe<Scalars['String']['input']>;
  translatedText_gt?: InputMaybe<Scalars['String']['input']>;
  translatedText_gte?: InputMaybe<Scalars['String']['input']>;
  translatedText_in?: InputMaybe<Array<Scalars['String']['input']>>;
  translatedText_lt?: InputMaybe<Scalars['String']['input']>;
  translatedText_lte?: InputMaybe<Scalars['String']['input']>;
  translatedText_not?: InputMaybe<Scalars['String']['input']>;
  translatedText_not_contains?: InputMaybe<Scalars['String']['input']>;
  translatedText_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  translatedText_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  translatedText_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  translatedText_starts_with?: InputMaybe<Scalars['String']['input']>;
  translationStartTime?: InputMaybe<Scalars['Float']['input']>;
  translationStartTime_gt?: InputMaybe<Scalars['Float']['input']>;
  translationStartTime_gte?: InputMaybe<Scalars['Float']['input']>;
  translationStartTime_in?: InputMaybe<Array<Scalars['Float']['input']>>;
  translationStartTime_lt?: InputMaybe<Scalars['Float']['input']>;
  translationStartTime_lte?: InputMaybe<Scalars['Float']['input']>;
  translationStartTime_not?: InputMaybe<Scalars['Float']['input']>;
  translationStartTime_not_in?: InputMaybe<Array<Scalars['Float']['input']>>;
  tunedAudioDone?: InputMaybe<Scalars['Boolean']['input']>;
  tunedAudioDone_not?: InputMaybe<Scalars['Boolean']['input']>;
  video?: InputMaybe<SegmentWhereInput_Video>;
};

export type SegmentWhereInput_Video = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type SegmentWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type Session = {
  __typename?: 'Session';
  activityDate?: Maybe<Scalars['DateTime']['output']>;
  channelSessions?: Maybe<Array<SessionChannelTime>>;
  createdAt: Scalars['DateTime']['output'];
  dashboardTime: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  manualTaskTimes?: Maybe<Array<ManualTaskTime>>;
  totalTime: Scalars['Int']['output'];
  updatedAt: Scalars['DateTime']['output'];
  userId: User;
  videoSessions?: Maybe<Array<SessionVideoTime>>;
};

export type SessionChannelTime = {
  __typename?: 'SessionChannelTime';
  channelDetailsTime: Scalars['Int']['output'];
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  translatedChannelId?: Maybe<TranslatedChannel>;
  updatedAt: Scalars['DateTime']['output'];
};

export enum SessionOrderByInput {
  ActivityDateAsc = 'activityDate_ASC',
  ActivityDateDesc = 'activityDate_DESC',
  CreatedAtAsc = 'createdAt_ASC',
  CreatedAtDesc = 'createdAt_DESC',
  DashboardTimeAsc = 'dashboardTime_ASC',
  DashboardTimeDesc = 'dashboardTime_DESC',
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  TotalTimeAsc = 'totalTime_ASC',
  TotalTimeDesc = 'totalTime_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC'
}

export type SessionVideoTime = {
  __typename?: 'SessionVideoTime';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  manualTaskTimes?: Maybe<Array<ManualTaskTime>>;
  outputReview: Scalars['Int']['output'];
  speechTime: Scalars['Int']['output'];
  studioTime: Scalars['Int']['output'];
  studioTunedModeTime: Scalars['Int']['output'];
  transcriptionTime: Scalars['Int']['output'];
  translatedVideoId?: Maybe<TranslatedVideo>;
  translationTime: Scalars['Int']['output'];
  updatedAt: Scalars['DateTime']['output'];
  videoDetailsTime: Scalars['Int']['output'];
};

export type SessionWhereInput = {
  AND?: InputMaybe<Array<SessionWhereInput>>;
  NOT?: InputMaybe<Array<SessionWhereInput>>;
  OR?: InputMaybe<Array<SessionWhereInput>>;
  activityDate?: InputMaybe<Scalars['DateTime']['input']>;
  activityDate_gt?: InputMaybe<Scalars['DateTime']['input']>;
  activityDate_gte?: InputMaybe<Scalars['DateTime']['input']>;
  activityDate_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  activityDate_lt?: InputMaybe<Scalars['DateTime']['input']>;
  activityDate_lte?: InputMaybe<Scalars['DateTime']['input']>;
  activityDate_not?: InputMaybe<Scalars['DateTime']['input']>;
  activityDate_not_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_not_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  dashboardTime?: InputMaybe<Scalars['Int']['input']>;
  dashboardTime_gt?: InputMaybe<Scalars['Int']['input']>;
  dashboardTime_gte?: InputMaybe<Scalars['Int']['input']>;
  dashboardTime_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  dashboardTime_lt?: InputMaybe<Scalars['Int']['input']>;
  dashboardTime_lte?: InputMaybe<Scalars['Int']['input']>;
  dashboardTime_not?: InputMaybe<Scalars['Int']['input']>;
  dashboardTime_not_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  id_gt?: InputMaybe<Scalars['ID']['input']>;
  id_gte?: InputMaybe<Scalars['ID']['input']>;
  id_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_lt?: InputMaybe<Scalars['ID']['input']>;
  id_lte?: InputMaybe<Scalars['ID']['input']>;
  id_not?: InputMaybe<Scalars['ID']['input']>;
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  id_not_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  totalTime?: InputMaybe<Scalars['Int']['input']>;
  totalTime_gt?: InputMaybe<Scalars['Int']['input']>;
  totalTime_gte?: InputMaybe<Scalars['Int']['input']>;
  totalTime_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  totalTime_lt?: InputMaybe<Scalars['Int']['input']>;
  totalTime_lte?: InputMaybe<Scalars['Int']['input']>;
  totalTime_not?: InputMaybe<Scalars['Int']['input']>;
  totalTime_not_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_not_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  userId?: InputMaybe<UserWhereInput>;
};

export type SourceChannel = {
  __typename?: 'SourceChannel';
  activeStatus: SourceChannelActiveStatus;
  channelCreator?: Maybe<Creator>;
  channelManagers: Array<User>;
  /** @deprecated Use channelManagers — a source channel can have several managers (PPC-711). */
  channelOwner?: Maybe<User>;
  channelType?: Maybe<ChannelType>;
  createdAt: Scalars['DateTime']['output'];
  customer?: Maybe<Customer>;
  frameioProjectId?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  interPartGapSeconds?: Maybe<Scalars['Int']['output']>;
  isOnScreenTextCaptureEnabled: Scalars['Boolean']['output'];
  isTest: Scalars['Boolean']['output'];
  isTranscriptEnhancementEnabled: Scalars['Boolean']['output'];
  isVisualAnalysisEnabled: Scalars['Boolean']['output'];
  isVisualAnalysisFlagOn: Scalars['Boolean']['output'];
  language: Scalars['String']['output'];
  sourceVideos?: Maybe<Array<SourceVideo>>;
  splitAudioProvider: SplitAudioProvider;
  splitAudioProviderConfig?: Maybe<Scalars['Json']['output']>;
  title: Scalars['String']['output'];
  transcriptionType: TranscriptionProvider;
  translatedChannels?: Maybe<Array<TranslatedChannel>>;
  typicalVideoDuration?: Maybe<TypicalVideoDuration>;
  updatedAt: Scalars['DateTime']['output'];
};


export type SourceChannelTranslatedChannelsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<TranslatedChannelOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<TranslatedChannelWhereInput>;
};

export enum SourceChannelActiveStatus {
  Active = 'Active',
  ToBeDeleted = 'ToBeDeleted'
}

export type SourceChannelGroup = {
  __typename?: 'SourceChannelGroup';
  channelCount: Scalars['Int']['output'];
  channels: Array<SourceChannel>;
  customer?: Maybe<Customer>;
};

export type SourceChannelGroupList = {
  __typename?: 'SourceChannelGroupList';
  groups: Array<SourceChannelGroup>;
  totalChannels: Scalars['Int']['output'];
  totalGroups: Scalars['Int']['output'];
};

export enum SourceChannelOrderByInput {
  ActiveStatusAsc = 'activeStatus_ASC',
  ActiveStatusDesc = 'activeStatus_DESC',
  ChannelTypeAsc = 'channelType_ASC',
  ChannelTypeDesc = 'channelType_DESC',
  CreatedAtAsc = 'createdAt_ASC',
  CreatedAtDesc = 'createdAt_DESC',
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  IsTestAsc = 'isTest_ASC',
  IsTestDesc = 'isTest_DESC',
  LanguageAsc = 'language_ASC',
  LanguageDesc = 'language_DESC',
  SplitAudioProviderConfigAsc = 'splitAudioProviderConfig_ASC',
  SplitAudioProviderConfigDesc = 'splitAudioProviderConfig_DESC',
  SplitAudioProviderAsc = 'splitAudioProvider_ASC',
  SplitAudioProviderDesc = 'splitAudioProvider_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC',
  TranscriptionTypeAsc = 'transcriptionType_ASC',
  TranscriptionTypeDesc = 'transcriptionType_DESC',
  TypicalVideoDurationAsc = 'typicalVideoDuration_ASC',
  TypicalVideoDurationDesc = 'typicalVideoDuration_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC'
}

export type SourceChannelUpdateInput = {
  activeStatus?: InputMaybe<SourceChannelActiveStatus>;
  channelCreator?: InputMaybe<CreatorUpdateOneInput>;
  channelManagers?: InputMaybe<UserUpdateManyInput>;
  channelOwner?: InputMaybe<UserUpdateOneInput>;
  channelType?: InputMaybe<ChannelType>;
  interPartGapSeconds?: InputMaybe<Scalars['Int']['input']>;
  isOnScreenTextCaptureEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  isTest?: InputMaybe<Scalars['Boolean']['input']>;
  isTranscriptEnhancementEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  isVisualAnalysisEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  language?: InputMaybe<Scalars['String']['input']>;
  splitAudioProvider?: InputMaybe<SplitAudioProvider>;
  splitAudioProviderConfig?: InputMaybe<Scalars['Json']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  transcriptionType?: InputMaybe<TranscriptionProvider>;
  typicalVideoDuration?: InputMaybe<TypicalVideoDuration>;
};

export type SourceChannelWhereInput = {
  AND?: InputMaybe<Array<SourceChannelWhereInput>>;
  NOT?: InputMaybe<Array<SourceChannelWhereInput>>;
  OR?: InputMaybe<Array<SourceChannelWhereInput>>;
  activeStatus?: InputMaybe<SourceChannelActiveStatus>;
  activeStatus_in?: InputMaybe<Array<SourceChannelActiveStatus>>;
  channelType?: InputMaybe<ChannelType>;
  channelType_in?: InputMaybe<Array<ChannelType>>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_not_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  customerId?: InputMaybe<Scalars['ID']['input']>;
  hasCustomer?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  id_gt?: InputMaybe<Scalars['ID']['input']>;
  id_gte?: InputMaybe<Scalars['ID']['input']>;
  id_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_lt?: InputMaybe<Scalars['ID']['input']>;
  id_lte?: InputMaybe<Scalars['ID']['input']>;
  id_not?: InputMaybe<Scalars['ID']['input']>;
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  id_not_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  isTest?: InputMaybe<Scalars['Boolean']['input']>;
  isTest_not?: InputMaybe<Scalars['Boolean']['input']>;
  language?: InputMaybe<Scalars['String']['input']>;
  language_contains?: InputMaybe<Scalars['String']['input']>;
  language_ends_with?: InputMaybe<Scalars['String']['input']>;
  language_gt?: InputMaybe<Scalars['String']['input']>;
  language_gte?: InputMaybe<Scalars['String']['input']>;
  language_in?: InputMaybe<Array<Scalars['String']['input']>>;
  language_lt?: InputMaybe<Scalars['String']['input']>;
  language_lte?: InputMaybe<Scalars['String']['input']>;
  language_not?: InputMaybe<Scalars['String']['input']>;
  language_not_contains?: InputMaybe<Scalars['String']['input']>;
  language_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  language_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  language_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  language_starts_with?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  splitAudioProvider?: InputMaybe<SplitAudioProvider>;
  splitAudioProvider_in?: InputMaybe<Array<SplitAudioProvider>>;
  title?: InputMaybe<Scalars['String']['input']>;
  title_contains?: InputMaybe<Scalars['String']['input']>;
  title_ends_with?: InputMaybe<Scalars['String']['input']>;
  title_gt?: InputMaybe<Scalars['String']['input']>;
  title_gte?: InputMaybe<Scalars['String']['input']>;
  title_in?: InputMaybe<Array<Scalars['String']['input']>>;
  title_lt?: InputMaybe<Scalars['String']['input']>;
  title_lte?: InputMaybe<Scalars['String']['input']>;
  title_not?: InputMaybe<Scalars['String']['input']>;
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  title_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  title_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  title_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  title_starts_with?: InputMaybe<Scalars['String']['input']>;
  transcriptionType?: InputMaybe<TranscriptionProvider>;
  transcriptionType_in?: InputMaybe<Array<TranscriptionProvider>>;
  transcriptionType_not?: InputMaybe<TranscriptionProvider>;
  transcriptionType_not_in?: InputMaybe<Array<TranscriptionProvider>>;
  translatedChannels_every?: InputMaybe<TranslatedChannelWhereInput>;
  translatedChannels_none?: InputMaybe<TranslatedChannelWhereInput>;
  translatedChannels_some?: InputMaybe<TranslatedChannelWhereInput>;
  typicalVideoDuration?: InputMaybe<TypicalVideoDuration>;
  typicalVideoDuration_in?: InputMaybe<Array<TypicalVideoDuration>>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_not_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
};

export type SourceChannelWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type SourceVideo = {
  __typename?: 'SourceVideo';
  activeStatus: SourceVideoActiveStatus;
  asrConfig?: Maybe<Scalars['Json']['output']>;
  asrSegmentsFile?: Maybe<File>;
  audioAccompanimentFile?: Maybe<File>;
  audioVocalsFile?: Maybe<File>;
  audioWaveformJSONFile?: Maybe<File>;
  createdAt: Scalars['DateTime']['output'];
  /** TranslatedVideos created in the same request, with their channel IDs. */
  createdTranslatedVideos?: Maybe<Array<CreatedTranslatedVideo>>;
  /** Presigned S3 policies for per-part CSV uploads (multi-file audio, ManualTranscriptionTranslationUpload). Populated by confirmUploadedAudioAndTranslations. */
  csvPartsPresignedPolicies?: Maybe<Array<TranslatedVideoPartsPresignedPolicies>>;
  /** Presigned S3 policies for CSV uploads. Only populated by confirmUploadedVideoAndTranslations. */
  csvPresignedPolicies?: Maybe<Array<CsvPresignedPolicy>>;
  currentFailure?: Maybe<SourceVideoFailure>;
  currentFailureState?: Maybe<SourceVideoState>;
  duration?: Maybe<Scalars['Float']['output']>;
  durationFormatted?: Maybe<Scalars['String']['output']>;
  editedAudioGroups?: Maybe<Array<EditedAudioGroup>>;
  edits?: Maybe<Array<Edit>>;
  enhancedAsrFile?: Maybe<File>;
  extractedAudioGCP?: Maybe<File>;
  extractedAudioS3?: Maybe<File>;
  failures?: Maybe<Array<SourceVideoFailure>>;
  frameioFileId?: Maybe<Scalars['String']['output']>;
  highResVideoFile?: Maybe<File>;
  id: Scalars['ID']['output'];
  mediaType: MediaType;
  notes?: Maybe<Array<Note>>;
  onScreenTexts?: Maybe<Array<OnScreenTextSource>>;
  presignedS3Policy?: Maybe<Scalars['Json']['output']>;
  rawAsrFile?: Maybe<File>;
  s3root: Scalars['String']['output'];
  sourceChannel: SourceChannel;
  splitAudioProvider: SplitAudioProvider;
  splitAudioProviderConfig?: Maybe<Scalars['Json']['output']>;
  /** Presigned S3 policy for the source-video-level transcription SRT upload. Populated by confirmUploadedVideoAndTranslations when using the SRT flow. Shared across all languages. */
  srtTranscriptionPresignedPolicy?: Maybe<SrtTranscriptionPresignedPolicy>;
  /** Presigned S3 policies for per-language translation SRT uploads. Populated by confirmUploadedVideoAndTranslations when using the SRT flow. */
  srtTranslationPresignedPolicies?: Maybe<Array<SrtTranslationPresignedPolicy>>;
  stateValue: SourceVideoState;
  thumbnailFile?: Maybe<File>;
  title?: Maybe<Scalars['String']['output']>;
  tracks?: Maybe<Array<Track>>;
  /** Presigned S3 policies for per-part transcription SRT uploads (multi-file audio, ManualTranscriptionUpload). Populated by confirmUploadedAudioAndTranslations. */
  transcriptionSrtPartsPresignedPolicies?: Maybe<Array<TranslatedVideoPartsPresignedPolicies>>;
  transcriptionType: TranscriptionProvider;
  translatedVideos?: Maybe<Array<TranslatedVideo>>;
  /** Presigned S3 policies for per-part translation SRT uploads (multi-file audio, ManualTranscriptionUpload). Populated by confirmUploadedAudioAndTranslations. */
  translationSrtPartsPresignedPolicies?: Maybe<Array<TranslatedVideoPartsPresignedPolicies>>;
  updatedAt: Scalars['DateTime']['output'];
  uploader?: Maybe<User>;
  videoFile?: Maybe<File>;
  videoSource: SourceVideoSource;
  visualAnalysisFile?: Maybe<File>;
};


export type SourceVideoTracksArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<TrackOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};

export enum SourceVideoActiveStatus {
  Active = 'Active',
  CloudFileDeletionComplete = 'CloudFileDeletionComplete',
  CloudFileDeletionInProgress = 'CloudFileDeletionInProgress',
  ToBeDeleted = 'ToBeDeleted'
}

export type SourceVideoFailure = {
  __typename?: 'SourceVideoFailure';
  createdAt: Scalars['DateTime']['output'];
  currentFailureSourceVideo?: Maybe<SourceVideo>;
  failureError?: Maybe<Scalars['String']['output']>;
  failureMessage?: Maybe<Scalars['String']['output']>;
  failureState?: Maybe<SourceVideoState>;
  failureStatusCode?: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  sourceVideo: SourceVideo;
  updatedAt: Scalars['DateTime']['output'];
};

export enum SourceVideoOrderByInput {
  ActiveStatusAsc = 'activeStatus_ASC',
  ActiveStatusDesc = 'activeStatus_DESC',
  CreatedAtAsc = 'createdAt_ASC',
  CreatedAtDesc = 'createdAt_DESC',
  DurationAsc = 'duration_ASC',
  DurationDesc = 'duration_DESC',
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  SplitAudioProviderAsc = 'splitAudioProvider_ASC',
  SplitAudioProviderDesc = 'splitAudioProvider_DESC',
  StateValueAsc = 'stateValue_ASC',
  StateValueDesc = 'stateValue_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC',
  TranscriptionTypeAsc = 'transcriptionType_ASC',
  TranscriptionTypeDesc = 'transcriptionType_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC',
  VideoSourceAsc = 'videoSource_ASC',
  VideoSourceDesc = 'videoSource_DESC'
}

export enum SourceVideoSource {
  FrameIo = 'FrameIo',
  ManualUpload = 'ManualUpload'
}

export enum SourceVideoState {
  AsRing = 'ASRing',
  AwaitingManualTranscript = 'AwaitingManualTranscript',
  AwaitingManualUpload = 'AwaitingManualUpload',
  Complete = 'Complete',
  DownsamplingVideo = 'DownsamplingVideo',
  EnhancingTranscript = 'EnhancingTranscript',
  ExtractingAudio = 'ExtractingAudio',
  Failed = 'Failed',
  GeneratingAudioVocalsAndAccompaniment = 'GeneratingAudioVocalsAndAccompaniment',
  GeneratingWaveform = 'GeneratingWaveform',
  Initial = 'Initial',
  ProcessingAudio = 'ProcessingAudio',
  VisualAnalysis = 'VisualAnalysis'
}

export type SourceVideoUpdateInput = {
  activeStatus?: InputMaybe<SourceVideoActiveStatus>;
  asrConfig?: InputMaybe<Scalars['Json']['input']>;
  currentFailureState?: InputMaybe<SourceVideoState>;
  duration?: InputMaybe<Scalars['Float']['input']>;
  presignedS3Policy?: InputMaybe<Scalars['Json']['input']>;
  s3root?: InputMaybe<Scalars['String']['input']>;
  splitAudioProvider?: InputMaybe<SplitAudioProvider>;
  splitAudioProviderConfig?: InputMaybe<Scalars['Json']['input']>;
  stateValue?: InputMaybe<SourceVideoState>;
  title?: InputMaybe<Scalars['String']['input']>;
  transcriptionType?: InputMaybe<TranscriptionProvider>;
  videoSource?: InputMaybe<SourceVideoSource>;
};

export type SourceVideoWhereInput = {
  AND?: InputMaybe<Array<SourceVideoWhereInput>>;
  NOT?: InputMaybe<Array<SourceVideoWhereInput>>;
  OR?: InputMaybe<Array<SourceVideoWhereInput>>;
  activeStatus?: InputMaybe<SourceVideoActiveStatus>;
  activeStatus_in?: InputMaybe<Array<SourceVideoActiveStatus>>;
  activeStatus_not?: InputMaybe<SourceVideoActiveStatus>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_not?: InputMaybe<Scalars['ID']['input']>;
  sourceChannel?: InputMaybe<SourceVideoWhereInput_SourceChannel>;
  splitAudioProvider?: InputMaybe<SplitAudioProvider>;
  stateValue?: InputMaybe<SourceVideoState>;
  stateValue_in?: InputMaybe<Array<SourceVideoState>>;
  stateValue_not?: InputMaybe<SourceVideoState>;
  title?: InputMaybe<Scalars['String']['input']>;
  title_contains?: InputMaybe<Scalars['String']['input']>;
  title_starts_with?: InputMaybe<Scalars['String']['input']>;
  transcriptionType?: InputMaybe<TranscriptionProvider>;
  videoSource?: InputMaybe<SourceVideoSource>;
  videoSource_in?: InputMaybe<Array<SourceVideoSource>>;
};

export type SourceVideoWhereInput_SourceChannel = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type SourceVideoWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type Speaker = {
  __typename?: 'Speaker';
  aliases: Array<Alias>;
  /** Voices catalog data. Errors with VOICE_CATALOG_OFF while the voice catalog is off. */
  catalog?: Maybe<SpeakerCatalog>;
  channel?: Maybe<TranslatedChannel>;
  color?: Maybe<Scalars['String']['output']>;
  colorCode?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  defaultStretchRate: Scalars['Float']['output'];
  id: Scalars['ID']['output'];
  isLocked: Scalars['Boolean']['output'];
  isMainCharacter: Scalars['Boolean']['output'];
  name?: Maybe<Scalars['String']['output']>;
  style: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  voice: Voice;
  voiceActor?: Maybe<User>;
  voiceCharacteristics?: Maybe<Scalars['Json']['output']>;
};

export type SpeakerCatalog = {
  __typename?: 'SpeakerCatalog';
  voice?: Maybe<CatalogVoice>;
  voiceId?: Maybe<Scalars['String']['output']>;
};

export enum SpeakerOrderByInput {
  ColorAsc = 'color_ASC',
  ColorDesc = 'color_DESC',
  CreatedAtAsc = 'createdAt_ASC',
  CreatedAtDesc = 'createdAt_DESC',
  DefaultStretchRateAsc = 'defaultStretchRate_ASC',
  DefaultStretchRateDesc = 'defaultStretchRate_DESC',
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  IsMainCharacterAsc = 'isMainCharacter_ASC',
  IsMainCharacterDesc = 'isMainCharacter_DESC',
  NameAsc = 'name_ASC',
  NameDesc = 'name_DESC',
  StyleAsc = 'style_ASC',
  StyleDesc = 'style_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC'
}

export type SpeakerUpdateInput = {
  color?: InputMaybe<Scalars['String']['input']>;
  defaultStretchRate?: InputMaybe<Scalars['Float']['input']>;
  isMainCharacter?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  style?: InputMaybe<Scalars['String']['input']>;
  voice?: InputMaybe<VoiceUpdateOneRequiredInput>;
  voiceActor?: InputMaybe<UserUpdateOneInput>;
  voiceCharacteristics?: InputMaybe<Scalars['Json']['input']>;
};

export type SpeakerUpdateManyWithoutChannelInput = {
  disconnect?: InputMaybe<Array<SpeakerWhereUniqueInput>>;
};

export type SpeakerUpdateOneInput = {
  connect?: InputMaybe<SpeakerWhereUniqueInput>;
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum SpeakerUpdateRetroactivity {
  FullyRetroactive = 'FullyRetroactive',
  NotRetroactive = 'NotRetroactive'
}

export type SpeakerUsage = {
  __typename?: 'SpeakerUsage';
  translatedVideosCount: Scalars['Int']['output'];
};

export type SpeakerWhereInput = {
  AND?: InputMaybe<Array<SpeakerWhereInput>>;
  NOT?: InputMaybe<Array<SpeakerWhereInput>>;
  OR?: InputMaybe<Array<SpeakerWhereInput>>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  id_gt?: InputMaybe<Scalars['ID']['input']>;
  id_gte?: InputMaybe<Scalars['ID']['input']>;
  id_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_lt?: InputMaybe<Scalars['ID']['input']>;
  id_lte?: InputMaybe<Scalars['ID']['input']>;
  id_not?: InputMaybe<Scalars['ID']['input']>;
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  id_not_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  isMainCharacter?: InputMaybe<Scalars['Boolean']['input']>;
  isMainCharacter_not?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_contains?: InputMaybe<Scalars['String']['input']>;
  name_ends_with?: InputMaybe<Scalars['String']['input']>;
  name_gt?: InputMaybe<Scalars['String']['input']>;
  name_gte?: InputMaybe<Scalars['String']['input']>;
  name_in?: InputMaybe<Array<Scalars['String']['input']>>;
  name_lt?: InputMaybe<Scalars['String']['input']>;
  name_lte?: InputMaybe<Scalars['String']['input']>;
  name_not?: InputMaybe<Scalars['String']['input']>;
  name_not_contains?: InputMaybe<Scalars['String']['input']>;
  name_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  name_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  name_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  name_starts_with?: InputMaybe<Scalars['String']['input']>;
};

export type SpeakerWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type SpeechInputData = {
  __typename?: 'SpeechInputData';
  /** Voices catalog data. Errors with VOICE_CATALOG_OFF while the voice catalog is off. */
  catalog?: Maybe<SpeechInputDataCatalog>;
  controls?: Maybe<Scalars['Json']['output']>;
  /** Corrected Text with all the flags removed */
  correctedTextWithNoMarkup: Scalars['String']['output'];
  correctionIdsToFinalDraftId: Scalars['Json']['output'];
  createdAt: Scalars['DateTime']['output'];
  featuresVersion?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  languageCode: Scalars['String']['output'];
  markedupText: Scalars['String']['output'];
  mimicAudioFile?: Maybe<File>;
  mlConfigName?: Maybe<Scalars['String']['output']>;
  prosodyTemplateId?: Maybe<Scalars['String']['output']>;
  speakerCode: Scalars['String']['output'];
  speakerOverride?: Maybe<Speaker>;
  stretchRate: Scalars['Float']['output'];
  styleCode: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  /** @deprecated Every render uses TunedVoice. */
  vocoderType: VocoderType;
  voiceConversionType?: Maybe<VoiceConversionTypeEnum>;
};

export type SpeechInputDataCatalog = {
  __typename?: 'SpeechInputDataCatalog';
  /** The segment's controls on its model: the model's parameters as stored, defaults for the rest. What setSegmentCatalogControls takes back unchanged. */
  controls?: Maybe<Scalars['Json']['output']>;
  model?: Maybe<CatalogModel>;
  modelKey?: Maybe<Scalars['String']['output']>;
  voiceId?: Maybe<Scalars['String']['output']>;
};

export type SpeechInputDataCreateOneInput = {
  connect?: InputMaybe<SpeechInputDataWhereUniqueInput>;
};

export type SpeechInputDataWhereInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  markedupText?: InputMaybe<Scalars['String']['input']>;
  speakerCode?: InputMaybe<Scalars['String']['input']>;
  stretchRate?: InputMaybe<Scalars['Float']['input']>;
  styleCode?: InputMaybe<Scalars['String']['input']>;
  vocoderType?: InputMaybe<VocoderType>;
};

export type SpeechInputDataWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type SpeechOutput = {
  __typename?: 'SpeechOutput';
  audioFile?: Maybe<File>;
  audioFileSourceEnum?: Maybe<AudioFileSource>;
  correctionDraft?: Maybe<CorrectionDraft>;
  createdAt: Scalars['DateTime']['output'];
  createdBy?: Maybe<User>;
  effectUnit?: Maybe<EffectUnit>;
  forModelTypeEnum?: Maybe<SpeechOutputForModelTypeEnum>;
  id: Scalars['ID']['output'];
  isAutoGenerated: Scalars['Boolean']['output'];
  isBulkUpdate: Scalars['Boolean']['output'];
  isCorrectionApplied: Scalars['Boolean']['output'];
  isFavorite: Scalars['Boolean']['output'];
  isReady: Scalars['Boolean']['output'];
  outputGroup?: Maybe<OutputGroup>;
  outputGroups?: Maybe<Array<OutputGroup>>;
  processingDurationMs?: Maybe<Scalars['Float']['output']>;
  processingEndTime?: Maybe<Scalars['DateTime']['output']>;
  processingStartTime?: Maybe<Scalars['DateTime']['output']>;
  segment?: Maybe<Segment>;
  selectedAt?: Maybe<Scalars['DateTime']['output']>;
  speechInputData: SpeechInputData;
  speechOutputFeedbacks?: Maybe<Array<SpeechOutputFeedback>>;
  /** Current Status of the generation of the SpeechOutput */
  status: SpeechOutputStatus;
  thirdPartyTtsData?: Maybe<ThirdPartyTtsData>;
  transcriptionFile?: Maybe<File>;
  updatedAt: Scalars['DateTime']['output'];
  vocoderOutput?: Maybe<VocoderOutput>;
  voice?: Maybe<Voice>;
  wasOutputFoundInCache: Scalars['Boolean']['output'];
  waveform?: Maybe<Scalars['Json']['output']>;
};


export type SpeechOutputOutputGroupsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OutputGroupOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<OutputGroupWhereInput>;
};


export type SpeechOutputSpeechOutputFeedbacksArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<SpeechOutputFeedbackOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<SpeechOutputFeedbackWhereInput>;
};

export type SpeechOutputCollection = {
  __typename?: 'SpeechOutputCollection';
  collectionType: SpeechOutputCollectionType;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  segment: Segment;
  speechOutputs: Array<SpeechOutput>;
  updatedAt: Scalars['DateTime']['output'];
};

export enum SpeechOutputCollectionOrderByInput {
  CollectionTypeAsc = 'collectionType_ASC',
  CollectionTypeDesc = 'collectionType_DESC',
  CreatedAtAsc = 'createdAt_ASC',
  CreatedAtDesc = 'createdAt_DESC',
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC'
}

export enum SpeechOutputCollectionType {
  MultipleRenditions = 'MultipleRenditions',
  ProsodyBuffet = 'ProsodyBuffet'
}

export type SpeechOutputCollectionWhereInput = {
  AND?: InputMaybe<Array<SpeechOutputCollectionWhereInput>>;
  NOT?: InputMaybe<Array<SpeechOutputCollectionWhereInput>>;
  OR?: InputMaybe<Array<SpeechOutputCollectionWhereInput>>;
  collectionType?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_in?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type SpeechOutputCollectionWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type SpeechOutputCreateManyWithoutSpeechOutputFeedbacksInput = {
  connect?: InputMaybe<Array<SpeechOutputWhereUniqueInput>>;
  create?: InputMaybe<Array<Scalars['Json']['input']>>;
};

export type SpeechOutputFeedback = {
  __typename?: 'SpeechOutputFeedback';
  controlFeature?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  createdBy?: Maybe<User>;
  endTimeSec?: Maybe<Scalars['Float']['output']>;
  feedbackDetails?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  issue: Scalars['String']['output'];
  speechOutputs?: Maybe<Array<SpeechOutput>>;
  startTimeSec?: Maybe<Scalars['Float']['output']>;
  type: SpeechOutputFeedbackType;
  updatedAt: Scalars['DateTime']['output'];
};


export type SpeechOutputFeedbackSpeechOutputsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<SpeechOutputOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<SpeechOutputWhereInput>;
};

export type SpeechOutputFeedbackCreateInput = {
  controlFeature?: InputMaybe<Scalars['String']['input']>;
  createdBy?: InputMaybe<UserCreateOneInput>;
  endTimeSec?: InputMaybe<Scalars['Float']['input']>;
  feedbackDetails?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  issue: Scalars['String']['input'];
  speechOutputs?: InputMaybe<SpeechOutputCreateManyWithoutSpeechOutputFeedbacksInput>;
  startTimeSec?: InputMaybe<Scalars['Float']['input']>;
  type: SpeechOutputFeedbackType;
};

export enum SpeechOutputFeedbackOrderByInput {
  CreatedAtAsc = 'createdAt_ASC',
  CreatedAtDesc = 'createdAt_DESC',
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC'
}

export enum SpeechOutputFeedbackType {
  Artifact = 'Artifact',
  Expressivity = 'Expressivity',
  Other = 'Other',
  Pronunciation = 'Pronunciation'
}

export type SpeechOutputFeedbackWhereInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  id_in?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export enum SpeechOutputForModelTypeEnum {
  CorrectionDraft = 'CorrectionDraft',
  OutputGroup = 'OutputGroup',
  ProsodyBuffet = 'ProsodyBuffet',
  Segment = 'Segment',
  SpeechOutputCollection = 'SpeechOutputCollection',
  Voice = 'Voice'
}

export enum SpeechOutputOrderByInput {
  AudioFileSourceEnumAsc = 'audioFileSourceEnum_ASC',
  AudioFileSourceEnumDesc = 'audioFileSourceEnum_DESC',
  CreatedAtAsc = 'createdAt_ASC',
  CreatedAtDesc = 'createdAt_DESC',
  ForModelTypeEnumAsc = 'forModelTypeEnum_ASC',
  ForModelTypeEnumDesc = 'forModelTypeEnum_DESC',
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  IsAutoGeneratedAsc = 'isAutoGenerated_ASC',
  IsAutoGeneratedDesc = 'isAutoGenerated_DESC',
  IsBulkUpdateAsc = 'isBulkUpdate_ASC',
  IsBulkUpdateDesc = 'isBulkUpdate_DESC',
  IsCorrectionAppliedAsc = 'isCorrectionApplied_ASC',
  IsCorrectionAppliedDesc = 'isCorrectionApplied_DESC',
  ProcessingDurationMsAsc = 'processingDurationMs_ASC',
  ProcessingDurationMsDesc = 'processingDurationMs_DESC',
  ProcessingEndTimeAsc = 'processingEndTime_ASC',
  ProcessingEndTimeDesc = 'processingEndTime_DESC',
  ProcessingStartTimeAsc = 'processingStartTime_ASC',
  ProcessingStartTimeDesc = 'processingStartTime_DESC',
  SelectedAtAsc = 'selectedAt_ASC',
  SelectedAtDesc = 'selectedAt_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC',
  WasOutputFoundInCacheAsc = 'wasOutputFoundInCache_ASC',
  WasOutputFoundInCacheDesc = 'wasOutputFoundInCache_DESC'
}

/** Inferred status of the SpeechOutput */
export type SpeechOutputStatus = {
  __typename?: 'SpeechOutputStatus';
  failureMessage?: Maybe<Scalars['String']['output']>;
  generatingPriority?: Maybe<Scalars['GeneratingPriority']['output']>;
  /** Additional status info. E.g. more granular detail of the workflow status */
  info?: Maybe<Scalars['String']['output']>;
  modelId: Scalars['String']['output'];
  modelType: Scalars['String']['output'];
  stateEnum: GeneratingState;
};

export type SpeechOutputWhereInput = {
  AND?: InputMaybe<Array<SpeechOutputWhereInput>>;
  NOT?: InputMaybe<Array<SpeechOutputWhereInput>>;
  OR?: InputMaybe<Array<SpeechOutputWhereInput>>;
  audioFile?: InputMaybe<FileWhereInput>;
  audioFileSourceEnum?: InputMaybe<AudioFileSource>;
  audioFileSourceEnum_in?: InputMaybe<Array<AudioFileSource>>;
  correctionDraft?: InputMaybe<CorrectionDraftWhereInput>;
  forModelTypeEnum?: InputMaybe<SpeechOutputForModelTypeEnum>;
  forModelTypeEnum_in?: InputMaybe<Array<SpeechOutputForModelTypeEnum>>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  isAutoGenerated?: InputMaybe<Scalars['Boolean']['input']>;
  isBulkUpdate?: InputMaybe<Scalars['Boolean']['input']>;
  isCorrectionApplied?: InputMaybe<Scalars['Boolean']['input']>;
  isFavorite?: InputMaybe<Scalars['Boolean']['input']>;
  outputGroup?: InputMaybe<OutputGroupWhereInput>;
  segment?: InputMaybe<SegmentWhereInput>;
  speechInputData?: InputMaybe<SpeechInputDataWhereInput>;
  voice?: InputMaybe<VoiceWhereInput>;
  wasOutputFoundInCache?: InputMaybe<Scalars['Boolean']['input']>;
};

export type SpeechOutputWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export enum SplitAudioProvider {
  AudioShake = 'AudioShake',
  NoSplitAudio = 'NoSplitAudio',
  Uvr = 'UVR'
}

export type SrtTranscriptionPresignedPolicy = {
  __typename?: 'SrtTranscriptionPresignedPolicy';
  presignedPolicy: Scalars['Json']['output'];
};

export type SrtTranslationPresignedPolicy = {
  __typename?: 'SrtTranslationPresignedPolicy';
  channelId: Scalars['ID']['output'];
  presignedPolicy: Scalars['Json']['output'];
};

export type StateTransitionEvent = {
  __typename?: 'StateTransitionEvent';
  createdAt: Scalars['DateTime']['output'];
  createdBy?: Maybe<User>;
  event: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  modelId: Scalars['String']['output'];
  modelType: ModelType;
  newState: Scalars['String']['output'];
  previousState: Scalars['String']['output'];
  previousStateDurationMs: Scalars['Float']['output'];
  previousStateDurationSecStr?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

export enum StateTransitionEventOrderByInput {
  CreatedAtAsc = 'createdAt_ASC',
  CreatedAtDesc = 'createdAt_DESC',
  EventAsc = 'event_ASC',
  EventDesc = 'event_DESC',
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  ModelIdAsc = 'modelId_ASC',
  ModelIdDesc = 'modelId_DESC',
  ModelTypeAsc = 'modelType_ASC',
  ModelTypeDesc = 'modelType_DESC',
  NewStateAsc = 'newState_ASC',
  NewStateDesc = 'newState_DESC',
  PreviousStateDurationMsAsc = 'previousStateDurationMs_ASC',
  PreviousStateDurationMsDesc = 'previousStateDurationMs_DESC',
  PreviousStateAsc = 'previousState_ASC',
  PreviousStateDesc = 'previousState_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC'
}

export type StateTransitionEventWhereInput = {
  AND?: InputMaybe<Array<StateTransitionEventWhereInput>>;
  NOT?: InputMaybe<Array<StateTransitionEventWhereInput>>;
  OR?: InputMaybe<Array<StateTransitionEventWhereInput>>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_not_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  createdBy?: InputMaybe<UserWhereInput>;
  event?: InputMaybe<Scalars['String']['input']>;
  event_contains?: InputMaybe<Scalars['String']['input']>;
  event_ends_with?: InputMaybe<Scalars['String']['input']>;
  event_gt?: InputMaybe<Scalars['String']['input']>;
  event_gte?: InputMaybe<Scalars['String']['input']>;
  event_in?: InputMaybe<Array<Scalars['String']['input']>>;
  event_lt?: InputMaybe<Scalars['String']['input']>;
  event_lte?: InputMaybe<Scalars['String']['input']>;
  event_not?: InputMaybe<Scalars['String']['input']>;
  event_not_contains?: InputMaybe<Scalars['String']['input']>;
  event_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  event_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  event_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  event_starts_with?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  id_gt?: InputMaybe<Scalars['ID']['input']>;
  id_gte?: InputMaybe<Scalars['ID']['input']>;
  id_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_lt?: InputMaybe<Scalars['ID']['input']>;
  id_lte?: InputMaybe<Scalars['ID']['input']>;
  id_not?: InputMaybe<Scalars['ID']['input']>;
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  id_not_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  modelId?: InputMaybe<Scalars['String']['input']>;
  modelId_contains?: InputMaybe<Scalars['String']['input']>;
  modelId_ends_with?: InputMaybe<Scalars['String']['input']>;
  modelId_gt?: InputMaybe<Scalars['String']['input']>;
  modelId_gte?: InputMaybe<Scalars['String']['input']>;
  modelId_in?: InputMaybe<Array<Scalars['String']['input']>>;
  modelId_lt?: InputMaybe<Scalars['String']['input']>;
  modelId_lte?: InputMaybe<Scalars['String']['input']>;
  modelId_not?: InputMaybe<Scalars['String']['input']>;
  modelId_not_contains?: InputMaybe<Scalars['String']['input']>;
  modelId_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  modelId_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  modelId_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  modelId_starts_with?: InputMaybe<Scalars['String']['input']>;
  modelType?: InputMaybe<ModelType>;
  modelType_in?: InputMaybe<Array<ModelType>>;
  modelType_not?: InputMaybe<ModelType>;
  modelType_not_in?: InputMaybe<Array<ModelType>>;
  newState?: InputMaybe<Scalars['String']['input']>;
  newState_contains?: InputMaybe<Scalars['String']['input']>;
  newState_ends_with?: InputMaybe<Scalars['String']['input']>;
  newState_gt?: InputMaybe<Scalars['String']['input']>;
  newState_gte?: InputMaybe<Scalars['String']['input']>;
  newState_in?: InputMaybe<Array<Scalars['String']['input']>>;
  newState_lt?: InputMaybe<Scalars['String']['input']>;
  newState_lte?: InputMaybe<Scalars['String']['input']>;
  newState_not?: InputMaybe<Scalars['String']['input']>;
  newState_not_contains?: InputMaybe<Scalars['String']['input']>;
  newState_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  newState_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  newState_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  newState_starts_with?: InputMaybe<Scalars['String']['input']>;
  previousState?: InputMaybe<Scalars['String']['input']>;
  previousStateDurationMs?: InputMaybe<Scalars['Float']['input']>;
  previousStateDurationMs_gt?: InputMaybe<Scalars['Float']['input']>;
  previousStateDurationMs_gte?: InputMaybe<Scalars['Float']['input']>;
  previousStateDurationMs_in?: InputMaybe<Array<Scalars['Float']['input']>>;
  previousStateDurationMs_lt?: InputMaybe<Scalars['Float']['input']>;
  previousStateDurationMs_lte?: InputMaybe<Scalars['Float']['input']>;
  previousStateDurationMs_not?: InputMaybe<Scalars['Float']['input']>;
  previousStateDurationMs_not_in?: InputMaybe<Array<Scalars['Float']['input']>>;
  previousState_contains?: InputMaybe<Scalars['String']['input']>;
  previousState_ends_with?: InputMaybe<Scalars['String']['input']>;
  previousState_gt?: InputMaybe<Scalars['String']['input']>;
  previousState_gte?: InputMaybe<Scalars['String']['input']>;
  previousState_in?: InputMaybe<Array<Scalars['String']['input']>>;
  previousState_lt?: InputMaybe<Scalars['String']['input']>;
  previousState_lte?: InputMaybe<Scalars['String']['input']>;
  previousState_not?: InputMaybe<Scalars['String']['input']>;
  previousState_not_contains?: InputMaybe<Scalars['String']['input']>;
  previousState_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  previousState_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  previousState_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  previousState_starts_with?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_not_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
};

export type StateTransitionEventWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export enum SupportedPageEnumType {
  ChannelDetails = 'channelDetails',
  Dashboard = 'dashboard',
  OutputReview = 'outputReview',
  Rewrite = 'rewrite',
  Scoping = 'scoping',
  Speech = 'speech',
  Studio = 'studio',
  StudioTunedMode = 'studioTunedMode',
  Transcription = 'transcription',
  Translation = 'translation',
  VideoDetails = 'videoDetails',
  Voice = 'voice'
}

export enum TvStudioStageState {
  Full = 'Full',
  Speech = 'Speech',
  Transcription = 'Transcription',
  Translation = 'Translation'
}

export type ThirdPartyTtsData = {
  __typename?: 'ThirdPartyTtsData';
  audioFile?: Maybe<File>;
  chatterboxStorageKey?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  request: Scalars['Json']['output'];
  requestHash: Scalars['String']['output'];
  ttsSourceEnum: TtsSource;
  updatedAt: Scalars['DateTime']['output'];
  workflowId?: Maybe<Scalars['String']['output']>;
  workflowRunId?: Maybe<Scalars['String']['output']>;
};

export type Track = {
  __typename?: 'Track';
  createdAt: Scalars['DateTime']['output'];
  file: File;
  id: Scalars['ID']['output'];
  includeInOutput: Scalars['Boolean']['output'];
  name?: Maybe<Scalars['String']['output']>;
  sourceVideo: SourceVideo;
  splitAudioProvider: SplitAudioProvider;
  trackType: TrackType;
  updatedAt: Scalars['DateTime']['output'];
  uploadedBy?: Maybe<User>;
  volumeAdj: Scalars['Float']['output'];
};

export enum TrackOrderByInput {
  CreatedAtAsc = 'createdAt_ASC',
  CreatedAtDesc = 'createdAt_DESC',
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  IncludeInOutputAsc = 'includeInOutput_ASC',
  IncludeInOutputDesc = 'includeInOutput_DESC',
  NameAsc = 'name_ASC',
  NameDesc = 'name_DESC',
  SplitAudioProviderAsc = 'splitAudioProvider_ASC',
  SplitAudioProviderDesc = 'splitAudioProvider_DESC',
  TrackTypeAsc = 'trackType_ASC',
  TrackTypeDesc = 'trackType_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC',
  VolumeAdjAsc = 'volumeAdj_ASC',
  VolumeAdjDesc = 'volumeAdj_DESC'
}

export enum TrackType {
  Dialogue = 'Dialogue',
  MusicAndEffects = 'MusicAndEffects'
}

export type TrackUpdateInput = {
  includeInOutput?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  volumeAdj?: InputMaybe<Scalars['Float']['input']>;
};

export type TrackWhereInput = {
  AND?: InputMaybe<Array<TrackWhereInput>>;
  NOT?: InputMaybe<Array<TrackWhereInput>>;
  OR?: InputMaybe<Array<TrackWhereInput>>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_not_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  file?: InputMaybe<TrackWhereInput_Relation>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  id_gt?: InputMaybe<Scalars['ID']['input']>;
  id_gte?: InputMaybe<Scalars['ID']['input']>;
  id_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_lt?: InputMaybe<Scalars['ID']['input']>;
  id_lte?: InputMaybe<Scalars['ID']['input']>;
  id_not?: InputMaybe<Scalars['ID']['input']>;
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  id_not_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  includeInOutput?: InputMaybe<Scalars['Boolean']['input']>;
  includeInOutput_not?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_contains?: InputMaybe<Scalars['String']['input']>;
  name_ends_with?: InputMaybe<Scalars['String']['input']>;
  name_gt?: InputMaybe<Scalars['String']['input']>;
  name_gte?: InputMaybe<Scalars['String']['input']>;
  name_in?: InputMaybe<Array<Scalars['String']['input']>>;
  name_lt?: InputMaybe<Scalars['String']['input']>;
  name_lte?: InputMaybe<Scalars['String']['input']>;
  name_not?: InputMaybe<Scalars['String']['input']>;
  name_not_contains?: InputMaybe<Scalars['String']['input']>;
  name_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  name_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  name_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  name_starts_with?: InputMaybe<Scalars['String']['input']>;
  sourceVideo?: InputMaybe<TrackWhereInput_Relation>;
  splitAudioProvider?: InputMaybe<SplitAudioProvider>;
  splitAudioProvider_in?: InputMaybe<Array<SplitAudioProvider>>;
  splitAudioProvider_not?: InputMaybe<SplitAudioProvider>;
  splitAudioProvider_not_in?: InputMaybe<Array<SplitAudioProvider>>;
  trackType?: InputMaybe<TrackType>;
  trackType_in?: InputMaybe<Array<TrackType>>;
  trackType_not?: InputMaybe<TrackType>;
  trackType_not_in?: InputMaybe<Array<TrackType>>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_not_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  uploadedBy?: InputMaybe<TrackWhereInput_Relation>;
  volumeAdj?: InputMaybe<Scalars['Float']['input']>;
  volumeAdj_gt?: InputMaybe<Scalars['Float']['input']>;
  volumeAdj_gte?: InputMaybe<Scalars['Float']['input']>;
  volumeAdj_in?: InputMaybe<Array<Scalars['Float']['input']>>;
  volumeAdj_lt?: InputMaybe<Scalars['Float']['input']>;
  volumeAdj_lte?: InputMaybe<Scalars['Float']['input']>;
  volumeAdj_not?: InputMaybe<Scalars['Float']['input']>;
  volumeAdj_not_in?: InputMaybe<Array<Scalars['Float']['input']>>;
};

export type TrackWhereInput_Relation = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type TrackWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export enum TranscriptionProvider {
  Deepgram = 'Deepgram',
  DeepgramNova2 = 'DeepgramNova2',
  Gemini = 'Gemini',
  GoogleAsr = 'GoogleASR',
  HappyScribeTranscriptionAuto = 'HappyScribeTranscriptionAuto',
  HappyScribeTranscriptionHitl = 'HappyScribeTranscriptionHitl',
  HappyScribeTranscriptionUpload = 'HappyScribeTranscriptionUpload',
  ManualTranscriptionTranslationUpload = 'ManualTranscriptionTranslationUpload',
  ManualTranscriptionUpload = 'ManualTranscriptionUpload',
  Speechmatics = 'Speechmatics'
}

export type TranslatedChannel = {
  __typename?: 'TranslatedChannel';
  QAer?: Maybe<User>;
  audioRefinementParams?: Maybe<Scalars['Json']['output']>;
  audioRefinementProvider: AudioRefinementProvider;
  createdAt: Scalars['DateTime']['output'];
  defaultSpeaker?: Maybe<Speaker>;
  editor?: Maybe<User>;
  editorQC?: Maybe<User>;
  /** DEPRECATED in favour of flagsmith */
  featureFlags?: Maybe<Scalars['Json']['output']>;
  frameioExportOutputTypes: Array<OutputType>;
  generatingPriority?: Maybe<Scalars['Float']['output']>;
  id: Scalars['ID']['output'];
  /** DEPRECATED */
  initialAutoStretchRateEnabled: Scalars['Boolean']['output'];
  isAblyEnabled: Scalars['Boolean']['output'];
  language: Scalars['String']['output'];
  /** Metadata for the Translated Channel */
  metadata?: Maybe<Scalars['Json']['output']>;
  prepareSegmentsMethod: PrepareSegmentsMethod;
  qc?: Maybe<User>;
  requiresAnEditor: Scalars['Boolean']['output'];
  scheduleDays: Array<DaysOfWeek>;
  scheduleFrequency?: Maybe<Frequency>;
  schedulePublishingTime?: Maybe<Scalars['DateTime']['output']>;
  scheduleUploads?: Maybe<Scalars['Int']['output']>;
  shouldAutoGenerateInitialOutput: Scalars['Boolean']['output'];
  /** DEPRECATED */
  shouldTranscribeAudio: Scalars['Boolean']['output'];
  sourceChannel: SourceChannel;
  speakerUpdateRetroactivity: SpeakerUpdateRetroactivity;
  speakers: Array<Speaker>;
  /** @deprecated Use speechEditingQAers — a stage can have several specialists (PPC-711). */
  speechEditingQAer?: Maybe<User>;
  speechEditingQAers: Array<User>;
  targetMinutePerMinute?: Maybe<Scalars['Float']['output']>;
  title: Scalars['String']['output'];
  /** @deprecated Use transcriptionQAers — a stage can have several specialists (PPC-711). */
  transcriptionQAer?: Maybe<User>;
  transcriptionQAers: Array<User>;
  translatedVideos?: Maybe<Array<TranslatedVideo>>;
  /** The number of translated videos belonging to this channel */
  translatedVideosCount: Scalars['Int']['output'];
  /** @deprecated Use translationQAers — a stage can have several specialists (PPC-711). */
  translationQAer?: Maybe<User>;
  translationQAers: Array<User>;
  updatedAt: Scalars['DateTime']['output'];
  voiceActor?: Maybe<User>;
  voiceActorPerSpeakerEnabled: Scalars['Boolean']['output'];
};


export type TranslatedChannelSpeakersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<SpeakerOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<SpeakerWhereInput>;
};


export type TranslatedChannelTranslatedVideosArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<TranslatedVideoOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<TranslatedVideoWhereInput>;
};


export type TranslatedChannelTranslatedVideosCountArgs = {
  where?: InputMaybe<TranslatedVideoWhereInput>;
};

export enum TranslatedChannelOrderByInput {
  AudioRefinementParamsAsc = 'audioRefinementParams_ASC',
  AudioRefinementParamsDesc = 'audioRefinementParams_DESC',
  AudioRefinementProviderAsc = 'audioRefinementProvider_ASC',
  AudioRefinementProviderDesc = 'audioRefinementProvider_DESC',
  CreatedAtAsc = 'createdAt_ASC',
  CreatedAtDesc = 'createdAt_DESC',
  FeatureFlagsAsc = 'featureFlags_ASC',
  FeatureFlagsDesc = 'featureFlags_DESC',
  GeneratingPriorityAsc = 'generatingPriority_ASC',
  GeneratingPriorityDesc = 'generatingPriority_DESC',
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  InitialAutoStretchRateEnabledAsc = 'initialAutoStretchRateEnabled_ASC',
  InitialAutoStretchRateEnabledDesc = 'initialAutoStretchRateEnabled_DESC',
  IsAblyEnabledAsc = 'isAblyEnabled_ASC',
  IsAblyEnabledDesc = 'isAblyEnabled_DESC',
  LanguageAsc = 'language_ASC',
  LanguageDesc = 'language_DESC',
  MetadataAsc = 'metadata_ASC',
  MetadataDesc = 'metadata_DESC',
  PrepareSegmentsMethodAsc = 'prepareSegmentsMethod_ASC',
  PrepareSegmentsMethodDesc = 'prepareSegmentsMethod_DESC',
  RequiresAnEditorAsc = 'requiresAnEditor_ASC',
  RequiresAnEditorDesc = 'requiresAnEditor_DESC',
  ScheduleFrequencyAsc = 'scheduleFrequency_ASC',
  ScheduleFrequencyDesc = 'scheduleFrequency_DESC',
  SchedulePublishingTimeAsc = 'schedulePublishingTime_ASC',
  SchedulePublishingTimeDesc = 'schedulePublishingTime_DESC',
  ScheduleUploadsAsc = 'scheduleUploads_ASC',
  ScheduleUploadsDesc = 'scheduleUploads_DESC',
  ShouldAutoGenerateInitialOutputAsc = 'shouldAutoGenerateInitialOutput_ASC',
  ShouldAutoGenerateInitialOutputDesc = 'shouldAutoGenerateInitialOutput_DESC',
  ShouldTranscribeAudioAsc = 'shouldTranscribeAudio_ASC',
  ShouldTranscribeAudioDesc = 'shouldTranscribeAudio_DESC',
  SpeakerUpdateRetroactivityAsc = 'speakerUpdateRetroactivity_ASC',
  SpeakerUpdateRetroactivityDesc = 'speakerUpdateRetroactivity_DESC',
  TargetMinutePerMinuteAsc = 'targetMinutePerMinute_ASC',
  TargetMinutePerMinuteDesc = 'targetMinutePerMinute_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC',
  VoiceActorPerSpeakerEnabledAsc = 'voiceActorPerSpeakerEnabled_ASC',
  VoiceActorPerSpeakerEnabledDesc = 'voiceActorPerSpeakerEnabled_DESC'
}

export type TranslatedChannelUpdateInput = {
  QAer?: InputMaybe<UserUpdateOneInput>;
  audioRefinementParams?: InputMaybe<Scalars['Json']['input']>;
  audioRefinementProvider?: InputMaybe<AudioRefinementProvider>;
  defaultSpeaker?: InputMaybe<SpeakerUpdateOneInput>;
  editor?: InputMaybe<UserUpdateOneInput>;
  editorQC?: InputMaybe<UserUpdateOneInput>;
  featureFlags?: InputMaybe<Scalars['Json']['input']>;
  frameioExportOutputTypes?: InputMaybe<Array<OutputType>>;
  generatingPriority?: InputMaybe<Scalars['Float']['input']>;
  initialAutoStretchRateEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  isAblyEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  language?: InputMaybe<Scalars['String']['input']>;
  metadata?: InputMaybe<Scalars['Json']['input']>;
  prepareSegmentsMethod?: InputMaybe<PrepareSegmentsMethod>;
  qc?: InputMaybe<UserUpdateOneInput>;
  requiresAnEditor?: InputMaybe<Scalars['Boolean']['input']>;
  scheduleFrequency?: InputMaybe<Frequency>;
  schedulePublishingTime?: InputMaybe<Scalars['DateTime']['input']>;
  scheduleUploads?: InputMaybe<Scalars['Int']['input']>;
  shouldAutoGenerateInitialOutput?: InputMaybe<Scalars['Boolean']['input']>;
  shouldTranscribeAudio?: InputMaybe<Scalars['Boolean']['input']>;
  speakerUpdateRetroactivity?: InputMaybe<SpeakerUpdateRetroactivity>;
  speakers?: InputMaybe<SpeakerUpdateManyWithoutChannelInput>;
  speechEditingQAer?: InputMaybe<UserUpdateOneInput>;
  speechEditingQAers?: InputMaybe<UserUpdateManyInput>;
  targetMinutePerMinute?: InputMaybe<Scalars['Float']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  transcriptionQAer?: InputMaybe<UserUpdateOneInput>;
  transcriptionQAers?: InputMaybe<UserUpdateManyInput>;
  translationQAer?: InputMaybe<UserUpdateOneInput>;
  translationQAers?: InputMaybe<UserUpdateManyInput>;
  voiceActor?: InputMaybe<UserUpdateOneInput>;
  voiceActorPerSpeakerEnabled?: InputMaybe<Scalars['Boolean']['input']>;
};

export type TranslatedChannelWhereInput = {
  AND?: InputMaybe<Array<TranslatedChannelWhereInput>>;
  NOT?: InputMaybe<Array<TranslatedChannelWhereInput>>;
  OR?: InputMaybe<Array<TranslatedChannelWhereInput>>;
  QAer?: InputMaybe<UserWhereInput>;
  audioRefinementProvider?: InputMaybe<AudioRefinementProvider>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_not_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  editor?: InputMaybe<UserWhereInput>;
  editorQC?: InputMaybe<UserWhereInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  id_gt?: InputMaybe<Scalars['ID']['input']>;
  id_gte?: InputMaybe<Scalars['ID']['input']>;
  id_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_lt?: InputMaybe<Scalars['ID']['input']>;
  id_lte?: InputMaybe<Scalars['ID']['input']>;
  id_not?: InputMaybe<Scalars['ID']['input']>;
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  id_not_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  initialAutoStretchRateEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  initialAutoStretchRateEnabled_not?: InputMaybe<Scalars['Boolean']['input']>;
  isAblyEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  isAblyEnabled_not?: InputMaybe<Scalars['Boolean']['input']>;
  language?: InputMaybe<Scalars['String']['input']>;
  language_contains?: InputMaybe<Scalars['String']['input']>;
  language_ends_with?: InputMaybe<Scalars['String']['input']>;
  language_gt?: InputMaybe<Scalars['String']['input']>;
  language_gte?: InputMaybe<Scalars['String']['input']>;
  language_in?: InputMaybe<Array<Scalars['String']['input']>>;
  language_lt?: InputMaybe<Scalars['String']['input']>;
  language_lte?: InputMaybe<Scalars['String']['input']>;
  language_not?: InputMaybe<Scalars['String']['input']>;
  language_not_contains?: InputMaybe<Scalars['String']['input']>;
  language_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  language_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  language_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  language_starts_with?: InputMaybe<Scalars['String']['input']>;
  prepareSegmentsMethod?: InputMaybe<PrepareSegmentsMethod>;
  qc?: InputMaybe<UserWhereInput>;
  requiresAnEditor?: InputMaybe<Scalars['Boolean']['input']>;
  requiresAnEditor_not?: InputMaybe<Scalars['Boolean']['input']>;
  scheduleFrequency?: InputMaybe<Frequency>;
  shouldAutoGenerateInitialOutput?: InputMaybe<Scalars['Boolean']['input']>;
  shouldAutoGenerateInitialOutput_not?: InputMaybe<Scalars['Boolean']['input']>;
  shouldTranscribeAudio?: InputMaybe<Scalars['Boolean']['input']>;
  shouldTranscribeAudio_not?: InputMaybe<Scalars['Boolean']['input']>;
  sourceChannel?: InputMaybe<SourceChannelWhereInput>;
  speakerUpdateRetroactivity?: InputMaybe<SpeakerUpdateRetroactivity>;
  speechEditingQAer?: InputMaybe<UserWhereInput>;
  title?: InputMaybe<Scalars['String']['input']>;
  title_contains?: InputMaybe<Scalars['String']['input']>;
  title_ends_with?: InputMaybe<Scalars['String']['input']>;
  title_gt?: InputMaybe<Scalars['String']['input']>;
  title_gte?: InputMaybe<Scalars['String']['input']>;
  title_in?: InputMaybe<Array<Scalars['String']['input']>>;
  title_lt?: InputMaybe<Scalars['String']['input']>;
  title_lte?: InputMaybe<Scalars['String']['input']>;
  title_not?: InputMaybe<Scalars['String']['input']>;
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  title_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  title_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  title_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  title_starts_with?: InputMaybe<Scalars['String']['input']>;
  transcriptionQAer?: InputMaybe<UserWhereInput>;
  translationQAer?: InputMaybe<UserWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_not_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  voiceActor?: InputMaybe<UserWhereInput>;
  voiceActorPerSpeakerEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  voiceActorPerSpeakerEnabled_not?: InputMaybe<Scalars['Boolean']['input']>;
};

export type TranslatedChannelWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type TranslatedVideo = {
  __typename?: 'TranslatedVideo';
  addedBy?: Maybe<User>;
  asrModel: Scalars['String']['output'];
  audibleOverlaps: Scalars['Boolean']['output'];
  audioEngineer?: Maybe<User>;
  audioEngineerDueDate?: Maybe<Scalars['DateTime']['output']>;
  availableMLConfigs?: Maybe<Scalars['Json']['output']>;
  /** availableVoiceControls defined in the chatterbox config for the first TTS config in availableMLConfigs */
  availableVoiceControls?: Maybe<Scalars['Json']['output']>;
  channel: TranslatedChannel;
  channelMetadata?: Maybe<Scalars['Json']['output']>;
  context?: Maybe<Context>;
  createdAt: Scalars['DateTime']['output'];
  /** The number of unarchived segments in this translatedVideo */
  doneSegmentsCount: Scalars['Int']['output'];
  dueDate?: Maybe<Scalars['DateTime']['output']>;
  editor?: Maybe<User>;
  editorDueDate?: Maybe<Scalars['DateTime']['output']>;
  editorQC?: Maybe<User>;
  editorQCDueDate?: Maybe<Scalars['DateTime']['output']>;
  featureFlags?: Maybe<Scalars['Json']['output']>;
  hasInitialAutoStretchRate: Scalars['Boolean']['output'];
  hasSegmentTextChanged: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  invoiceItem?: Maybe<InvoiceItem>;
  isDatamodelV3: Scalars['Boolean']['output'];
  isStudioStagesEnabled: Scalars['Boolean']['output'];
  /** The most recent OutputGroup generated for this video */
  latestOutputGroup?: Maybe<OutputGroup>;
  mappedSpeakersResponse?: Maybe<File>;
  markedCompleteBy?: Maybe<User>;
  metadata?: Maybe<Scalars['Json']['output']>;
  notes: Array<Note>;
  onScreenTexts: Array<Maybe<OnScreenTextTranslation>>;
  outputGroups: Array<OutputGroup>;
  prepareSegmentsMethod: PrepareSegmentsMethod;
  prepareSegmentsResponse?: Maybe<File>;
  qaer?: Maybe<User>;
  qc?: Maybe<User>;
  qcDueDate?: Maybe<Scalars['DateTime']['output']>;
  requiresAnEditor: Scalars['Boolean']['output'];
  reviewedBy?: Maybe<User>;
  s3root: Scalars['String']['output'];
  scriptCsvUploadType?: Maybe<ScriptCsvUploadType>;
  /** The number of unarchived segments in this translatedVideo */
  segmentCount: Scalars['Int']['output'];
  segments: Array<Segment>;
  /** Summary of segments grouped by speaker, including completion status and mimic file presence */
  segmentsSummary: Scalars['Json']['output'];
  shouldAutoGenerateInitialOutput: Scalars['Boolean']['output'];
  shouldTranscribeAudio: Scalars['Boolean']['output'];
  snapshots: Array<TranslatedVideoSnapshot>;
  sourceVideo: SourceVideo;
  /** @deprecated Use speechEditingQAers — a stage can have several specialists (PPC-711). */
  speechEditingQAer?: Maybe<User>;
  speechEditingQAerDueDate?: Maybe<Scalars['DateTime']['output']>;
  speechEditingQAers: Array<User>;
  stateValue: TranslatedVideoState;
  tags: Array<Scalars['String']['output']>;
  targetMinutePerMinute?: Maybe<Scalars['Float']['output']>;
  targetTranscriptFile?: Maybe<File>;
  title?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use transcriptionQAers — a stage can have several specialists (PPC-711). */
  transcriptionQAer?: Maybe<User>;
  transcriptionQAerDueDate?: Maybe<Scalars['DateTime']['output']>;
  transcriptionQAers: Array<User>;
  translatedDescription?: Maybe<Scalars['String']['output']>;
  translatedTitle?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use translationQAers — a stage can have several specialists (PPC-711). */
  translationQAer?: Maybe<User>;
  translationQAerDueDate?: Maybe<Scalars['DateTime']['output']>;
  translationQAers: Array<User>;
  tvStudioStageState: TvStudioStageState;
  updatedAt: Scalars['DateTime']['output'];
  uploadedCsvFile?: Maybe<File>;
  /** Distinct Speakers assigned via speakerOverride to this video's non-archived segments. */
  usedCharacters: Array<Speaker>;
  videoComplexityCalculated?: Maybe<Scalars['Int']['output']>;
  videoComplexityQA?: Maybe<Scalars['Int']['output']>;
  videoComplexityQC?: Maybe<Scalars['Int']['output']>;
  videoComplexityRating: Array<VideoComplexityRating>;
  voiceActor?: Maybe<User>;
  voiceActorDueDate?: Maybe<Scalars['DateTime']['output']>;
  voiceActorQC?: Maybe<User>;
  voiceActorQCDueDate?: Maybe<Scalars['DateTime']['output']>;
  wasMigratedToV3: Scalars['Boolean']['output'];
  workableDurationSec?: Maybe<Scalars['Int']['output']>;
  /** The number of unarchived segments in this translatedVideo, within the workable duration */
  workableDurationSegmentCount: Scalars['Int']['output'];
};


export type TranslatedVideoDoneSegmentsCountArgs = {
  studioStage?: InputMaybe<TvStudioStageState>;
};


export type TranslatedVideoNotesArgs = {
  orderBy?: InputMaybe<NoteOrderByInput>;
  where?: InputMaybe<NoteWhereInput>;
};


export type TranslatedVideoOnScreenTextsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<OnScreenTextTranslationWhereInput>;
};


export type TranslatedVideoOutputGroupsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OutputGroupOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<OutputGroupWhereInput>;
};


export type TranslatedVideoSegmentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<SegmentOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<SegmentWhereInput>;
};


export type TranslatedVideoSnapshotsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type TranslatedVideoVideoComplexityRatingArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};

export type TranslatedVideoCreateOneInput = {
  connect?: InputMaybe<TranslatedVideoWhereUniqueInput>;
};

export type TranslatedVideoCreateOneWithoutSegmentsInput = {
  connect?: InputMaybe<TranslatedVideoWhereUniqueInput>;
};

export enum TranslatedVideoEventEnumType {
  Complete = 'Complete',
  GeneratingOutput = 'GeneratingOutput',
  InProgressQa = 'InProgressQA',
  InProgressReview = 'InProgressReview',
  InProgressVoiceActing = 'InProgressVoiceActing',
  OutputGenerated = 'OutputGenerated',
  PreparingSegmentsComplete = 'PreparingSegmentsComplete',
  ReadyForPostProduction = 'ReadyForPostProduction',
  ReadyForReview = 'ReadyForReview',
  ReadyForVoiceActing = 'ReadyForVoiceActing',
  ReopenVideo = 'ReopenVideo',
  SendForRevision = 'SendForRevision',
  UndoApprove = 'UndoApprove',
  VoiceActingComplete = 'VoiceActingComplete'
}

export enum TranslatedVideoOrderByInput {
  AsrModelAsc = 'asrModel_ASC',
  AsrModelDesc = 'asrModel_DESC',
  AudibleOverlapsAsc = 'audibleOverlaps_ASC',
  AudibleOverlapsDesc = 'audibleOverlaps_DESC',
  AudioEngineerDueDateAsc = 'audioEngineerDueDate_ASC',
  AudioEngineerDueDateDesc = 'audioEngineerDueDate_DESC',
  AvailableMlConfigsAsc = 'availableMLConfigs_ASC',
  AvailableMlConfigsDesc = 'availableMLConfigs_DESC',
  ChannelMetadataAsc = 'channelMetadata_ASC',
  ChannelMetadataDesc = 'channelMetadata_DESC',
  CreatedAtAsc = 'createdAt_ASC',
  CreatedAtDesc = 'createdAt_DESC',
  DueDateAsc = 'dueDate_ASC',
  DueDateDesc = 'dueDate_DESC',
  EditorDueDateAsc = 'editorDueDate_ASC',
  EditorDueDateDesc = 'editorDueDate_DESC',
  EditorQcDueDateAsc = 'editorQCDueDate_ASC',
  EditorQcDueDateDesc = 'editorQCDueDate_DESC',
  FeatureFlagsAsc = 'featureFlags_ASC',
  FeatureFlagsDesc = 'featureFlags_DESC',
  HasInitialAutoStretchRateAsc = 'hasInitialAutoStretchRate_ASC',
  HasInitialAutoStretchRateDesc = 'hasInitialAutoStretchRate_DESC',
  HasSegmentTextChangedAsc = 'hasSegmentTextChanged_ASC',
  HasSegmentTextChangedDesc = 'hasSegmentTextChanged_DESC',
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  IsDatamodelV3Asc = 'isDatamodelV3_ASC',
  IsDatamodelV3Desc = 'isDatamodelV3_DESC',
  IsStudioStagesEnabledAsc = 'isStudioStagesEnabled_ASC',
  IsStudioStagesEnabledDesc = 'isStudioStagesEnabled_DESC',
  MetadataAsc = 'metadata_ASC',
  MetadataDesc = 'metadata_DESC',
  PrepareSegmentsMethodAsc = 'prepareSegmentsMethod_ASC',
  PrepareSegmentsMethodDesc = 'prepareSegmentsMethod_DESC',
  QcDueDateAsc = 'qcDueDate_ASC',
  QcDueDateDesc = 'qcDueDate_DESC',
  RequiresAnEditorAsc = 'requiresAnEditor_ASC',
  RequiresAnEditorDesc = 'requiresAnEditor_DESC',
  S3rootAsc = 's3root_ASC',
  S3rootDesc = 's3root_DESC',
  ShouldAutoGenerateInitialOutputAsc = 'shouldAutoGenerateInitialOutput_ASC',
  ShouldAutoGenerateInitialOutputDesc = 'shouldAutoGenerateInitialOutput_DESC',
  ShouldTranscribeAudioAsc = 'shouldTranscribeAudio_ASC',
  ShouldTranscribeAudioDesc = 'shouldTranscribeAudio_DESC',
  StateValueAsc = 'stateValue_ASC',
  StateValueDesc = 'stateValue_DESC',
  TargetMinutePerMinuteAsc = 'targetMinutePerMinute_ASC',
  TargetMinutePerMinuteDesc = 'targetMinutePerMinute_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC',
  TranslatedDescriptionAsc = 'translatedDescription_ASC',
  TranslatedDescriptionDesc = 'translatedDescription_DESC',
  TranslatedTitleAsc = 'translatedTitle_ASC',
  TranslatedTitleDesc = 'translatedTitle_DESC',
  TvStudioStageStateAsc = 'tvStudioStageState_ASC',
  TvStudioStageStateDesc = 'tvStudioStageState_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC',
  VideoComplexityCalculatedAsc = 'videoComplexityCalculated_ASC',
  VideoComplexityCalculatedDesc = 'videoComplexityCalculated_DESC',
  VideoComplexityQaAsc = 'videoComplexityQA_ASC',
  VideoComplexityQaDesc = 'videoComplexityQA_DESC',
  VideoComplexityQcAsc = 'videoComplexityQC_ASC',
  VideoComplexityQcDesc = 'videoComplexityQC_DESC',
  VoiceActorDueDateAsc = 'voiceActorDueDate_ASC',
  VoiceActorDueDateDesc = 'voiceActorDueDate_DESC',
  VoiceActorQcDueDateAsc = 'voiceActorQCDueDate_ASC',
  VoiceActorQcDueDateDesc = 'voiceActorQCDueDate_DESC',
  WasMigratedToV3Asc = 'wasMigratedToV3_ASC',
  WasMigratedToV3Desc = 'wasMigratedToV3_DESC',
  WorkableDurationSecAsc = 'workableDurationSec_ASC',
  WorkableDurationSecDesc = 'workableDurationSec_DESC'
}

export type TranslatedVideoPartsPresignedPolicies = {
  __typename?: 'TranslatedVideoPartsPresignedPolicies';
  parts: Array<PartPresignedPolicy>;
  translatedVideoId: Scalars['ID']['output'];
};

export type TranslatedVideoSnapshot = {
  __typename?: 'TranslatedVideoSnapshot';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  /** Number of Segments in the Snapshot where endpoint is overlapping another Segment or the end of the video */
  overlappingSegmentCount: Scalars['Int']['output'];
  /** Number of Segments in the Snapshot */
  segmentCount: Scalars['Int']['output'];
  segmentSnapshots?: Maybe<Array<SegmentSnapshot>>;
  snapshotType: VideoSnapshotType;
  totalOverlapDurationSec: Scalars['Float']['output'];
  transcriptionProvider: TranscriptionProvider;
  translatedVideo: TranslatedVideo;
  updatedAt: Scalars['DateTime']['output'];
};


export type TranslatedVideoSnapshotSegmentSnapshotsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<SegmentSnapshotOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<SegmentSnapshotWhereInput>;
};

export enum TranslatedVideoSnapshotOrderByInput {
  CreatedAtAsc = 'createdAt_ASC',
  CreatedAtDesc = 'createdAt_DESC',
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  SnapshotTypeAsc = 'snapshotType_ASC',
  SnapshotTypeDesc = 'snapshotType_DESC',
  TotalOverlapDurationSecAsc = 'totalOverlapDurationSec_ASC',
  TotalOverlapDurationSecDesc = 'totalOverlapDurationSec_DESC',
  TranscriptionProviderAsc = 'transcriptionProvider_ASC',
  TranscriptionProviderDesc = 'transcriptionProvider_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC'
}

export type TranslatedVideoSnapshotWhereInput = {
  AND?: InputMaybe<Array<TranslatedVideoSnapshotWhereInput>>;
  NOT?: InputMaybe<Array<TranslatedVideoSnapshotWhereInput>>;
  OR?: InputMaybe<Array<TranslatedVideoSnapshotWhereInput>>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_not_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  id_gt?: InputMaybe<Scalars['ID']['input']>;
  id_gte?: InputMaybe<Scalars['ID']['input']>;
  id_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_lt?: InputMaybe<Scalars['ID']['input']>;
  id_lte?: InputMaybe<Scalars['ID']['input']>;
  id_not?: InputMaybe<Scalars['ID']['input']>;
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  id_not_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  segmentSnapshots_every?: InputMaybe<TranslatedVideoSnapshotWhereInput_SegmentSnapshots>;
  segmentSnapshots_none?: InputMaybe<TranslatedVideoSnapshotWhereInput_SegmentSnapshots>;
  segmentSnapshots_some?: InputMaybe<TranslatedVideoSnapshotWhereInput_SegmentSnapshots>;
  snapshotType?: InputMaybe<VideoSnapshotType>;
  snapshotType_in?: InputMaybe<Array<VideoSnapshotType>>;
  snapshotType_not?: InputMaybe<VideoSnapshotType>;
  snapshotType_not_in?: InputMaybe<Array<VideoSnapshotType>>;
  totalOverlapDurationSec?: InputMaybe<Scalars['Float']['input']>;
  totalOverlapDurationSec_gt?: InputMaybe<Scalars['Float']['input']>;
  totalOverlapDurationSec_gte?: InputMaybe<Scalars['Float']['input']>;
  totalOverlapDurationSec_in?: InputMaybe<Array<Scalars['Float']['input']>>;
  totalOverlapDurationSec_lt?: InputMaybe<Scalars['Float']['input']>;
  totalOverlapDurationSec_lte?: InputMaybe<Scalars['Float']['input']>;
  totalOverlapDurationSec_not?: InputMaybe<Scalars['Float']['input']>;
  totalOverlapDurationSec_not_in?: InputMaybe<Array<Scalars['Float']['input']>>;
  transcriptionProvider?: InputMaybe<TranscriptionProvider>;
  transcriptionProvider_in?: InputMaybe<Array<TranscriptionProvider>>;
  transcriptionProvider_not?: InputMaybe<TranscriptionProvider>;
  transcriptionProvider_not_in?: InputMaybe<Array<TranscriptionProvider>>;
  translatedVideo?: InputMaybe<TranslatedVideoSnapshotWhereInput_Relation>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_not_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
};

export type TranslatedVideoSnapshotWhereInput_Relation = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type TranslatedVideoSnapshotWhereInput_SegmentSnapshots = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type TranslatedVideoSnapshotWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export enum TranslatedVideoState {
  Complete = 'Complete',
  Failed = 'Failed',
  GeneratingInitialOutput = 'GeneratingInitialOutput',
  GeneratingOutput = 'GeneratingOutput',
  InProgressQa = 'InProgressQA',
  InProgressReview = 'InProgressReview',
  InProgressRevision = 'InProgressRevision',
  InProgressVoiceActing = 'InProgressVoiceActing',
  Initial = 'Initial',
  InitialAutoStretchRate = 'InitialAutoStretchRate',
  OutputGenerated = 'OutputGenerated',
  PreparingSegments = 'PreparingSegments',
  PreparingSegmentsProcessing = 'PreparingSegmentsProcessing',
  ReadyForPostProduction = 'ReadyForPostProduction',
  ReadyForReview = 'ReadyForReview',
  ReadyForRevision = 'ReadyForRevision',
  ReadyForVoiceActing = 'ReadyForVoiceActing',
  ReadyToQa = 'ReadyToQA',
  Retranslating = 'Retranslating'
}

export type TranslatedVideoUpdateInput = {
  addedBy?: InputMaybe<UserUpdateOneInput>;
  asrModel?: InputMaybe<Scalars['String']['input']>;
  audibleOverlaps?: InputMaybe<Scalars['Boolean']['input']>;
  audioEngineer?: InputMaybe<UserUpdateOneInput>;
  audioEngineerDueDate?: InputMaybe<Scalars['DateTime']['input']>;
  availableMLConfigs?: InputMaybe<Scalars['Json']['input']>;
  channelMetadata?: InputMaybe<Scalars['Json']['input']>;
  dueDate?: InputMaybe<Scalars['DateTime']['input']>;
  editor?: InputMaybe<UserUpdateOneInput>;
  editorDueDate?: InputMaybe<Scalars['DateTime']['input']>;
  editorQC?: InputMaybe<UserUpdateOneInput>;
  editorQCDueDate?: InputMaybe<Scalars['DateTime']['input']>;
  featureFlags?: InputMaybe<Scalars['Json']['input']>;
  hasInitialAutoStretchRate?: InputMaybe<Scalars['Boolean']['input']>;
  hasSegmentTextChanged?: InputMaybe<Scalars['Boolean']['input']>;
  isDatamodelV3?: InputMaybe<Scalars['Boolean']['input']>;
  isStudioStagesEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  markedCompleteBy?: InputMaybe<UserUpdateOneInput>;
  metadata?: InputMaybe<Scalars['Json']['input']>;
  notes?: InputMaybe<NoteCreateManyWithoutTranslatedVideoInput>;
  prepareSegmentsMethod?: InputMaybe<PrepareSegmentsMethod>;
  qaer?: InputMaybe<UserUpdateOneInput>;
  qc?: InputMaybe<UserUpdateOneInput>;
  qcDueDate?: InputMaybe<Scalars['DateTime']['input']>;
  requiresAnEditor?: InputMaybe<Scalars['Boolean']['input']>;
  reviewedBy?: InputMaybe<UserUpdateOneInput>;
  s3root?: InputMaybe<Scalars['String']['input']>;
  scriptCsvUploadType?: InputMaybe<ScriptCsvUploadType>;
  shouldAutoGenerateInitialOutput?: InputMaybe<Scalars['Boolean']['input']>;
  shouldTranscribeAudio?: InputMaybe<Scalars['Boolean']['input']>;
  speechEditingQAer?: InputMaybe<UserUpdateOneInput>;
  speechEditingQAerDueDate?: InputMaybe<Scalars['DateTime']['input']>;
  speechEditingQAers?: InputMaybe<UserUpdateManyInput>;
  stateValue?: InputMaybe<TranslatedVideoState>;
  tags?: InputMaybe<TranslatedVideoUpdatetagsInput>;
  targetMinutePerMinute?: InputMaybe<Scalars['Float']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  transcriptionQAer?: InputMaybe<UserUpdateOneInput>;
  transcriptionQAerDueDate?: InputMaybe<Scalars['DateTime']['input']>;
  transcriptionQAers?: InputMaybe<UserUpdateManyInput>;
  translatedDescription?: InputMaybe<Scalars['String']['input']>;
  translatedTitle?: InputMaybe<Scalars['String']['input']>;
  translationQAer?: InputMaybe<UserUpdateOneInput>;
  translationQAerDueDate?: InputMaybe<Scalars['DateTime']['input']>;
  translationQAers?: InputMaybe<UserUpdateManyInput>;
  tvStudioStageState?: InputMaybe<TvStudioStageState>;
  videoComplexityCalculated?: InputMaybe<Scalars['Int']['input']>;
  videoComplexityQA?: InputMaybe<Scalars['Int']['input']>;
  videoComplexityQC?: InputMaybe<Scalars['Int']['input']>;
  voiceActor?: InputMaybe<UserUpdateOneInput>;
  voiceActorDueDate?: InputMaybe<Scalars['DateTime']['input']>;
  voiceActorQC?: InputMaybe<UserUpdateOneInput>;
  voiceActorQCDueDate?: InputMaybe<Scalars['DateTime']['input']>;
  wasMigratedToV3?: InputMaybe<Scalars['Boolean']['input']>;
  workableDurationSec?: InputMaybe<Scalars['Int']['input']>;
};

export type TranslatedVideoUpdatetagsInput = {
  set?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type TranslatedVideoWhereInput = {
  AND?: InputMaybe<Array<TranslatedVideoWhereInput>>;
  NOT?: InputMaybe<Array<TranslatedVideoWhereInput>>;
  OR?: InputMaybe<Array<TranslatedVideoWhereInput>>;
  addedBy?: InputMaybe<TranslatedVideoWhereInput_User>;
  audibleOverlaps?: InputMaybe<Scalars['Boolean']['input']>;
  audioEngineer?: InputMaybe<TranslatedVideoWhereInput_User>;
  channel?: InputMaybe<TranslatedVideoWhereInput_Channel>;
  editor?: InputMaybe<TranslatedVideoWhereInput_User>;
  editorQC?: InputMaybe<TranslatedVideoWhereInput_User>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_not?: InputMaybe<Scalars['ID']['input']>;
  id_not_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  isDatamodelV3?: InputMaybe<Scalars['Boolean']['input']>;
  isStudioStagesEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  markedCompleteBy?: InputMaybe<TranslatedVideoWhereInput_User>;
  qaer?: InputMaybe<TranslatedVideoWhereInput_User>;
  qc?: InputMaybe<TranslatedVideoWhereInput_User>;
  reviewedBy?: InputMaybe<TranslatedVideoWhereInput_User>;
  sourceVideo?: InputMaybe<SourceVideoWhereInput>;
  speechEditingQAer?: InputMaybe<TranslatedVideoWhereInput_User>;
  speechEditingQAers?: InputMaybe<TranslatedVideoWhereInput_User>;
  stateValue?: InputMaybe<TranslatedVideoState>;
  stateValue_in?: InputMaybe<Array<TranslatedVideoState>>;
  stateValue_not?: InputMaybe<TranslatedVideoState>;
  stateValue_not_in?: InputMaybe<Array<TranslatedVideoState>>;
  title?: InputMaybe<Scalars['String']['input']>;
  title_contains?: InputMaybe<Scalars['String']['input']>;
  title_starts_with?: InputMaybe<Scalars['String']['input']>;
  transcriptionQAer?: InputMaybe<TranslatedVideoWhereInput_User>;
  transcriptionQAers?: InputMaybe<TranslatedVideoWhereInput_User>;
  translationQAer?: InputMaybe<TranslatedVideoWhereInput_User>;
  translationQAers?: InputMaybe<TranslatedVideoWhereInput_User>;
  tvStudioStageState?: InputMaybe<TvStudioStageState>;
  tvStudioStageState_in?: InputMaybe<Array<TvStudioStageState>>;
  voiceActor?: InputMaybe<TranslatedVideoWhereInput_User>;
  voiceActorQC?: InputMaybe<TranslatedVideoWhereInput_User>;
};

export type TranslatedVideoWhereInput_Channel = {
  id?: InputMaybe<Scalars['ID']['input']>;
  id_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  language?: InputMaybe<Scalars['String']['input']>;
  language_in?: InputMaybe<Array<Scalars['String']['input']>>;
  sourceChannel?: InputMaybe<TranslatedVideoWhereInput_Channel_SourceChannel>;
};

export type TranslatedVideoWhereInput_Channel_SourceChannel = {
  language_in?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type TranslatedVideoWhereInput_User = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type TranslatedVideoWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type Translation = {
  /** translated channel id */
  channelId: Scalars['String']['input'];
  /** ID of a TranslatedVideo to copy settings from */
  copyFromTvId?: InputMaybe<Scalars['ID']['input']>;
  /** Due date accepted any format that is used by moment: https://momentjs.com/guides/#/parsing/ */
  dueDate?: InputMaybe<Scalars['String']['input']>;
  /** was a target transcript uploaded */
  hasTargetTranscript?: InputMaybe<Scalars['Boolean']['input']>;
  transcriptionType?: InputMaybe<TranscriptionProvider>;
};

export enum TtsSource {
  ElevenLabs = 'ElevenLabs',
  Google = 'Google',
  Microsoft = 'Microsoft',
  OpenAi = 'OpenAI',
  Papercup = 'Papercup'
}

export enum TypicalVideoDuration {
  Long = 'Long',
  Medium = 'Medium',
  Short = 'Short'
}

export type User = {
  __typename?: 'User';
  auth0Id?: Maybe<Scalars['String']['output']>;
  cognitoSub: Scalars['String']['output'];
  cognitoUsername: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  /** Email address */
  email: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  isArchived?: Maybe<Scalars['Boolean']['output']>;
  mimicActorId?: Maybe<Scalars['String']['output']>;
  /** Name */
  name: Scalars['String']['output'];
  nativeLanguage?: Maybe<Scalars['String']['output']>;
  roles?: Maybe<Array<Role>>;
  updatedAt: Scalars['DateTime']['output'];
};


export type UserRolesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<RoleOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<RoleWhereInput>;
};

export type UserCreateInput = {
  auth0Id?: InputMaybe<Scalars['String']['input']>;
  cognitoSub: Scalars['String']['input'];
  cognitoUsername: Scalars['String']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  isArchived?: InputMaybe<Scalars['Boolean']['input']>;
  mimicActorId?: InputMaybe<Scalars['String']['input']>;
  nativeLanguage?: InputMaybe<Scalars['String']['input']>;
  roles?: InputMaybe<RoleCreateManyInput>;
};

export type UserCreateOneInput = {
  connect?: InputMaybe<UserWhereUniqueInput>;
};

export enum UserOrderByInput {
  Auth0IdAsc = 'auth0Id_ASC',
  Auth0IdDesc = 'auth0Id_DESC',
  CognitoSubAsc = 'cognitoSub_ASC',
  CognitoSubDesc = 'cognitoSub_DESC',
  CognitoUsernameAsc = 'cognitoUsername_ASC',
  CognitoUsernameDesc = 'cognitoUsername_DESC',
  CreatedAtAsc = 'createdAt_ASC',
  CreatedAtDesc = 'createdAt_DESC',
  DescriptionAsc = 'description_ASC',
  DescriptionDesc = 'description_DESC',
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  IsArchivedAsc = 'isArchived_ASC',
  IsArchivedDesc = 'isArchived_DESC',
  MimicActorIdAsc = 'mimicActorId_ASC',
  MimicActorIdDesc = 'mimicActorId_DESC',
  NativeLanguageAsc = 'nativeLanguage_ASC',
  NativeLanguageDesc = 'nativeLanguage_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC'
}

export enum UserRole {
  Admin = 'Admin',
  AudioEngineer = 'AudioEngineer',
  CastEditor = 'CastEditor',
  ChannelManager = 'ChannelManager',
  ChannelOwner = 'ChannelOwner',
  Editor = 'Editor',
  EditorQc = 'EditorQC',
  QAer = 'QAer',
  Qc = 'QC',
  SpeechEditingQAer = 'SpeechEditingQAer',
  SuperUser = 'SuperUser',
  TranscriptionQAer = 'TranscriptionQAer',
  TranslationQAer = 'TranslationQAer',
  Unknown = 'Unknown',
  VoiceActor = 'VoiceActor',
  VoiceActorQc = 'VoiceActorQC'
}

export type UserUpdateInput = {
  auth0Id?: InputMaybe<Scalars['String']['input']>;
  cognitoSub?: InputMaybe<Scalars['String']['input']>;
  cognitoUsername?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  isArchived?: InputMaybe<Scalars['Boolean']['input']>;
  mimicActorId?: InputMaybe<Scalars['String']['input']>;
  nativeLanguage?: InputMaybe<Scalars['String']['input']>;
  roles?: InputMaybe<RoleUpdateManyInput>;
};

export type UserUpdateManyInput = {
  set?: InputMaybe<Array<UserWhereUniqueInput>>;
};

export type UserUpdateOneInput = {
  connect?: InputMaybe<UserWhereUniqueInput>;
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UserWhereInput = {
  AND?: InputMaybe<Array<UserWhereInput>>;
  NOT?: InputMaybe<Array<UserWhereInput>>;
  OR?: InputMaybe<Array<UserWhereInput>>;
  auth0Id?: InputMaybe<Scalars['String']['input']>;
  auth0Id_contains?: InputMaybe<Scalars['String']['input']>;
  auth0Id_ends_with?: InputMaybe<Scalars['String']['input']>;
  auth0Id_gt?: InputMaybe<Scalars['String']['input']>;
  auth0Id_gte?: InputMaybe<Scalars['String']['input']>;
  auth0Id_in?: InputMaybe<Array<Scalars['String']['input']>>;
  auth0Id_lt?: InputMaybe<Scalars['String']['input']>;
  auth0Id_lte?: InputMaybe<Scalars['String']['input']>;
  auth0Id_not?: InputMaybe<Scalars['String']['input']>;
  auth0Id_not_contains?: InputMaybe<Scalars['String']['input']>;
  auth0Id_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  auth0Id_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  auth0Id_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  auth0Id_starts_with?: InputMaybe<Scalars['String']['input']>;
  cognitoSub?: InputMaybe<Scalars['String']['input']>;
  cognitoSub_contains?: InputMaybe<Scalars['String']['input']>;
  cognitoSub_ends_with?: InputMaybe<Scalars['String']['input']>;
  cognitoSub_gt?: InputMaybe<Scalars['String']['input']>;
  cognitoSub_gte?: InputMaybe<Scalars['String']['input']>;
  cognitoSub_in?: InputMaybe<Array<Scalars['String']['input']>>;
  cognitoSub_lt?: InputMaybe<Scalars['String']['input']>;
  cognitoSub_lte?: InputMaybe<Scalars['String']['input']>;
  cognitoSub_not?: InputMaybe<Scalars['String']['input']>;
  cognitoSub_not_contains?: InputMaybe<Scalars['String']['input']>;
  cognitoSub_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  cognitoSub_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  cognitoSub_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  cognitoSub_starts_with?: InputMaybe<Scalars['String']['input']>;
  cognitoUsername?: InputMaybe<Scalars['String']['input']>;
  cognitoUsername_contains?: InputMaybe<Scalars['String']['input']>;
  cognitoUsername_ends_with?: InputMaybe<Scalars['String']['input']>;
  cognitoUsername_gt?: InputMaybe<Scalars['String']['input']>;
  cognitoUsername_gte?: InputMaybe<Scalars['String']['input']>;
  cognitoUsername_in?: InputMaybe<Array<Scalars['String']['input']>>;
  cognitoUsername_lt?: InputMaybe<Scalars['String']['input']>;
  cognitoUsername_lte?: InputMaybe<Scalars['String']['input']>;
  cognitoUsername_not?: InputMaybe<Scalars['String']['input']>;
  cognitoUsername_not_contains?: InputMaybe<Scalars['String']['input']>;
  cognitoUsername_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  cognitoUsername_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  cognitoUsername_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  cognitoUsername_starts_with?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_not_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  description?: InputMaybe<Scalars['String']['input']>;
  description_contains?: InputMaybe<Scalars['String']['input']>;
  description_ends_with?: InputMaybe<Scalars['String']['input']>;
  description_gt?: InputMaybe<Scalars['String']['input']>;
  description_gte?: InputMaybe<Scalars['String']['input']>;
  description_in?: InputMaybe<Array<Scalars['String']['input']>>;
  description_lt?: InputMaybe<Scalars['String']['input']>;
  description_lte?: InputMaybe<Scalars['String']['input']>;
  description_not?: InputMaybe<Scalars['String']['input']>;
  description_not_contains?: InputMaybe<Scalars['String']['input']>;
  description_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  description_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  description_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  description_starts_with?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  id_gt?: InputMaybe<Scalars['ID']['input']>;
  id_gte?: InputMaybe<Scalars['ID']['input']>;
  id_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_lt?: InputMaybe<Scalars['ID']['input']>;
  id_lte?: InputMaybe<Scalars['ID']['input']>;
  id_not?: InputMaybe<Scalars['ID']['input']>;
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  id_not_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  isArchived?: InputMaybe<Scalars['Boolean']['input']>;
  isArchived_not?: InputMaybe<Scalars['Boolean']['input']>;
  mimicActorId?: InputMaybe<Scalars['String']['input']>;
  mimicActorId_contains?: InputMaybe<Scalars['String']['input']>;
  mimicActorId_ends_with?: InputMaybe<Scalars['String']['input']>;
  mimicActorId_gt?: InputMaybe<Scalars['String']['input']>;
  mimicActorId_gte?: InputMaybe<Scalars['String']['input']>;
  mimicActorId_in?: InputMaybe<Array<Scalars['String']['input']>>;
  mimicActorId_lt?: InputMaybe<Scalars['String']['input']>;
  mimicActorId_lte?: InputMaybe<Scalars['String']['input']>;
  mimicActorId_not?: InputMaybe<Scalars['String']['input']>;
  mimicActorId_not_contains?: InputMaybe<Scalars['String']['input']>;
  mimicActorId_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  mimicActorId_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  mimicActorId_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  mimicActorId_starts_with?: InputMaybe<Scalars['String']['input']>;
  nativeLanguage?: InputMaybe<Scalars['String']['input']>;
  nativeLanguage_contains?: InputMaybe<Scalars['String']['input']>;
  nativeLanguage_ends_with?: InputMaybe<Scalars['String']['input']>;
  nativeLanguage_gt?: InputMaybe<Scalars['String']['input']>;
  nativeLanguage_gte?: InputMaybe<Scalars['String']['input']>;
  nativeLanguage_in?: InputMaybe<Array<Scalars['String']['input']>>;
  nativeLanguage_lt?: InputMaybe<Scalars['String']['input']>;
  nativeLanguage_lte?: InputMaybe<Scalars['String']['input']>;
  nativeLanguage_not?: InputMaybe<Scalars['String']['input']>;
  nativeLanguage_not_contains?: InputMaybe<Scalars['String']['input']>;
  nativeLanguage_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  nativeLanguage_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  nativeLanguage_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  nativeLanguage_starts_with?: InputMaybe<Scalars['String']['input']>;
  roles_every?: InputMaybe<RoleWhereInput>;
  roles_none?: InputMaybe<RoleWhereInput>;
  roles_some?: InputMaybe<RoleWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_not_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
};

export type UserWhereUniqueInput = {
  auth0Id?: InputMaybe<Scalars['String']['input']>;
  cognitoSub?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type VideoComplexityRating = {
  __typename?: 'VideoComplexityRating';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  maxRating: Scalars['Int']['output'];
  minRating: Scalars['Int']['output'];
  qaer: User;
  rating: Scalars['Int']['output'];
  reason: Scalars['String']['output'];
  reviewerRole: ReviewerRole;
  translatedVideo: TranslatedVideo;
  updatedAt: Scalars['DateTime']['output'];
};

export type VideoComplexityRatingInput = {
  rating: Scalars['Int']['input'];
  reason: Scalars['String']['input'];
};

/** Video Properties from ffprobe. */
export type VideoProperties = {
  __typename?: 'VideoProperties';
  /** Average frame rate. total duration / total # of frame */
  avg_frame_rate: Scalars['String']['output'];
  /** Returns a long representation of the stream codec. */
  codec_long_name: Scalars['String']['output'];
  /** Returns a string representation of the stream codec. */
  codec_name: Scalars['String']['output'];
  /** Returns a short representative tag of the stream codec. */
  codec_tag_string: Scalars['String']['output'];
  codec_type: Scalars['String']['output'];
  coded_height: Scalars['Int']['output'];
  coded_width: Scalars['Int']['output'];
  display_aspect_ratio: Scalars['String']['output'];
  duration: Scalars['String']['output'];
  duration_ts: Scalars['Int']['output'];
  height: Scalars['Int']['output'];
  nb_frames: Scalars['String']['output'];
  /**
   * Real base framerate of the stream.
   *
   * This is the lowest framerate with which all timestamps can be represented accurately (it is the least common multiple of all framerates in the stream). Note, this value is just a guess! For example, if the time base is 1/90000 and all frames have either approximately 3600 or 1800 timer ticks, then r_frame_rate will be 50/1.
   */
  r_frame_rate: Scalars['String']['output'];
  sample_aspect_ratio: Scalars['String']['output'];
  width: Scalars['Int']['output'];
};

export enum VideoSnapshotType {
  InitialSegments = 'InitialSegments',
  PostInitialAutoStretch = 'PostInitialAutoStretch',
  PostStickyNotes = 'PostStickyNotes',
  Test = 'Test'
}

export type VocoderOutput = {
  __typename?: 'VocoderOutput';
  audioFile?: Maybe<File>;
  createdAt: Scalars['DateTime']['output'];
  effectUnits: Array<EffectUnit>;
  failureMessage?: Maybe<Scalars['String']['output']>;
  featuresData: FeaturesData;
  generatingPriority: Scalars['Float']['output'];
  id: Scalars['ID']['output'];
  inputsHash: Scalars['String']['output'];
  modelName?: Maybe<Scalars['String']['output']>;
  processingDurationMs?: Maybe<Scalars['Float']['output']>;
  processingEndTime?: Maybe<Scalars['DateTime']['output']>;
  processingStartTime?: Maybe<Scalars['DateTime']['output']>;
  speechOutputs?: Maybe<Array<SpeechOutput>>;
  stateEnum: GeneratingState;
  updatedAt: Scalars['DateTime']['output'];
  vocoderType: VocoderType;
};

export enum VocoderType {
  PreviewVoice = 'PreviewVoice',
  TunedVoice = 'TunedVoice'
}

// added by post-generation script
export type Characteristic = {
  key: Scalars["String"]["output"];
  value: Scalars["String"]["output"];
};

export type Voice = {
  __typename?: 'Voice';
  age?: Maybe<Scalars['Int']['output']>;
  createdAt: Scalars['DateTime']['output'];
  gender: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  isDatamodelV3: Scalars['Boolean']['output'];
  language: Scalars['String']['output'];
  phonemizationVersion?: Maybe<Scalars['String']['output']>;
  phonemizedText: Array<Scalars['Int']['output']>;
  samples: Array<Sample>;
  speakerId: Scalars['String']['output'];
  speechOutputs: Array<SpeechOutput>;
  /** Stage of life based on age */
  stageOfLife: Scalars['String']['output'];
  state: Scalars['Json']['output'];
  stateValue: VoiceState;
  styles: Array<Scalars['String']['output']>;
  text: Scalars['String']['output'];
  ttsSourceEnum: TtsSource;
  updatedAt: Scalars['DateTime']['output'];
  voiceConversionMethod: VoiceConversionMethod;
// added by post-generation script
  characteristics: Array<Characteristic>;
  name: Scalars["String"]["output"];
  style: Scalars["String"]["output"];
  source: Scalars["String"]["output"];
};

export enum VoiceConversionMethod {
  None = 'None',
  Rvc = 'RVC',
  ZeroShot = 'ZeroShot'
}

export enum VoiceConversionTypeEnum {
  Advc = 'ADVC',
  Tdvc = 'TDVC'
}

export type VoiceCreateInput = {
  age?: InputMaybe<Scalars['Int']['input']>;
  gender: Scalars['String']['input'];
  id?: InputMaybe<Scalars['ID']['input']>;
  isDatamodelV3?: InputMaybe<Scalars['Boolean']['input']>;
  language: Scalars['String']['input'];
  phonemizationVersion?: InputMaybe<Scalars['String']['input']>;
  speakerId: Scalars['String']['input'];
  state?: InputMaybe<Scalars['Json']['input']>;
  stateValue?: InputMaybe<VoiceState>;
  styles?: InputMaybe<VoiceCreatestylesInput>;
  text: Scalars['String']['input'];
  ttsSourceEnum?: InputMaybe<TtsSource>;
  voiceConversionMethod?: InputMaybe<VoiceConversionMethod>;
};

export type VoiceCreatestylesInput = {
  set?: InputMaybe<Array<Scalars['String']['input']>>;
};

export enum VoiceOrderByInput {
  AgeAsc = 'age_ASC',
  AgeDesc = 'age_DESC',
  CreatedAtAsc = 'createdAt_ASC',
  CreatedAtDesc = 'createdAt_DESC',
  GenderAsc = 'gender_ASC',
  GenderDesc = 'gender_DESC',
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  IsDatamodelV3Asc = 'isDatamodelV3_ASC',
  IsDatamodelV3Desc = 'isDatamodelV3_DESC',
  LanguageAsc = 'language_ASC',
  LanguageDesc = 'language_DESC',
  PhonemizationVersionAsc = 'phonemizationVersion_ASC',
  PhonemizationVersionDesc = 'phonemizationVersion_DESC',
  SpeakerIdAsc = 'speakerId_ASC',
  SpeakerIdDesc = 'speakerId_DESC',
  StateValueAsc = 'stateValue_ASC',
  StateValueDesc = 'stateValue_DESC',
  StateAsc = 'state_ASC',
  StateDesc = 'state_DESC',
  TextAsc = 'text_ASC',
  TextDesc = 'text_DESC',
  TtsSourceEnumAsc = 'ttsSourceEnum_ASC',
  TtsSourceEnumDesc = 'ttsSourceEnum_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC',
  VoiceConversionMethodAsc = 'voiceConversionMethod_ASC',
  VoiceConversionMethodDesc = 'voiceConversionMethod_DESC'
}

export enum VoiceState {
  Complete = 'Complete',
  GeneratingPhones = 'GeneratingPhones',
  Initial = 'Initial'
}

export type VoiceUpdateOneRequiredInput = {
  connect?: InputMaybe<VoiceWhereUniqueInput>;
  create?: InputMaybe<VoiceCreateInput>;
};

export type VoiceWhereInput = {
  AND?: InputMaybe<Array<VoiceWhereInput>>;
  NOT?: InputMaybe<Array<VoiceWhereInput>>;
  OR?: InputMaybe<Array<VoiceWhereInput>>;
  age?: InputMaybe<Scalars['Int']['input']>;
  age_gt?: InputMaybe<Scalars['Int']['input']>;
  age_gte?: InputMaybe<Scalars['Int']['input']>;
  age_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  age_lt?: InputMaybe<Scalars['Int']['input']>;
  age_lte?: InputMaybe<Scalars['Int']['input']>;
  age_not?: InputMaybe<Scalars['Int']['input']>;
  age_not_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  gender?: InputMaybe<Scalars['String']['input']>;
  gender_contains?: InputMaybe<Scalars['String']['input']>;
  gender_in?: InputMaybe<Array<Scalars['String']['input']>>;
  gender_not?: InputMaybe<Scalars['String']['input']>;
  gender_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  gender_starts_with?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_not?: InputMaybe<Scalars['ID']['input']>;
  id_not_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  isDatamodelV3?: InputMaybe<Scalars['Boolean']['input']>;
  isDatamodelV3_not?: InputMaybe<Scalars['Boolean']['input']>;
  language?: InputMaybe<Scalars['String']['input']>;
  language_contains?: InputMaybe<Scalars['String']['input']>;
  language_in?: InputMaybe<Array<Scalars['String']['input']>>;
  language_not?: InputMaybe<Scalars['String']['input']>;
  language_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  language_starts_with?: InputMaybe<Scalars['String']['input']>;
  samples_every?: InputMaybe<SampleWhereInput>;
  samples_none?: InputMaybe<SampleWhereInput>;
  samples_some?: InputMaybe<SampleWhereInput>;
  speakerId?: InputMaybe<Scalars['String']['input']>;
  speakerId_contains?: InputMaybe<Scalars['String']['input']>;
  speakerId_in?: InputMaybe<Array<Scalars['String']['input']>>;
  speakerId_not?: InputMaybe<Scalars['String']['input']>;
  speakerId_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  speakerId_starts_with?: InputMaybe<Scalars['String']['input']>;
  speechOutputs_every?: InputMaybe<SpeechOutputWhereInput>;
  speechOutputs_none?: InputMaybe<SpeechOutputWhereInput>;
  speechOutputs_some?: InputMaybe<SpeechOutputWhereInput>;
  stateValue?: InputMaybe<VoiceState>;
  stateValue_in?: InputMaybe<Array<VoiceState>>;
  stateValue_not?: InputMaybe<VoiceState>;
  stateValue_not_in?: InputMaybe<Array<VoiceState>>;
  text?: InputMaybe<Scalars['String']['input']>;
  text_contains?: InputMaybe<Scalars['String']['input']>;
  text_in?: InputMaybe<Array<Scalars['String']['input']>>;
  text_not?: InputMaybe<Scalars['String']['input']>;
  text_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  text_starts_with?: InputMaybe<Scalars['String']['input']>;
  ttsSourceEnum?: InputMaybe<TtsSource>;
  ttsSourceEnum_in?: InputMaybe<Array<TtsSource>>;
  ttsSourceEnum_not?: InputMaybe<TtsSource>;
  ttsSourceEnum_not_in?: InputMaybe<Array<TtsSource>>;
  voiceConversionMethod?: InputMaybe<VoiceConversionMethod>;
  voiceConversionMethod_in?: InputMaybe<Array<VoiceConversionMethod>>;
  voiceConversionMethod_not?: InputMaybe<VoiceConversionMethod>;
  voiceConversionMethod_not_in?: InputMaybe<Array<VoiceConversionMethod>>;
};

export type VoiceWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  speakerId?: InputMaybe<Scalars['String']['input']>;
};
